//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const ApiBaseUrl = new InjectionToken<string>('ApiBaseUrl');

@Injectable({
    providedIn: 'root'
})
export class AdoptionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    sendCaseAdoptionEmail(donorId?: number | undefined, caseIds?: number[] | null | undefined, file?: FileParameter[] | null | undefined): Observable<SendCaseAdoptionResponse> {
        let url_ = this.baseUrl + "/Adoption/SendCaseAdoptionEmail?";
        if (donorId === null)
            throw new Error("The parameter 'donorId' cannot be null.");
        else if (donorId !== undefined)
            url_ += "donorId=" + encodeURIComponent("" + donorId) + "&";
        if (caseIds !== undefined && caseIds !== null)
            caseIds && caseIds.forEach(item => { url_ += "caseIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            file.forEach(item_ => content_.append("file", item_.data, item_.fileName ? item_.fileName : "file") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendCaseAdoptionEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendCaseAdoptionEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendCaseAdoptionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendCaseAdoptionResponse>;
        }));
    }

    protected processSendCaseAdoptionEmail(response: HttpResponseBase): Observable<SendCaseAdoptionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendCaseAdoptionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendCaseAdoptionResponse>(null as any);
    }

    updateCaseAndAdoptionStatus(request: UpdateCaseAndAdoptionStatusRequest): Observable<void> {
        let url_ = this.baseUrl + "/Adoption/UpdateCaseAndAdoptionStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaseAndAdoptionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaseAndAdoptionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCaseAndAdoptionStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getAdoptionStatus(caseId?: number | undefined): Observable<GetAdoptionStatusResponse> {
        let url_ = this.baseUrl + "/Adoption/GetAdoptionStatus?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdoptionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdoptionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdoptionStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdoptionStatusResponse>;
        }));
    }

    protected processGetAdoptionStatus(response: HttpResponseBase): Observable<GetAdoptionStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdoptionStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAdoptionStatusResponse>(null as any);
    }

    getDonorAdoptions(donorId?: number | undefined): Observable<GetDonorAdoptionsResponse> {
        let url_ = this.baseUrl + "/Adoption/GetDonorAdoptions?";
        if (donorId === null)
            throw new Error("The parameter 'donorId' cannot be null.");
        else if (donorId !== undefined)
            url_ += "donorId=" + encodeURIComponent("" + donorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDonorAdoptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDonorAdoptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDonorAdoptionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDonorAdoptionsResponse>;
        }));
    }

    protected processGetDonorAdoptions(response: HttpResponseBase): Observable<GetDonorAdoptionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDonorAdoptionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDonorAdoptionsResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AgencyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    get(agencyNumber: number): Observable<GetAgencyResponse> {
        let url_ = this.baseUrl + "/Agency/{agencyNumber}";
        if (agencyNumber === undefined || agencyNumber === null)
            throw new Error("The parameter 'agencyNumber' must be defined.");
        url_ = url_.replace("{agencyNumber}", encodeURIComponent("" + agencyNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAgencyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAgencyResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetAgencyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAgencyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAgencyResponse>(null as any);
    }

    getUsers(agencyIds?: number[] | null | undefined): Observable<GetAgencyUsersResponse> {
        let url_ = this.baseUrl + "/Agency/GetUsers?";
        if (agencyIds !== undefined && agencyIds !== null)
            agencyIds && agencyIds.forEach(item => { url_ += "agencyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAgencyUsersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAgencyUsersResponse>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<GetAgencyUsersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAgencyUsersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAgencyUsersResponse>(null as any);
    }

    getAll(request: GetAgenciesRequest): Observable<GetAgenciesResponse> {
        let url_ = this.baseUrl + "/Agency/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAgenciesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAgenciesResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetAgenciesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAgenciesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAgenciesResponse>(null as any);
    }

    add(request: AddAgencyRequest): Observable<AddAgencyResponse> {
        let url_ = this.baseUrl + "/Agency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAgencyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAgencyResponse>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<AddAgencyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddAgencyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddAgencyResponse>(null as any);
    }

    search(request: SearchAgenciesRequest): Observable<SearchAgenciesResponse> {
        let url_ = this.baseUrl + "/Agency/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchAgenciesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchAgenciesResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchAgenciesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchAgenciesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchAgenciesResponse>(null as any);
    }

    getPrimaryContact(agencyId?: number | undefined): Observable<GetPrimaryContactResponse> {
        let url_ = this.baseUrl + "/Agency/GetPrimaryContact?";
        if (agencyId === null)
            throw new Error("The parameter 'agencyId' cannot be null.");
        else if (agencyId !== undefined)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrimaryContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrimaryContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPrimaryContactResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPrimaryContactResponse>;
        }));
    }

    protected processGetPrimaryContact(response: HttpResponseBase): Observable<GetPrimaryContactResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPrimaryContactResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPrimaryContactResponse>(null as any);
    }

    update(request: UpdateAgencyRequest): Observable<UpdateAgencyResponse> {
        let url_ = this.baseUrl + "/Agency/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateAgencyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateAgencyResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateAgencyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAgencyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateAgencyResponse>(null as any);
    }

    updateActiveStatus(request: ChangeActiveStatusRequest): Observable<ChangeActiveStatusResponse> {
        let url_ = this.baseUrl + "/Agency/UpdateActiveStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActiveStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActiveStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeActiveStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeActiveStatusResponse>;
        }));
    }

    protected processUpdateActiveStatus(response: HttpResponseBase): Observable<ChangeActiveStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeActiveStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChangeActiveStatusResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AllocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    get(id: number): Observable<GetAllocationResponse> {
        let url_ = this.baseUrl + "/Allocation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllocationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllocationResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetAllocationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllocationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllocationResponse>(null as any);
    }

    getAllocations(campaignId?: number | null | undefined): Observable<GetAllocationsResponse> {
        let url_ = this.baseUrl + "/Allocation/GetAllocations?";
        if (campaignId !== undefined && campaignId !== null)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllocationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllocationsResponse>;
        }));
    }

    protected processGetAllocations(response: HttpResponseBase): Observable<GetAllocationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllocationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllocationsResponse>(null as any);
    }

    add(request: AddAllocationRequest): Observable<AddAllocationResponse> {
        let url_ = this.baseUrl + "/Allocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAllocationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAllocationResponse>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<AddAllocationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddAllocationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddAllocationResponse>(null as any);
    }

    getDistributeAllocationPreview(allocationType?: AllocationType | undefined): Observable<GetDistributeAllocationPreviewResponse> {
        let url_ = this.baseUrl + "/Allocation/GetDistributeAllocationPreview?";
        if (allocationType === null)
            throw new Error("The parameter 'allocationType' cannot be null.");
        else if (allocationType !== undefined)
            url_ += "allocationType=" + encodeURIComponent("" + allocationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistributeAllocationPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistributeAllocationPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDistributeAllocationPreviewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDistributeAllocationPreviewResponse>;
        }));
    }

    protected processGetDistributeAllocationPreview(response: HttpResponseBase): Observable<GetDistributeAllocationPreviewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDistributeAllocationPreviewResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDistributeAllocationPreviewResponse>(null as any);
    }

    distributeAllocation(type?: AllocationType | undefined, deadlineDate?: Date | undefined): Observable<DistributeAllocationsResponse> {
        let url_ = this.baseUrl + "/Allocation/DistributeAllocation?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (deadlineDate === null)
            throw new Error("The parameter 'deadlineDate' cannot be null.");
        else if (deadlineDate !== undefined)
            url_ += "deadlineDate=" + encodeURIComponent(deadlineDate ? "" + deadlineDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDistributeAllocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDistributeAllocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DistributeAllocationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DistributeAllocationsResponse>;
        }));
    }

    protected processDistributeAllocation(response: HttpResponseBase): Observable<DistributeAllocationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistributeAllocationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DistributeAllocationsResponse>(null as any);
    }

    getDistributedStatus(allocationType?: AllocationType | undefined): Observable<GetAllocationDistributedStatusResponse> {
        let url_ = this.baseUrl + "/Allocation/GetDistributedStatus?";
        if (allocationType === null)
            throw new Error("The parameter 'allocationType' cannot be null.");
        else if (allocationType !== undefined)
            url_ += "allocationType=" + encodeURIComponent("" + allocationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistributedStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistributedStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllocationDistributedStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllocationDistributedStatusResponse>;
        }));
    }

    protected processGetDistributedStatus(response: HttpResponseBase): Observable<GetAllocationDistributedStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllocationDistributedStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllocationDistributedStatusResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AllocatorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    getAll(assignedOnly?: boolean | null | undefined): Observable<GetAllocatorsResponse> {
        let url_ = this.baseUrl + "/Allocator?";
        if (assignedOnly !== undefined && assignedOnly !== null)
            url_ += "assignedOnly=" + encodeURIComponent("" + assignedOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllocatorsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllocatorsResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetAllocatorsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllocatorsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllocatorsResponse>(null as any);
    }

    getOverview(): Observable<GetAllocatorsOverviewResponse> {
        let url_ = this.baseUrl + "/Allocator/GetOverview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllocatorsOverviewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllocatorsOverviewResponse>;
        }));
    }

    protected processGetOverview(response: HttpResponseBase): Observable<GetAllocatorsOverviewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllocatorsOverviewResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllocatorsOverviewResponse>(null as any);
    }

    getWorkingSummary(allocatorId?: number | null | undefined): Observable<GetAllocatorWorkingSummaryResponse> {
        let url_ = this.baseUrl + "/Allocator/GetWorkingSummary?";
        if (allocatorId !== undefined && allocatorId !== null)
            url_ += "allocatorId=" + encodeURIComponent("" + allocatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkingSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkingSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllocatorWorkingSummaryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllocatorWorkingSummaryResponse>;
        }));
    }

    protected processGetWorkingSummary(response: HttpResponseBase): Observable<GetAllocatorWorkingSummaryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllocatorWorkingSummaryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllocatorWorkingSummaryResponse>(null as any);
    }

    getDistributionThresholds(): Observable<GetDistributionThresholdsResponse> {
        let url_ = this.baseUrl + "/Allocator/GetDistributionThresholds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistributionThresholds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistributionThresholds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDistributionThresholdsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDistributionThresholdsResponse>;
        }));
    }

    protected processGetDistributionThresholds(response: HttpResponseBase): Observable<GetDistributionThresholdsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDistributionThresholdsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDistributionThresholdsResponse>(null as any);
    }

    updateDistributionThresholds(minimumDistribution?: number | undefined, maximumDistribution?: number | undefined): Observable<UpdateDistributionThresholdsResponse> {
        let url_ = this.baseUrl + "/Allocator/UpdateDistributionThresholds?";
        if (minimumDistribution === null)
            throw new Error("The parameter 'minimumDistribution' cannot be null.");
        else if (minimumDistribution !== undefined)
            url_ += "minimumDistribution=" + encodeURIComponent("" + minimumDistribution) + "&";
        if (maximumDistribution === null)
            throw new Error("The parameter 'maximumDistribution' cannot be null.");
        else if (maximumDistribution !== undefined)
            url_ += "maximumDistribution=" + encodeURIComponent("" + maximumDistribution) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDistributionThresholds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDistributionThresholds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateDistributionThresholdsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateDistributionThresholdsResponse>;
        }));
    }

    protected processUpdateDistributionThresholds(response: HttpResponseBase): Observable<UpdateDistributionThresholdsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateDistributionThresholdsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateDistributionThresholdsResponse>(null as any);
    }

    getCaseAllocations(allocatorId?: number | null | undefined): Observable<GetCaseAllocationsResponse> {
        let url_ = this.baseUrl + "/Allocator/GetCaseAllocations?";
        if (allocatorId !== undefined && allocatorId !== null)
            url_ += "allocatorId=" + encodeURIComponent("" + allocatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseAllocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseAllocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCaseAllocationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCaseAllocationsResponse>;
        }));
    }

    protected processGetCaseAllocations(response: HttpResponseBase): Observable<GetCaseAllocationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCaseAllocationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCaseAllocationsResponse>(null as any);
    }

    updateCaseAllocations(request: UpdateCaseAllocationsRequest): Observable<UpdateCaseAllocationsResponse> {
        let url_ = this.baseUrl + "/Allocator/UpdateCaseAllocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaseAllocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaseAllocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateCaseAllocationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateCaseAllocationsResponse>;
        }));
    }

    protected processUpdateCaseAllocations(response: HttpResponseBase): Observable<UpdateCaseAllocationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCaseAllocationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCaseAllocationsResponse>(null as any);
    }

    getAllocatorCompletions(allocatorId?: number | null | undefined): Observable<GetAllocatorCompletionsResponse> {
        let url_ = this.baseUrl + "/Allocator/GetAllocatorCompletions?";
        if (allocatorId !== undefined && allocatorId !== null)
            url_ += "allocatorId=" + encodeURIComponent("" + allocatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllocatorCompletions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllocatorCompletions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllocatorCompletionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllocatorCompletionsResponse>;
        }));
    }

    protected processGetAllocatorCompletions(response: HttpResponseBase): Observable<GetAllocatorCompletionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllocatorCompletionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllocatorCompletionsResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CampaignClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    get(campaignId: number): Observable<GetCampaignResponse> {
        let url_ = this.baseUrl + "/Campaign/{campaignId}";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCampaignResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCampaignResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetCampaignResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCampaignResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCampaignResponse>(null as any);
    }

    getCurrentCampaign(): Observable<GetCurrentCampaignResponse> {
        let url_ = this.baseUrl + "/Campaign/GetCurrentCampaign";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentCampaign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentCampaignResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentCampaignResponse>;
        }));
    }

    protected processGetCurrentCampaign(response: HttpResponseBase): Observable<GetCurrentCampaignResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentCampaignResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentCampaignResponse>(null as any);
    }

    add(request: AddCampaignRequest): Observable<AddCampaignResponse> {
        let url_ = this.baseUrl + "/Campaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddCampaignResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddCampaignResponse>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<AddCampaignResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddCampaignResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCampaignResponse>(null as any);
    }

    updateCampaignFrozenState(isFrozen?: boolean | undefined, campaignId?: number | null | undefined): Observable<UpdateCampaignFrozenStateResponse> {
        let url_ = this.baseUrl + "/Campaign/UpdateCampaignFrozenState?";
        if (isFrozen === null)
            throw new Error("The parameter 'isFrozen' cannot be null.");
        else if (isFrozen !== undefined)
            url_ += "isFrozen=" + encodeURIComponent("" + isFrozen) + "&";
        if (campaignId !== undefined && campaignId !== null)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCampaignFrozenState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCampaignFrozenState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateCampaignFrozenStateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateCampaignFrozenStateResponse>;
        }));
    }

    protected processUpdateCampaignFrozenState(response: HttpResponseBase): Observable<UpdateCampaignFrozenStateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCampaignFrozenStateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCampaignFrozenStateResponse>(null as any);
    }

    getCampaignFrozenState(campaignId?: number | null | undefined): Observable<GetCampaignFrozenStateResponse> {
        let url_ = this.baseUrl + "/Campaign/GetCampaignFrozenState?";
        if (campaignId !== undefined && campaignId !== null)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaignFrozenState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignFrozenState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCampaignFrozenStateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCampaignFrozenStateResponse>;
        }));
    }

    protected processGetCampaignFrozenState(response: HttpResponseBase): Observable<GetCampaignFrozenStateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCampaignFrozenStateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCampaignFrozenStateResponse>(null as any);
    }

    getPreviousYearCampaign(): Observable<GetPreviousCampaignResponse> {
        let url_ = this.baseUrl + "/Campaign/GetPreviousYearCampaign";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreviousYearCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreviousYearCampaign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPreviousCampaignResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPreviousCampaignResponse>;
        }));
    }

    protected processGetPreviousYearCampaign(response: HttpResponseBase): Observable<GetPreviousCampaignResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPreviousCampaignResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPreviousCampaignResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CaseClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    get(caseNumber?: string | null | undefined): Observable<GetCaseResponse> {
        let url_ = this.baseUrl + "/Case?";
        if (caseNumber !== undefined && caseNumber !== null)
            url_ += "caseNumber=" + encodeURIComponent("" + caseNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCaseResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetCaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCaseResponse>(null as any);
    }

    add(request: AddCaseRequest): Observable<GetCaseResponse> {
        let url_ = this.baseUrl + "/Case";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCaseResponse>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<GetCaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCaseResponse>(null as any);
    }

    update(request: UpdateCaseRequest): Observable<GetCaseResponse> {
        let url_ = this.baseUrl + "/Case";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCaseResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<GetCaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCaseResponse>(null as any);
    }

    delete(caseViewModel: CaseViewModel): Observable<void> {
        let url_ = this.baseUrl + "/Case";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(caseViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getMany(ids?: number[] | null | undefined): Observable<GetCasesResponse> {
        let url_ = this.baseUrl + "/Case/GetMany?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCasesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCasesResponse>;
        }));
    }

    protected processGetMany(response: HttpResponseBase): Observable<GetCasesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCasesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCasesResponse>(null as any);
    }

    getById(id?: number | undefined): Observable<GetCaseResponse> {
        let url_ = this.baseUrl + "/Case/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCaseResponse>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetCaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCaseResponse>(null as any);
    }

    getNextCaseId(): Observable<GetNextCaseIdResponse> {
        let url_ = this.baseUrl + "/Case/GetNextCaseId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextCaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextCaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNextCaseIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNextCaseIdResponse>;
        }));
    }

    protected processGetNextCaseId(response: HttpResponseBase): Observable<GetNextCaseIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNextCaseIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNextCaseIdResponse>(null as any);
    }

    getCasesCount(): Observable<GetCasesCountResponse> {
        let url_ = this.baseUrl + "/Case/GetCasesCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCasesCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCasesCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCasesCountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCasesCountResponse>;
        }));
    }

    protected processGetCasesCount(response: HttpResponseBase): Observable<GetCasesCountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCasesCountResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCasesCountResponse>(null as any);
    }

    getPostDispatchCases(): Observable<GetPostDispatchCasesResponse> {
        let url_ = this.baseUrl + "/Case/GetPostDispatchCases";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostDispatchCases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostDispatchCases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPostDispatchCasesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPostDispatchCasesResponse>;
        }));
    }

    protected processGetPostDispatchCases(response: HttpResponseBase): Observable<GetPostDispatchCasesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPostDispatchCasesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPostDispatchCasesResponse>(null as any);
    }

    generateNewCaseData(agencyId?: number | null | undefined): Observable<GenerateNewCaseDataResponse> {
        let url_ = this.baseUrl + "/Case/GenerateNewCaseData?";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateNewCaseData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateNewCaseData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateNewCaseDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateNewCaseDataResponse>;
        }));
    }

    protected processGenerateNewCaseData(response: HttpResponseBase): Observable<GenerateNewCaseDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateNewCaseDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenerateNewCaseDataResponse>(null as any);
    }

    search(request: SearchCasesRequest): Observable<SearchCasesResponse> {
        let url_ = this.baseUrl + "/Case/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchCasesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchCasesResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchCasesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchCasesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchCasesResponse>(null as any);
    }

    quickSearch(searchText?: string | null | undefined, limit?: number | undefined): Observable<QuickSearchResponse> {
        let url_ = this.baseUrl + "/Case/QuickSearch?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuickSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuickSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuickSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuickSearchResponse>;
        }));
    }

    protected processQuickSearch(response: HttpResponseBase): Observable<QuickSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuickSearchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuickSearchResponse>(null as any);
    }

    advancedSearch(request: AdvancedSearchRequest): Observable<AdvancedSearchResponse> {
        let url_ = this.baseUrl + "/Case/AdvancedSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdvancedSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdvancedSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvancedSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvancedSearchResponse>;
        }));
    }

    protected processAdvancedSearch(response: HttpResponseBase): Observable<AdvancedSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvancedSearchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdvancedSearchResponse>(null as any);
    }

    updateStatus(request: UpdateCaseStatusRequest): Observable<void> {
        let url_ = this.baseUrl + "/Case/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    bulkUpdatePostDispatchCase(request: BulkUpdatePostDispatchCaseRequest): Observable<void> {
        let url_ = this.baseUrl + "/Case/BulkUpdatePostDispatchCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpdatePostDispatchCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdatePostDispatchCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdatePostDispatchCase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    searchCasesAndPrimaryContacts(request: SearchCaseAndPrimaryContactRequest): Observable<SearchCaseAndPrimaryContactResponse> {
        let url_ = this.baseUrl + "/Case/SearchCasesAndPrimaryContacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCasesAndPrimaryContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCasesAndPrimaryContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchCaseAndPrimaryContactResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchCaseAndPrimaryContactResponse>;
        }));
    }

    protected processSearchCasesAndPrimaryContacts(response: HttpResponseBase): Observable<SearchCaseAndPrimaryContactResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchCaseAndPrimaryContactResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchCaseAndPrimaryContactResponse>(null as any);
    }

    vote(caseId: number): Observable<VoteCaseResponse> {
        let url_ = this.baseUrl + "/Case/{caseId}/Vote";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoteCaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoteCaseResponse>;
        }));
    }

    protected processVote(response: HttpResponseBase): Observable<VoteCaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoteCaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoteCaseResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ClientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    get(id?: number | undefined): Observable<GetClientResponse> {
        let url_ = this.baseUrl + "/Client?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClientResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClientResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetClientResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClientResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetClientResponse>(null as any);
    }

    add(request: AddClientRequest): Observable<AddClientResponse> {
        let url_ = this.baseUrl + "/Client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddClientResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddClientResponse>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<AddClientResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddClientResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddClientResponse>(null as any);
    }

    update(request: UpdateClientRequest): Observable<UpdateClientResponse> {
        let url_ = this.baseUrl + "/Client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClientResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClientResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateClientResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClientResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateClientResponse>(null as any);
    }

    delete(clientViewModel: ClientViewModel): Observable<void> {
        let url_ = this.baseUrl + "/Client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clientViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    search(pageIndex?: number | undefined, pageSize?: number | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, dateOfBirth?: Date | null | undefined, clientSsn?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined): Observable<SearchClientsResponse> {
        let url_ = this.baseUrl + "/Client/Search?";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "lastName=" + encodeURIComponent("" + lastName) + "&";
        if (dateOfBirth !== undefined && dateOfBirth !== null)
            url_ += "dateOfBirth=" + encodeURIComponent(dateOfBirth ? "" + dateOfBirth.toISOString() : "") + "&";
        if (clientSsn !== undefined && clientSsn !== null)
            url_ += "clientSsn=" + encodeURIComponent("" + clientSsn) + "&";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (address1 !== undefined && address1 !== null)
            url_ += "address1=" + encodeURIComponent("" + address1) + "&";
        if (address2 !== undefined && address2 !== null)
            url_ += "address2=" + encodeURIComponent("" + address2) + "&";
        if (city !== undefined && city !== null)
            url_ += "city=" + encodeURIComponent("" + city) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (zip !== undefined && zip !== null)
            url_ += "zip=" + encodeURIComponent("" + zip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchClientsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchClientsResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchClientsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchClientsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchClientsResponse>(null as any);
    }

    checkSocialExists(request: CheckSSNRequest): Observable<CheckSSNResponse> {
        let url_ = this.baseUrl + "/Client/CheckSocialExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckSocialExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckSocialExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckSSNResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckSSNResponse>;
        }));
    }

    protected processCheckSocialExists(response: HttpResponseBase): Observable<CheckSSNResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckSSNResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckSSNResponse>(null as any);
    }

    hasCase(request: CheckHasCaseRequest): Observable<CheckHasCaseResponse> {
        let url_ = this.baseUrl + "/Client/HasCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckHasCaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckHasCaseResponse>;
        }));
    }

    protected processHasCase(response: HttpResponseBase): Observable<CheckHasCaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckHasCaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckHasCaseResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DonationBatchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    add(request: AddDonationBatchRequest): Observable<UpsertDonationBatchResponse> {
        let url_ = this.baseUrl + "/DonationBatch/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertDonationBatchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertDonationBatchResponse>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<UpsertDonationBatchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertDonationBatchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertDonationBatchResponse>(null as any);
    }

    getAll(request: GetDonationBatchesRequest): Observable<GetDonationBacthesResponse> {
        let url_ = this.baseUrl + "/DonationBatch/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDonationBacthesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDonationBacthesResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetDonationBacthesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDonationBacthesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDonationBacthesResponse>(null as any);
    }

    get(request: GetDonationBatchRequest): Observable<GetDonationBatchResponse> {
        let url_ = this.baseUrl + "/DonationBatch/Get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDonationBatchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDonationBatchResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetDonationBatchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDonationBatchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDonationBatchResponse>(null as any);
    }

    update(updateDonationBatchRequest: UpdateDonationBatchRequest): Observable<UpdateDonationBatchResponse> {
        let url_ = this.baseUrl + "/DonationBatch/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDonationBatchRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateDonationBatchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateDonationBatchResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateDonationBatchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateDonationBatchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateDonationBatchResponse>(null as any);
    }

    delete(id?: number | undefined): Observable<UpdateDonationBatchResponse> {
        let url_ = this.baseUrl + "/DonationBatch/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateDonationBatchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateDonationBatchResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<UpdateDonationBatchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateDonationBatchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateDonationBatchResponse>(null as any);
    }

    export(ids: number[]): Observable<GetDonationsExportResponse> {
        let url_ = this.baseUrl + "/DonationBatch/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDonationsExportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDonationsExportResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<GetDonationsExportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDonationsExportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDonationsExportResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DonationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    add(request: AddDonationsRequest): Observable<AddDonationsResponse> {
        let url_ = this.baseUrl + "/Donation/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddDonationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddDonationsResponse>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<AddDonationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddDonationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddDonationsResponse>(null as any);
    }

    getAll(request: GetDonationsRequest): Observable<GetDonationsResponse> {
        let url_ = this.baseUrl + "/Donation/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDonationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDonationsResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetDonationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDonationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDonationsResponse>(null as any);
    }

    get(request: GetDonationRequest): Observable<GetDonationResponse> {
        let url_ = this.baseUrl + "/Donation/Get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDonationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDonationResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetDonationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDonationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDonationResponse>(null as any);
    }

    getUnthankedDonationsCount(): Observable<GetUnthankedDonationsCountResponse> {
        let url_ = this.baseUrl + "/Donation/GetUnthankedDonationsCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnthankedDonationsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnthankedDonationsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUnthankedDonationsCountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUnthankedDonationsCountResponse>;
        }));
    }

    protected processGetUnthankedDonationsCount(response: HttpResponseBase): Observable<GetUnthankedDonationsCountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUnthankedDonationsCountResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUnthankedDonationsCountResponse>(null as any);
    }

    update(updateDonationRquest: UpdateDonationRequest): Observable<UpdateDonationResponse> {
        let url_ = this.baseUrl + "/Donation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDonationRquest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateDonationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateDonationResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateDonationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateDonationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateDonationResponse>(null as any);
    }

    updateDraft(updateDonationRquest: UpdateDraftDonationRequest): Observable<UpdateDraftDonationResponse> {
        let url_ = this.baseUrl + "/Donation/UpdateDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDonationRquest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateDraftDonationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateDraftDonationResponse>;
        }));
    }

    protected processUpdateDraft(response: HttpResponseBase): Observable<UpdateDraftDonationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateDraftDonationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateDraftDonationResponse>(null as any);
    }

    delete(id?: number | undefined): Observable<RemoveDonationResponse> {
        let url_ = this.baseUrl + "/Donation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoveDonationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoveDonationResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<RemoveDonationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemoveDonationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemoveDonationResponse>(null as any);
    }

    deleteDraft(id?: number | undefined): Observable<RemoveDraftDonationResponse> {
        let url_ = this.baseUrl + "/Donation/DeleteDraft?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoveDraftDonationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoveDraftDonationResponse>;
        }));
    }

    protected processDeleteDraft(response: HttpResponseBase): Observable<RemoveDraftDonationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemoveDraftDonationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemoveDraftDonationResponse>(null as any);
    }

    import(donationsImportRequest: DonationsImportRequest): Observable<DonationsImportResponse> {
        let url_ = this.baseUrl + "/Donation/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(donationsImportRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DonationsImportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DonationsImportResponse>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<DonationsImportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DonationsImportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DonationsImportResponse>(null as any);
    }

    getDraftDonations(batchId?: string | null | undefined): Observable<GetDraftDonationsResponse> {
        let url_ = this.baseUrl + "/Donation/GetDraftDonations?";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDraftDonations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDraftDonations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDraftDonationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDraftDonationsResponse>;
        }));
    }

    protected processGetDraftDonations(response: HttpResponseBase): Observable<GetDraftDonationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDraftDonationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDraftDonationsResponse>(null as any);
    }

    getDraftDonation(request: GetDraftDonationRequest): Observable<GetDraftDonationResponse> {
        let url_ = this.baseUrl + "/Donation/GetDraftDonation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDraftDonation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDraftDonation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDraftDonationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDraftDonationResponse>;
        }));
    }

    protected processGetDraftDonation(response: HttpResponseBase): Observable<GetDraftDonationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDraftDonationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDraftDonationResponse>(null as any);
    }

    addDraftDonation(request: AddDraftDonationRequest): Observable<AddDraftDonationResponse> {
        let url_ = this.baseUrl + "/Donation/AddDraftDonation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDraftDonation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDraftDonation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddDraftDonationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddDraftDonationResponse>;
        }));
    }

    protected processAddDraftDonation(response: HttpResponseBase): Observable<AddDraftDonationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddDraftDonationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddDraftDonationResponse>(null as any);
    }

    getDonationHistory(request: GetDonationHistoryRequest): Observable<GetDonationHistoryResponse> {
        let url_ = this.baseUrl + "/Donation/GetDonationHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDonationHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDonationHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDonationHistoryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDonationHistoryResponse>;
        }));
    }

    protected processGetDonationHistory(response: HttpResponseBase): Observable<GetDonationHistoryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDonationHistoryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDonationHistoryResponse>(null as any);
    }

    getUnpaidDonationsCount(): Observable<GetUnpaidDonationsCountResponse> {
        let url_ = this.baseUrl + "/Donation/GetUnpaidDonationsCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnpaidDonationsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnpaidDonationsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUnpaidDonationsCountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUnpaidDonationsCountResponse>;
        }));
    }

    protected processGetUnpaidDonationsCount(response: HttpResponseBase): Observable<GetUnpaidDonationsCountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUnpaidDonationsCountResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUnpaidDonationsCountResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DonorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    get(id?: number | undefined): Observable<GetDonorResponse> {
        let url_ = this.baseUrl + "/Donor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "id": id !== undefined && id !== null ? "" + id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDonorResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDonorResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetDonorResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDonorResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDonorResponse>(null as any);
    }

    add(request: AddDonorRequest): Observable<AddDonorResponse> {
        let url_ = this.baseUrl + "/Donor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddDonorResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddDonorResponse>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<AddDonorResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddDonorResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddDonorResponse>(null as any);
    }

    advancedSearch(request: DonorAdvancedSearchRequest): Observable<DonorAdvancedSearchResponse> {
        let url_ = this.baseUrl + "/Donor/AdvancedSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdvancedSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdvancedSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DonorAdvancedSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DonorAdvancedSearchResponse>;
        }));
    }

    protected processAdvancedSearch(response: HttpResponseBase): Observable<DonorAdvancedSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DonorAdvancedSearchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DonorAdvancedSearchResponse>(null as any);
    }

    update(request: UpdateDonorRequest): Observable<UpdateDonorResponse> {
        let url_ = this.baseUrl + "/Donor/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateDonorResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateDonorResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateDonorResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateDonorResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateDonorResponse>(null as any);
    }

    getMany(ids?: number[] | null | undefined): Observable<GetManyResponse> {
        let url_ = this.baseUrl + "/Donor/GetMany?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetManyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetManyResponse>;
        }));
    }

    protected processGetMany(response: HttpResponseBase): Observable<GetManyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetManyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetManyResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    export(request: ExportRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Export/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    caseDetails(request: ExportCaseDetailsRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Export/CaseDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCaseDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCaseDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCaseDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    exportDonationBatches(request: ExportDonationBatchesRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Export/ExportDonationBatches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDonationBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDonationBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportDonationBatches(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    exportDonors(request: ExportDonorsRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Export/ExportDonors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDonors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDonors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportDonors(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    getMany(type?: ReportType | undefined, to?: Date | null | undefined, from?: Date | null | undefined): Observable<GetReportsResponse> {
        let url_ = this.baseUrl + "/Report/GetMany?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportsResponse>;
        }));
    }

    protected processGetMany(response: HttpResponseBase): Observable<GetReportsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReportsResponse>(null as any);
    }

    download(fileName?: string | null | undefined, type?: ReportType | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Report/Download?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    generateNewThankYouReport(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Report/GenerateNewThankYouReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateNewThankYouReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateNewThankYouReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGenerateNewThankYouReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    generateBulkAgencyPaymentReport(request: GenerateBulkAgencyReportRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Report/GenerateBulkAgencyPaymentReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateBulkAgencyPaymentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateBulkAgencyPaymentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGenerateBulkAgencyPaymentReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    deleteReport(reportId?: number | undefined): Observable<DeleteBulkAgencyReportResponse> {
        let url_ = this.baseUrl + "/Report/DeleteReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteBulkAgencyReportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteBulkAgencyReportResponse>;
        }));
    }

    protected processDeleteReport(response: HttpResponseBase): Observable<DeleteBulkAgencyReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteBulkAgencyReportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteBulkAgencyReportResponse>(null as any);
    }

    generateAdoptersReportRequest(request: GenerateAdoptersReportRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Report/GenerateAdoptersReportRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateAdoptersReportRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateAdoptersReportRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGenerateAdoptersReportRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";
    }

    add(request: AddUserRequest): Observable<AddUserResponse> {
        let url_ = this.baseUrl + "/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddUserResponse>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<AddUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddUserResponse>(null as any);
    }

    getMany(ids?: number[] | null | undefined): Observable<GetUsersResponse> {
        let url_ = this.baseUrl + "/User/GetMany?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUsersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUsersResponse>;
        }));
    }

    protected processGetMany(response: HttpResponseBase): Observable<GetUsersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUsersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUsersResponse>(null as any);
    }

    getById(id: number): Observable<GetUserByIdResponse> {
        let url_ = this.baseUrl + "/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserByIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserByIdResponse>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetUserByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserByIdResponse>(null as any);
    }

    getByAzureId(azureId?: string | null | undefined): Observable<GetUserByAzureIdResponse> {
        let url_ = this.baseUrl + "/User/GetByAzureId?";
        if (azureId !== undefined && azureId !== null)
            url_ += "azureId=" + encodeURIComponent("" + azureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByAzureId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByAzureId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserByAzureIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserByAzureIdResponse>;
        }));
    }

    protected processGetByAzureId(response: HttpResponseBase): Observable<GetUserByAzureIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserByAzureIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserByAzureIdResponse>(null as any);
    }

    getCurrentUserAgencies(request: GetUserAgencyRequest): Observable<GetUserAgencyResponse> {
        let url_ = this.baseUrl + "/User/GetCurrentUserAgencies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserAgencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserAgencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserAgencyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserAgencyResponse>;
        }));
    }

    protected processGetCurrentUserAgencies(response: HttpResponseBase): Observable<GetUserAgencyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserAgencyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserAgencyResponse>(null as any);
    }

    getAccessibleUsers(request: GetAccessibleUsersRequest): Observable<GetAccessibleUsersResponse> {
        let url_ = this.baseUrl + "/User/GetAccessibleUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessibleUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessibleUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAccessibleUsersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAccessibleUsersResponse>;
        }));
    }

    protected processGetAccessibleUsers(response: HttpResponseBase): Observable<GetAccessibleUsersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccessibleUsersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAccessibleUsersResponse>(null as any);
    }

    update(request: UpdateUserRequest): Observable<UpdateUserResponse> {
        let url_ = this.baseUrl + "/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserResponse>(null as any);
    }

    disable(id?: number | undefined): Observable<DisableUserResponse> {
        let url_ = this.baseUrl + "/User/Disable?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DisableUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DisableUserResponse>;
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<DisableUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisableUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorViewModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DisableUserResponse>(null as any);
    }
}

export class SendCaseAdoptionResponse implements ISendCaseAdoptionResponse {

    constructor(data?: ISendCaseAdoptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SendCaseAdoptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendCaseAdoptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): SendCaseAdoptionResponse {
        const json = this.toJSON();
        let result = new SendCaseAdoptionResponse();
        result.init(json);
        return result;
    }
}

export interface ISendCaseAdoptionResponse {
}

export class ErrorViewModel implements IErrorViewModel {
    title?: string | null;
    detail?: string | null;

    constructor(data?: IErrorViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
        }
    }

    static fromJS(data: any): ErrorViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        return data;
    }

    clone(): ErrorViewModel {
        const json = this.toJSON();
        let result = new ErrorViewModel();
        result.init(json);
        return result;
    }
}

export interface IErrorViewModel {
    title?: string | null;
    detail?: string | null;
}

export class UpdateCaseAndAdoptionStatusRequest implements IUpdateCaseAndAdoptionStatusRequest {
    updates?: CaseAdoptionStatusUpdate[] | null;

    constructor(data?: IUpdateCaseAndAdoptionStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["updates"])) {
                this.updates = [] as any;
                for (let item of _data["updates"])
                    this.updates!.push(CaseAdoptionStatusUpdate.fromJS(item));
            }
            else {
                this.updates = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateCaseAndAdoptionStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseAndAdoptionStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.updates)) {
            data["updates"] = [];
            for (let item of this.updates)
                data["updates"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateCaseAndAdoptionStatusRequest {
        const json = this.toJSON();
        let result = new UpdateCaseAndAdoptionStatusRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateCaseAndAdoptionStatusRequest {
    updates?: CaseAdoptionStatusUpdate[] | null;
}

export class CaseAdoptionStatusUpdate implements ICaseAdoptionStatusUpdate {
    caseId?: number;
    donorId?: number;
    adoptionStatus?: string | null;

    constructor(data?: ICaseAdoptionStatusUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.donorId = _data["donorId"] !== undefined ? _data["donorId"] : <any>null;
            this.adoptionStatus = _data["adoptionStatus"] !== undefined ? _data["adoptionStatus"] : <any>null;
        }
    }

    static fromJS(data: any): CaseAdoptionStatusUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new CaseAdoptionStatusUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["donorId"] = this.donorId !== undefined ? this.donorId : <any>null;
        data["adoptionStatus"] = this.adoptionStatus !== undefined ? this.adoptionStatus : <any>null;
        return data;
    }

    clone(): CaseAdoptionStatusUpdate {
        const json = this.toJSON();
        let result = new CaseAdoptionStatusUpdate();
        result.init(json);
        return result;
    }
}

export interface ICaseAdoptionStatusUpdate {
    caseId?: number;
    donorId?: number;
    adoptionStatus?: string | null;
}

export class GetAdoptionStatusResponse implements IGetAdoptionStatusResponse {
    status?: string | null;

    constructor(data?: IGetAdoptionStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): GetAdoptionStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdoptionStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }

    clone(): GetAdoptionStatusResponse {
        const json = this.toJSON();
        let result = new GetAdoptionStatusResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAdoptionStatusResponse {
    status?: string | null;
}

export class GetDonorAdoptionsResponse implements IGetDonorAdoptionsResponse {
    cases?: CaseSearchResult[] | null;

    constructor(data?: IGetDonorAdoptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(CaseSearchResult.fromJS(item));
            }
            else {
                this.cases = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDonorAdoptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonorAdoptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetDonorAdoptionsResponse {
        const json = this.toJSON();
        let result = new GetDonorAdoptionsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDonorAdoptionsResponse {
    cases?: CaseSearchResult[] | null;
}

export class CaseSearchResult implements ICaseSearchResult {
    id?: number;
    campaignYear?: number | null;
    coreCategory?: string | null;
    caseNumber?: string | null;
    status?: Status;
    firstName?: string | null;
    lastName?: string | null;
    lastFourSSN?: string | null;
    isDraft?: boolean;
    neediestFlag?: boolean;
    donorName?: string | null;
    adoptionStatus?: string | null;

    constructor(data?: ICaseSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.campaignYear = _data["campaignYear"] !== undefined ? _data["campaignYear"] : <any>null;
            this.coreCategory = _data["coreCategory"] !== undefined ? _data["coreCategory"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.lastFourSSN = _data["lastFourSSN"] !== undefined ? _data["lastFourSSN"] : <any>null;
            this.isDraft = _data["isDraft"] !== undefined ? _data["isDraft"] : <any>null;
            this.neediestFlag = _data["neediestFlag"] !== undefined ? _data["neediestFlag"] : <any>null;
            this.donorName = _data["donorName"] !== undefined ? _data["donorName"] : <any>null;
            this.adoptionStatus = _data["adoptionStatus"] !== undefined ? _data["adoptionStatus"] : <any>null;
        }
    }

    static fromJS(data: any): CaseSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new CaseSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["campaignYear"] = this.campaignYear !== undefined ? this.campaignYear : <any>null;
        data["coreCategory"] = this.coreCategory !== undefined ? this.coreCategory : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["lastFourSSN"] = this.lastFourSSN !== undefined ? this.lastFourSSN : <any>null;
        data["isDraft"] = this.isDraft !== undefined ? this.isDraft : <any>null;
        data["neediestFlag"] = this.neediestFlag !== undefined ? this.neediestFlag : <any>null;
        data["donorName"] = this.donorName !== undefined ? this.donorName : <any>null;
        data["adoptionStatus"] = this.adoptionStatus !== undefined ? this.adoptionStatus : <any>null;
        return data;
    }

    clone(): CaseSearchResult {
        const json = this.toJSON();
        let result = new CaseSearchResult();
        result.init(json);
        return result;
    }
}

export interface ICaseSearchResult {
    id?: number;
    campaignYear?: number | null;
    coreCategory?: string | null;
    caseNumber?: string | null;
    status?: Status;
    firstName?: string | null;
    lastName?: string | null;
    lastFourSSN?: string | null;
    isDraft?: boolean;
    neediestFlag?: boolean;
    donorName?: string | null;
    adoptionStatus?: string | null;
}

export enum Status {
    Incomplete = "Incomplete",
    NewCase = "NewCase",
    PostDispatchCandidate = "PostDispatchCandidate",
    PostDispatchCase = "PostDispatchCase",
    PostDispatchAdopted = "PostDispatchAdopted",
    Adoptable = "Adoptable",
    PendingAdoption = "PendingAdoption",
    Adopted = "Adopted",
    Voided = "Voided",
}

export class GetAgencyResponse implements IGetAgencyResponse {
    agency?: AgencyViewModel | null;

    constructor(data?: IGetAgencyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agency = _data["agency"] ? AgencyViewModel.fromJS(_data["agency"]) : <any>null;
        }
    }

    static fromJS(data: any): GetAgencyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgencyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agency"] = this.agency ? this.agency.toJSON() : <any>null;
        return data;
    }

    clone(): GetAgencyResponse {
        const json = this.toJSON();
        let result = new GetAgencyResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAgencyResponse {
    agency?: AgencyViewModel | null;
}

export class AgencyViewModel implements IAgencyViewModel {
    id?: number;
    name?: string | null;
    uwAgencyNumber?: number;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    county?: string | null;
    phone?: string | null;
    fax?: string | null;
    emailAddress?: string | null;
    website?: string | null;
    executiveDirector?: string | null;
    agency501C3Number?: string | null;
    licenseNumber?: string | null;
    isActive?: boolean;

    constructor(data?: IAgencyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.uwAgencyNumber = _data["uwAgencyNumber"] !== undefined ? _data["uwAgencyNumber"] : <any>null;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.county = _data["county"] !== undefined ? _data["county"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.website = _data["website"] !== undefined ? _data["website"] : <any>null;
            this.executiveDirector = _data["executiveDirector"] !== undefined ? _data["executiveDirector"] : <any>null;
            this.agency501C3Number = _data["agency501C3Number"] !== undefined ? _data["agency501C3Number"] : <any>null;
            this.licenseNumber = _data["licenseNumber"] !== undefined ? _data["licenseNumber"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): AgencyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["uwAgencyNumber"] = this.uwAgencyNumber !== undefined ? this.uwAgencyNumber : <any>null;
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["county"] = this.county !== undefined ? this.county : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["website"] = this.website !== undefined ? this.website : <any>null;
        data["executiveDirector"] = this.executiveDirector !== undefined ? this.executiveDirector : <any>null;
        data["agency501C3Number"] = this.agency501C3Number !== undefined ? this.agency501C3Number : <any>null;
        data["licenseNumber"] = this.licenseNumber !== undefined ? this.licenseNumber : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }

    clone(): AgencyViewModel {
        const json = this.toJSON();
        let result = new AgencyViewModel();
        result.init(json);
        return result;
    }
}

export interface IAgencyViewModel {
    id?: number;
    name?: string | null;
    uwAgencyNumber?: number;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    county?: string | null;
    phone?: string | null;
    fax?: string | null;
    emailAddress?: string | null;
    website?: string | null;
    executiveDirector?: string | null;
    agency501C3Number?: string | null;
    licenseNumber?: string | null;
    isActive?: boolean;
}

export class GetAgencyUsersResponse implements IGetAgencyUsersResponse {
    users?: UserViewModel[] | null;

    constructor(data?: IGetAgencyUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserViewModel.fromJS(item));
            }
            else {
                this.users = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAgencyUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgencyUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAgencyUsersResponse {
        const json = this.toJSON();
        let result = new GetAgencyUsersResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAgencyUsersResponse {
    users?: UserViewModel[] | null;
}

export class UserViewModel implements IUserViewModel {
    id?: number | null;
    entitlement?: string | null;
    agencyId?: number | null;
    agency?: AgencyViewModel | null;
    contactType?: ContactType | null;
    firstName?: string | null;
    lastName?: string | null;
    emailAddress?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    fax?: string | null;
    isExternal?: boolean;
    fullName?: string | null;

    constructor(data?: IUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.entitlement = _data["entitlement"] !== undefined ? _data["entitlement"] : <any>null;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : <any>null;
            this.agency = _data["agency"] ? AgencyViewModel.fromJS(_data["agency"]) : <any>null;
            this.contactType = _data["contactType"] !== undefined ? _data["contactType"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            this.isExternal = _data["isExternal"] !== undefined ? _data["isExternal"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
        }
    }

    static fromJS(data: any): UserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["entitlement"] = this.entitlement !== undefined ? this.entitlement : <any>null;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : <any>null;
        data["agency"] = this.agency ? this.agency.toJSON() : <any>null;
        data["contactType"] = this.contactType !== undefined ? this.contactType : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        data["isExternal"] = this.isExternal !== undefined ? this.isExternal : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        return data;
    }

    clone(): UserViewModel {
        const json = this.toJSON();
        let result = new UserViewModel();
        result.init(json);
        return result;
    }
}

export interface IUserViewModel {
    id?: number | null;
    entitlement?: string | null;
    agencyId?: number | null;
    agency?: AgencyViewModel | null;
    contactType?: ContactType | null;
    firstName?: string | null;
    lastName?: string | null;
    emailAddress?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    fax?: string | null;
    isExternal?: boolean;
    fullName?: string | null;
}

export enum ContactType {
    Primary100NC = "Primary100NC",
    Alternate100NC = "Alternate100NC",
    Financial100NCContact = "Financial100NCContact",
    General = "General",
}

export class GetAgenciesResponse implements IGetAgenciesResponse {
    agencies?: AgencyViewModel[] | null;

    constructor(data?: IGetAgenciesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["agencies"])) {
                this.agencies = [] as any;
                for (let item of _data["agencies"])
                    this.agencies!.push(AgencyViewModel.fromJS(item));
            }
            else {
                this.agencies = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAgenciesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgenciesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agencies)) {
            data["agencies"] = [];
            for (let item of this.agencies)
                data["agencies"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAgenciesResponse {
        const json = this.toJSON();
        let result = new GetAgenciesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAgenciesResponse {
    agencies?: AgencyViewModel[] | null;
}

export class GetAgenciesRequest implements IGetAgenciesRequest {
    caseNumbers?: string[] | null;

    constructor(data?: IGetAgenciesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["caseNumbers"])) {
                this.caseNumbers = [] as any;
                for (let item of _data["caseNumbers"])
                    this.caseNumbers!.push(item);
            }
            else {
                this.caseNumbers = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAgenciesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgenciesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caseNumbers)) {
            data["caseNumbers"] = [];
            for (let item of this.caseNumbers)
                data["caseNumbers"].push(item);
        }
        return data;
    }

    clone(): GetAgenciesRequest {
        const json = this.toJSON();
        let result = new GetAgenciesRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAgenciesRequest {
    caseNumbers?: string[] | null;
}

export class AddAgencyResponse implements IAddAgencyResponse {
    id?: number;
    uwAgencyNumber?: number;

    constructor(data?: IAddAgencyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.uwAgencyNumber = _data["uwAgencyNumber"] !== undefined ? _data["uwAgencyNumber"] : <any>null;
        }
    }

    static fromJS(data: any): AddAgencyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddAgencyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["uwAgencyNumber"] = this.uwAgencyNumber !== undefined ? this.uwAgencyNumber : <any>null;
        return data;
    }

    clone(): AddAgencyResponse {
        const json = this.toJSON();
        let result = new AddAgencyResponse();
        result.init(json);
        return result;
    }
}

export interface IAddAgencyResponse {
    id?: number;
    uwAgencyNumber?: number;
}

export class AddAgencyRequest implements IAddAgencyRequest {
    agency?: AgencyViewModel | null;

    constructor(data?: IAddAgencyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agency = _data["agency"] ? AgencyViewModel.fromJS(_data["agency"]) : <any>null;
        }
    }

    static fromJS(data: any): AddAgencyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddAgencyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agency"] = this.agency ? this.agency.toJSON() : <any>null;
        return data;
    }

    clone(): AddAgencyRequest {
        const json = this.toJSON();
        let result = new AddAgencyRequest();
        result.init(json);
        return result;
    }
}

export interface IAddAgencyRequest {
    agency?: AgencyViewModel | null;
}

export class SearchAgenciesResponse implements ISearchAgenciesResponse {
    resultsLength?: number;
    agencyPreviews?: AgencyPreviewViewModel[] | null;

    constructor(data?: ISearchAgenciesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultsLength = _data["resultsLength"] !== undefined ? _data["resultsLength"] : <any>null;
            if (Array.isArray(_data["agencyPreviews"])) {
                this.agencyPreviews = [] as any;
                for (let item of _data["agencyPreviews"])
                    this.agencyPreviews!.push(AgencyPreviewViewModel.fromJS(item));
            }
            else {
                this.agencyPreviews = <any>null;
            }
        }
    }

    static fromJS(data: any): SearchAgenciesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchAgenciesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultsLength"] = this.resultsLength !== undefined ? this.resultsLength : <any>null;
        if (Array.isArray(this.agencyPreviews)) {
            data["agencyPreviews"] = [];
            for (let item of this.agencyPreviews)
                data["agencyPreviews"].push(item.toJSON());
        }
        return data;
    }

    clone(): SearchAgenciesResponse {
        const json = this.toJSON();
        let result = new SearchAgenciesResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchAgenciesResponse {
    resultsLength?: number;
    agencyPreviews?: AgencyPreviewViewModel[] | null;
}

export class AgencyPreviewViewModel implements IAgencyPreviewViewModel {
    id?: number;
    uwAgencyNumber?: number;
    name?: string | null;
    municipality?: string | null;
    phone?: string | null;
    caseCount?: number;
    isActive?: boolean;

    constructor(data?: IAgencyPreviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.uwAgencyNumber = _data["uwAgencyNumber"] !== undefined ? _data["uwAgencyNumber"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.municipality = _data["municipality"] !== undefined ? _data["municipality"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.caseCount = _data["caseCount"] !== undefined ? _data["caseCount"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): AgencyPreviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyPreviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["uwAgencyNumber"] = this.uwAgencyNumber !== undefined ? this.uwAgencyNumber : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["municipality"] = this.municipality !== undefined ? this.municipality : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["caseCount"] = this.caseCount !== undefined ? this.caseCount : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }

    clone(): AgencyPreviewViewModel {
        const json = this.toJSON();
        let result = new AgencyPreviewViewModel();
        result.init(json);
        return result;
    }
}

export interface IAgencyPreviewViewModel {
    id?: number;
    uwAgencyNumber?: number;
    name?: string | null;
    municipality?: string | null;
    phone?: string | null;
    caseCount?: number;
    isActive?: boolean;
}

export class SearchAgenciesRequest implements ISearchAgenciesRequest {
    pageIndex?: number;
    pageSize?: number;
    name?: string | null;

    constructor(data?: ISearchAgenciesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): SearchAgenciesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchAgenciesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): SearchAgenciesRequest {
        const json = this.toJSON();
        let result = new SearchAgenciesRequest();
        result.init(json);
        return result;
    }
}

export interface ISearchAgenciesRequest {
    pageIndex?: number;
    pageSize?: number;
    name?: string | null;
}

export class GetPrimaryContactResponse implements IGetPrimaryContactResponse {
    fullName?: string | null;
    phone?: string | null;
    email?: string | null;

    constructor(data?: IGetPrimaryContactResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): GetPrimaryContactResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrimaryContactResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }

    clone(): GetPrimaryContactResponse {
        const json = this.toJSON();
        let result = new GetPrimaryContactResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPrimaryContactResponse {
    fullName?: string | null;
    phone?: string | null;
    email?: string | null;
}

export class UpdateAgencyResponse implements IUpdateAgencyResponse {
    agencyNumber?: number;

    constructor(data?: IUpdateAgencyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyNumber = _data["agencyNumber"] !== undefined ? _data["agencyNumber"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateAgencyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgencyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyNumber"] = this.agencyNumber !== undefined ? this.agencyNumber : <any>null;
        return data;
    }

    clone(): UpdateAgencyResponse {
        const json = this.toJSON();
        let result = new UpdateAgencyResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateAgencyResponse {
    agencyNumber?: number;
}

export class UpdateAgencyRequest implements IUpdateAgencyRequest {
    agency?: AgencyViewModel | null;

    constructor(data?: IUpdateAgencyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agency = _data["agency"] ? AgencyViewModel.fromJS(_data["agency"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateAgencyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgencyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agency"] = this.agency ? this.agency.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateAgencyRequest {
        const json = this.toJSON();
        let result = new UpdateAgencyRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateAgencyRequest {
    agency?: AgencyViewModel | null;
}

export class ChangeActiveStatusResponse implements IChangeActiveStatusResponse {
    agencyNumber?: number;

    constructor(data?: IChangeActiveStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyNumber = _data["agencyNumber"] !== undefined ? _data["agencyNumber"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeActiveStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeActiveStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyNumber"] = this.agencyNumber !== undefined ? this.agencyNumber : <any>null;
        return data;
    }

    clone(): ChangeActiveStatusResponse {
        const json = this.toJSON();
        let result = new ChangeActiveStatusResponse();
        result.init(json);
        return result;
    }
}

export interface IChangeActiveStatusResponse {
    agencyNumber?: number;
}

export class ChangeActiveStatusRequest implements IChangeActiveStatusRequest {
    agencyNumber?: number;
    enable?: boolean;

    constructor(data?: IChangeActiveStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyNumber = _data["agencyNumber"] !== undefined ? _data["agencyNumber"] : <any>null;
            this.enable = _data["enable"] !== undefined ? _data["enable"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeActiveStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeActiveStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyNumber"] = this.agencyNumber !== undefined ? this.agencyNumber : <any>null;
        data["enable"] = this.enable !== undefined ? this.enable : <any>null;
        return data;
    }

    clone(): ChangeActiveStatusRequest {
        const json = this.toJSON();
        let result = new ChangeActiveStatusRequest();
        result.init(json);
        return result;
    }
}

export interface IChangeActiveStatusRequest {
    agencyNumber?: number;
    enable?: boolean;
}

export class GetAllocationResponse implements IGetAllocationResponse {
    allocation?: Allocation | null;

    constructor(data?: IGetAllocationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allocation = _data["allocation"] ? Allocation.fromJS(_data["allocation"]) : <any>null;
        }
    }

    static fromJS(data: any): GetAllocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllocationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocation"] = this.allocation ? this.allocation.toJSON() : <any>null;
        return data;
    }

    clone(): GetAllocationResponse {
        const json = this.toJSON();
        let result = new GetAllocationResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllocationResponse {
    allocation?: Allocation | null;
}

export abstract class BaseModel implements IBaseModel {
    id?: number;
    createdDate?: Date | null;
    lastUpdatedDate?: Date | null;

    constructor(data?: IBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? new Date(_data["lastUpdatedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): BaseModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toISOString() : <any>null;
        return data;
    }

    clone(): BaseModel {
        throw new Error("The abstract class 'BaseModel' cannot be instantiated.");
    }
}

export interface IBaseModel {
    id?: number;
    createdDate?: Date | null;
    lastUpdatedDate?: Date | null;
}

export class Allocation extends BaseModel implements IAllocation {
    campaignId?: number;
    campaign?: Campaign | null;
    type?: AllocationType;
    totalAmount?: number;
    amountPerAllocator?: number | null;
    caseSpecificCost?: number;
    nonAgencyCost?: number;
    postDispatchAmount?: number;
    postDispatchCasesCount?: number;
    totalDistributed?: number;
    netFundsAvailable?: number;
    distributedDate?: Date | null;
    deadlineDate?: Date | null;
    details?: AllocationDetail[] | null;

    constructor(data?: IAllocation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
            this.campaign = _data["campaign"] ? Campaign.fromJS(_data["campaign"]) : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : <any>null;
            this.amountPerAllocator = _data["amountPerAllocator"] !== undefined ? _data["amountPerAllocator"] : <any>null;
            this.caseSpecificCost = _data["caseSpecificCost"] !== undefined ? _data["caseSpecificCost"] : <any>null;
            this.nonAgencyCost = _data["nonAgencyCost"] !== undefined ? _data["nonAgencyCost"] : <any>null;
            this.postDispatchAmount = _data["postDispatchAmount"] !== undefined ? _data["postDispatchAmount"] : <any>null;
            this.postDispatchCasesCount = _data["postDispatchCasesCount"] !== undefined ? _data["postDispatchCasesCount"] : <any>null;
            this.totalDistributed = _data["totalDistributed"] !== undefined ? _data["totalDistributed"] : <any>null;
            this.netFundsAvailable = _data["netFundsAvailable"] !== undefined ? _data["netFundsAvailable"] : <any>null;
            this.distributedDate = _data["distributedDate"] ? new Date(_data["distributedDate"].toString()) : <any>null;
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : <any>null;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(AllocationDetail.fromJS(item));
            }
            else {
                this.details = <any>null;
            }
        }
    }

    static fromJS(data: any): Allocation {
        data = typeof data === 'object' ? data : {};
        let result = new Allocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : <any>null;
        data["amountPerAllocator"] = this.amountPerAllocator !== undefined ? this.amountPerAllocator : <any>null;
        data["caseSpecificCost"] = this.caseSpecificCost !== undefined ? this.caseSpecificCost : <any>null;
        data["nonAgencyCost"] = this.nonAgencyCost !== undefined ? this.nonAgencyCost : <any>null;
        data["postDispatchAmount"] = this.postDispatchAmount !== undefined ? this.postDispatchAmount : <any>null;
        data["postDispatchCasesCount"] = this.postDispatchCasesCount !== undefined ? this.postDispatchCasesCount : <any>null;
        data["totalDistributed"] = this.totalDistributed !== undefined ? this.totalDistributed : <any>null;
        data["netFundsAvailable"] = this.netFundsAvailable !== undefined ? this.netFundsAvailable : <any>null;
        data["distributedDate"] = this.distributedDate ? this.distributedDate.toISOString() : <any>null;
        data["deadlineDate"] = this.deadlineDate ? this.deadlineDate.toISOString() : <any>null;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): Allocation {
        const json = this.toJSON();
        let result = new Allocation();
        result.init(json);
        return result;
    }
}

export interface IAllocation extends IBaseModel {
    campaignId?: number;
    campaign?: Campaign | null;
    type?: AllocationType;
    totalAmount?: number;
    amountPerAllocator?: number | null;
    caseSpecificCost?: number;
    nonAgencyCost?: number;
    postDispatchAmount?: number;
    postDispatchCasesCount?: number;
    totalDistributed?: number;
    netFundsAvailable?: number;
    distributedDate?: Date | null;
    deadlineDate?: Date | null;
    details?: AllocationDetail[] | null;
}

export class Campaign extends BaseModel implements ICampaign {
    campaignYear?: number;
    isActive?: boolean;
    deactivatedDate?: Date | null;
    isFrozen?: boolean;

    constructor(data?: ICampaign) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.campaignYear = _data["campaignYear"] !== undefined ? _data["campaignYear"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.deactivatedDate = _data["deactivatedDate"] ? new Date(_data["deactivatedDate"].toString()) : <any>null;
            this.isFrozen = _data["isFrozen"] !== undefined ? _data["isFrozen"] : <any>null;
        }
    }

    static fromJS(data: any): Campaign {
        data = typeof data === 'object' ? data : {};
        let result = new Campaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignYear"] = this.campaignYear !== undefined ? this.campaignYear : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["deactivatedDate"] = this.deactivatedDate ? this.deactivatedDate.toISOString() : <any>null;
        data["isFrozen"] = this.isFrozen !== undefined ? this.isFrozen : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): Campaign {
        const json = this.toJSON();
        let result = new Campaign();
        result.init(json);
        return result;
    }
}

export interface ICampaign extends IBaseModel {
    campaignYear?: number;
    isActive?: boolean;
    deactivatedDate?: Date | null;
    isFrozen?: boolean;
}

export enum AllocationType {
    First = "First",
    Second = "Second",
    Third = "Third",
}

export class AllocationDetail extends BaseModel implements IAllocationDetail {
    allocationId?: number;
    allocation?: Allocation | null;
    caseId?: number;
    case?: Case | null;
    allocatorId?: number;
    allocator?: User | null;
    amount?: number;
    isCheckGenerated?: boolean;
    reportId?: number | null;
    paidDate?: Date | null;

    constructor(data?: IAllocationDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.allocationId = _data["allocationId"] !== undefined ? _data["allocationId"] : <any>null;
            this.allocation = _data["allocation"] ? Allocation.fromJS(_data["allocation"]) : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>null;
            this.allocatorId = _data["allocatorId"] !== undefined ? _data["allocatorId"] : <any>null;
            this.allocator = _data["allocator"] ? User.fromJS(_data["allocator"]) : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.isCheckGenerated = _data["isCheckGenerated"] !== undefined ? _data["isCheckGenerated"] : <any>null;
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : <any>null;
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AllocationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AllocationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocationId"] = this.allocationId !== undefined ? this.allocationId : <any>null;
        data["allocation"] = this.allocation ? this.allocation.toJSON() : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        data["allocatorId"] = this.allocatorId !== undefined ? this.allocatorId : <any>null;
        data["allocator"] = this.allocator ? this.allocator.toJSON() : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["isCheckGenerated"] = this.isCheckGenerated !== undefined ? this.isCheckGenerated : <any>null;
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): AllocationDetail {
        const json = this.toJSON();
        let result = new AllocationDetail();
        result.init(json);
        return result;
    }
}

export interface IAllocationDetail extends IBaseModel {
    allocationId?: number;
    allocation?: Allocation | null;
    caseId?: number;
    case?: Case | null;
    allocatorId?: number;
    allocator?: User | null;
    amount?: number;
    isCheckGenerated?: boolean;
    reportId?: number | null;
    paidDate?: Date | null;
}

export class Case extends BaseModel implements ICase {
    caseLikes?: CaseLike[] | null;
    campaign?: Campaign | null;
    campaignId?: number;
    caseNumber?: string | null;
    client?: Client | null;
    clientId?: number | null;
    appealLevel?: AppealLevel | null;
    status?: Status;
    neediestFlag?: boolean | null;
    allocatorAssigned?: boolean | null;
    allocatorId?: number | null;
    allocator?: User | null;
    agencyInputted?: boolean | null;
    agencyId?: number | null;
    agency?: Agency | null;
    caseWorkerName?: string | null;
    caseWorkerPhone?: string | null;
    story?: string | null;
    postDispatchNumber?: number | null;
    disburseTo?: string | null;
    coreCategory?: string | null;
    income?: Income[] | null;
    expenses?: Expense[] | null;
    needs?: Need[] | null;
    family?: FamilyMember[] | null;
    allocationDetails?: AllocationDetail[] | null;
    donationDetails?: DonationDetail[] | null;
    adopted?: boolean;
    adoptionReview?: boolean;
    donor?: Donor | null;
    donorId?: number | null;
    likeCount?: number;

    constructor(data?: ICase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["caseLikes"])) {
                this.caseLikes = [] as any;
                for (let item of _data["caseLikes"])
                    this.caseLikes!.push(CaseLike.fromJS(item));
            }
            else {
                this.caseLikes = <any>null;
            }
            this.campaign = _data["campaign"] ? Campaign.fromJS(_data["campaign"]) : <any>null;
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>null;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : <any>null;
            this.appealLevel = _data["appealLevel"] !== undefined ? _data["appealLevel"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.neediestFlag = _data["neediestFlag"] !== undefined ? _data["neediestFlag"] : <any>null;
            this.allocatorAssigned = _data["allocatorAssigned"] !== undefined ? _data["allocatorAssigned"] : <any>null;
            this.allocatorId = _data["allocatorId"] !== undefined ? _data["allocatorId"] : <any>null;
            this.allocator = _data["allocator"] ? User.fromJS(_data["allocator"]) : <any>null;
            this.agencyInputted = _data["agencyInputted"] !== undefined ? _data["agencyInputted"] : <any>null;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : <any>null;
            this.agency = _data["agency"] ? Agency.fromJS(_data["agency"]) : <any>null;
            this.caseWorkerName = _data["caseWorkerName"] !== undefined ? _data["caseWorkerName"] : <any>null;
            this.caseWorkerPhone = _data["caseWorkerPhone"] !== undefined ? _data["caseWorkerPhone"] : <any>null;
            this.story = _data["story"] !== undefined ? _data["story"] : <any>null;
            this.postDispatchNumber = _data["postDispatchNumber"] !== undefined ? _data["postDispatchNumber"] : <any>null;
            this.disburseTo = _data["disburseTo"] !== undefined ? _data["disburseTo"] : <any>null;
            this.coreCategory = _data["coreCategory"] !== undefined ? _data["coreCategory"] : <any>null;
            if (Array.isArray(_data["income"])) {
                this.income = [] as any;
                for (let item of _data["income"])
                    this.income!.push(Income.fromJS(item));
            }
            else {
                this.income = <any>null;
            }
            if (Array.isArray(_data["expenses"])) {
                this.expenses = [] as any;
                for (let item of _data["expenses"])
                    this.expenses!.push(Expense.fromJS(item));
            }
            else {
                this.expenses = <any>null;
            }
            if (Array.isArray(_data["needs"])) {
                this.needs = [] as any;
                for (let item of _data["needs"])
                    this.needs!.push(Need.fromJS(item));
            }
            else {
                this.needs = <any>null;
            }
            if (Array.isArray(_data["family"])) {
                this.family = [] as any;
                for (let item of _data["family"])
                    this.family!.push(FamilyMember.fromJS(item));
            }
            else {
                this.family = <any>null;
            }
            if (Array.isArray(_data["allocationDetails"])) {
                this.allocationDetails = [] as any;
                for (let item of _data["allocationDetails"])
                    this.allocationDetails!.push(AllocationDetail.fromJS(item));
            }
            else {
                this.allocationDetails = <any>null;
            }
            if (Array.isArray(_data["donationDetails"])) {
                this.donationDetails = [] as any;
                for (let item of _data["donationDetails"])
                    this.donationDetails!.push(DonationDetail.fromJS(item));
            }
            else {
                this.donationDetails = <any>null;
            }
            this.adopted = _data["adopted"] !== undefined ? _data["adopted"] : <any>null;
            this.adoptionReview = _data["adoptionReview"] !== undefined ? _data["adoptionReview"] : <any>null;
            this.donor = _data["donor"] ? Donor.fromJS(_data["donor"]) : <any>null;
            this.donorId = _data["donorId"] !== undefined ? _data["donorId"] : <any>null;
            this.likeCount = _data["likeCount"] !== undefined ? _data["likeCount"] : <any>null;
        }
    }

    static fromJS(data: any): Case {
        data = typeof data === 'object' ? data : {};
        let result = new Case();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caseLikes)) {
            data["caseLikes"] = [];
            for (let item of this.caseLikes)
                data["caseLikes"].push(item.toJSON());
        }
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>null;
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["clientId"] = this.clientId !== undefined ? this.clientId : <any>null;
        data["appealLevel"] = this.appealLevel !== undefined ? this.appealLevel : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["neediestFlag"] = this.neediestFlag !== undefined ? this.neediestFlag : <any>null;
        data["allocatorAssigned"] = this.allocatorAssigned !== undefined ? this.allocatorAssigned : <any>null;
        data["allocatorId"] = this.allocatorId !== undefined ? this.allocatorId : <any>null;
        data["allocator"] = this.allocator ? this.allocator.toJSON() : <any>null;
        data["agencyInputted"] = this.agencyInputted !== undefined ? this.agencyInputted : <any>null;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : <any>null;
        data["agency"] = this.agency ? this.agency.toJSON() : <any>null;
        data["caseWorkerName"] = this.caseWorkerName !== undefined ? this.caseWorkerName : <any>null;
        data["caseWorkerPhone"] = this.caseWorkerPhone !== undefined ? this.caseWorkerPhone : <any>null;
        data["story"] = this.story !== undefined ? this.story : <any>null;
        data["postDispatchNumber"] = this.postDispatchNumber !== undefined ? this.postDispatchNumber : <any>null;
        data["disburseTo"] = this.disburseTo !== undefined ? this.disburseTo : <any>null;
        data["coreCategory"] = this.coreCategory !== undefined ? this.coreCategory : <any>null;
        if (Array.isArray(this.income)) {
            data["income"] = [];
            for (let item of this.income)
                data["income"].push(item.toJSON());
        }
        if (Array.isArray(this.expenses)) {
            data["expenses"] = [];
            for (let item of this.expenses)
                data["expenses"].push(item.toJSON());
        }
        if (Array.isArray(this.needs)) {
            data["needs"] = [];
            for (let item of this.needs)
                data["needs"].push(item.toJSON());
        }
        if (Array.isArray(this.family)) {
            data["family"] = [];
            for (let item of this.family)
                data["family"].push(item.toJSON());
        }
        if (Array.isArray(this.allocationDetails)) {
            data["allocationDetails"] = [];
            for (let item of this.allocationDetails)
                data["allocationDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.donationDetails)) {
            data["donationDetails"] = [];
            for (let item of this.donationDetails)
                data["donationDetails"].push(item.toJSON());
        }
        data["adopted"] = this.adopted !== undefined ? this.adopted : <any>null;
        data["adoptionReview"] = this.adoptionReview !== undefined ? this.adoptionReview : <any>null;
        data["donor"] = this.donor ? this.donor.toJSON() : <any>null;
        data["donorId"] = this.donorId !== undefined ? this.donorId : <any>null;
        data["likeCount"] = this.likeCount !== undefined ? this.likeCount : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): Case {
        const json = this.toJSON();
        let result = new Case();
        result.init(json);
        return result;
    }
}

export interface ICase extends IBaseModel {
    caseLikes?: CaseLike[] | null;
    campaign?: Campaign | null;
    campaignId?: number;
    caseNumber?: string | null;
    client?: Client | null;
    clientId?: number | null;
    appealLevel?: AppealLevel | null;
    status?: Status;
    neediestFlag?: boolean | null;
    allocatorAssigned?: boolean | null;
    allocatorId?: number | null;
    allocator?: User | null;
    agencyInputted?: boolean | null;
    agencyId?: number | null;
    agency?: Agency | null;
    caseWorkerName?: string | null;
    caseWorkerPhone?: string | null;
    story?: string | null;
    postDispatchNumber?: number | null;
    disburseTo?: string | null;
    coreCategory?: string | null;
    income?: Income[] | null;
    expenses?: Expense[] | null;
    needs?: Need[] | null;
    family?: FamilyMember[] | null;
    allocationDetails?: AllocationDetail[] | null;
    donationDetails?: DonationDetail[] | null;
    adopted?: boolean;
    adoptionReview?: boolean;
    donor?: Donor | null;
    donorId?: number | null;
    likeCount?: number;
}

export class CaseLike extends BaseModel implements ICaseLike {
    caseId?: number;
    externalUserId?: string | null;
    case?: Case | null;

    constructor(data?: ICaseLike) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.externalUserId = _data["externalUserId"] !== undefined ? _data["externalUserId"] : <any>null;
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>null;
        }
    }

    static fromJS(data: any): CaseLike {
        data = typeof data === 'object' ? data : {};
        let result = new CaseLike();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["externalUserId"] = this.externalUserId !== undefined ? this.externalUserId : <any>null;
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): CaseLike {
        const json = this.toJSON();
        let result = new CaseLike();
        result.init(json);
        return result;
    }
}

export interface ICaseLike extends IBaseModel {
    caseId?: number;
    externalUserId?: string | null;
    case?: Case | null;
}

export class Client extends BaseModel implements IClient {
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    ssn?: string | null;
    lastFourSSN?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    gender?: string | null;
    dateOfBirth?: Date | null;
    phone?: string | null;
    email?: string | null;
    adultsInHousehold?: number | null;
    childrenInHousehold?: number | null;
    disabilities?: Disability[] | null;
    cases?: Case[] | null;

    constructor(data?: IClient) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : <any>null;
            this.lastFourSSN = _data["lastFourSSN"] !== undefined ? _data["lastFourSSN"] : <any>null;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.adultsInHousehold = _data["adultsInHousehold"] !== undefined ? _data["adultsInHousehold"] : <any>null;
            this.childrenInHousehold = _data["childrenInHousehold"] !== undefined ? _data["childrenInHousehold"] : <any>null;
            if (Array.isArray(_data["disabilities"])) {
                this.disabilities = [] as any;
                for (let item of _data["disabilities"])
                    this.disabilities!.push(Disability.fromJS(item));
            }
            else {
                this.disabilities = <any>null;
            }
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(Case.fromJS(item));
            }
            else {
                this.cases = <any>null;
            }
        }
    }

    static fromJS(data: any): Client {
        data = typeof data === 'object' ? data : {};
        let result = new Client();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["ssn"] = this.ssn !== undefined ? this.ssn : <any>null;
        data["lastFourSSN"] = this.lastFourSSN !== undefined ? this.lastFourSSN : <any>null;
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["adultsInHousehold"] = this.adultsInHousehold !== undefined ? this.adultsInHousehold : <any>null;
        data["childrenInHousehold"] = this.childrenInHousehold !== undefined ? this.childrenInHousehold : <any>null;
        if (Array.isArray(this.disabilities)) {
            data["disabilities"] = [];
            for (let item of this.disabilities)
                data["disabilities"].push(item.toJSON());
        }
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): Client {
        const json = this.toJSON();
        let result = new Client();
        result.init(json);
        return result;
    }
}

export interface IClient extends IBaseModel {
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    ssn?: string | null;
    lastFourSSN?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    gender?: string | null;
    dateOfBirth?: Date | null;
    phone?: string | null;
    email?: string | null;
    adultsInHousehold?: number | null;
    childrenInHousehold?: number | null;
    disabilities?: Disability[] | null;
    cases?: Case[] | null;
}

export class Disability extends BaseModel implements IDisability {
    campaign?: Campaign | null;
    campaignId?: number | null;
    client?: Client | null;
    clientId?: number;
    type?: DisabilityType | null;
    description?: string | null;

    constructor(data?: IDisability) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.campaign = _data["campaign"] ? Campaign.fromJS(_data["campaign"]) : <any>null;
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>null;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): Disability {
        data = typeof data === 'object' ? data : {};
        let result = new Disability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>null;
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["clientId"] = this.clientId !== undefined ? this.clientId : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): Disability {
        const json = this.toJSON();
        let result = new Disability();
        result.init(json);
        return result;
    }
}

export interface IDisability extends IBaseModel {
    campaign?: Campaign | null;
    campaignId?: number | null;
    client?: Client | null;
    clientId?: number;
    type?: DisabilityType | null;
    description?: string | null;
}

export enum DisabilityType {
    AbusedNeglected = "AbusedNeglected",
    Alzheimer = "Alzheimer",
    Amputation = "Amputation",
    Arthritis = "Arthritis",
    Asthma = "Asthma",
    Autism = "Autism",
    BehaviorDisorder = "BehaviorDisorder",
    Cancer = "Cancer",
    CerebralPalsy = "CerebralPalsy",
    Developmental = "Developmental",
    Diabetes = "Diabetes",
    DialysisTransplant = "DialysisTransplant",
    Emphysema = "Emphysema",
    HeadInjury = "HeadInjury",
    Heart = "Heart",
    Hiv = "Hiv",
    Hypertension = "Hypertension",
    KidneyFailure = "KidneyFailure",
    MentalHealth = "MentalHealth",
    Ms = "Ms",
    Other = "Other",
    Paraplegic = "Paraplegic",
    Quadriplegic = "Quadriplegic",
    RenalEndStage = "RenalEndStage",
    DevelopmentalDisabilities = "DevelopmentalDisabilities",
    Seizures = "Seizures",
    SocialSecuritySpou = "SocialSecuritySpou",
    SpinaBifida = "SpinaBifida",
    Thyroid = "Thyroid",
    Vision = "Vision",
}

export enum AppealLevel {
    Level1 = "Level1",
    Level2 = "Level2",
    Level3 = "Level3",
}

export class User extends BaseModel implements IUser {
    entitlement?: string | null;
    agencyId?: number | null;
    agency?: Agency | null;
    contactType?: ContactType | null;
    firstName?: string | null;
    lastName?: string | null;
    emailAddress?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    fax?: string | null;
    isExternal?: boolean;
    fullName?: string | null;
    azureId?: string | null;
    isActive?: boolean;
    assignedCases?: Case[] | null;
    allocationDetails?: AllocationDetail[] | null;
    allocatorCompletions?: AllocatorCompletion[] | null;

    constructor(data?: IUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entitlement = _data["entitlement"] !== undefined ? _data["entitlement"] : <any>null;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : <any>null;
            this.agency = _data["agency"] ? Agency.fromJS(_data["agency"]) : <any>null;
            this.contactType = _data["contactType"] !== undefined ? _data["contactType"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            this.isExternal = _data["isExternal"] !== undefined ? _data["isExternal"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.azureId = _data["azureId"] !== undefined ? _data["azureId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            if (Array.isArray(_data["assignedCases"])) {
                this.assignedCases = [] as any;
                for (let item of _data["assignedCases"])
                    this.assignedCases!.push(Case.fromJS(item));
            }
            else {
                this.assignedCases = <any>null;
            }
            if (Array.isArray(_data["allocationDetails"])) {
                this.allocationDetails = [] as any;
                for (let item of _data["allocationDetails"])
                    this.allocationDetails!.push(AllocationDetail.fromJS(item));
            }
            else {
                this.allocationDetails = <any>null;
            }
            if (Array.isArray(_data["allocatorCompletions"])) {
                this.allocatorCompletions = [] as any;
                for (let item of _data["allocatorCompletions"])
                    this.allocatorCompletions!.push(AllocatorCompletion.fromJS(item));
            }
            else {
                this.allocatorCompletions = <any>null;
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entitlement"] = this.entitlement !== undefined ? this.entitlement : <any>null;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : <any>null;
        data["agency"] = this.agency ? this.agency.toJSON() : <any>null;
        data["contactType"] = this.contactType !== undefined ? this.contactType : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        data["isExternal"] = this.isExternal !== undefined ? this.isExternal : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["azureId"] = this.azureId !== undefined ? this.azureId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        if (Array.isArray(this.assignedCases)) {
            data["assignedCases"] = [];
            for (let item of this.assignedCases)
                data["assignedCases"].push(item.toJSON());
        }
        if (Array.isArray(this.allocationDetails)) {
            data["allocationDetails"] = [];
            for (let item of this.allocationDetails)
                data["allocationDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.allocatorCompletions)) {
            data["allocatorCompletions"] = [];
            for (let item of this.allocatorCompletions)
                data["allocatorCompletions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser extends IBaseModel {
    entitlement?: string | null;
    agencyId?: number | null;
    agency?: Agency | null;
    contactType?: ContactType | null;
    firstName?: string | null;
    lastName?: string | null;
    emailAddress?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    fax?: string | null;
    isExternal?: boolean;
    fullName?: string | null;
    azureId?: string | null;
    isActive?: boolean;
    assignedCases?: Case[] | null;
    allocationDetails?: AllocationDetail[] | null;
    allocatorCompletions?: AllocatorCompletion[] | null;
}

export class Agency extends BaseModel implements IAgency {
    name?: string | null;
    uwAgencyNumber?: number;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    county?: string | null;
    phone?: string | null;
    fax?: string | null;
    emailAddress?: string | null;
    faxAddress?: string | null;
    website?: string | null;
    executiveDirector?: string | null;
    agency501C3Number?: string | null;
    licenseNumber?: string | null;
    cases?: Case[] | null;
    isActive?: boolean;

    constructor(data?: IAgency) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.uwAgencyNumber = _data["uwAgencyNumber"] !== undefined ? _data["uwAgencyNumber"] : <any>null;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.county = _data["county"] !== undefined ? _data["county"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.faxAddress = _data["faxAddress"] !== undefined ? _data["faxAddress"] : <any>null;
            this.website = _data["website"] !== undefined ? _data["website"] : <any>null;
            this.executiveDirector = _data["executiveDirector"] !== undefined ? _data["executiveDirector"] : <any>null;
            this.agency501C3Number = _data["agency501C3Number"] !== undefined ? _data["agency501C3Number"] : <any>null;
            this.licenseNumber = _data["licenseNumber"] !== undefined ? _data["licenseNumber"] : <any>null;
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(Case.fromJS(item));
            }
            else {
                this.cases = <any>null;
            }
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): Agency {
        data = typeof data === 'object' ? data : {};
        let result = new Agency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["uwAgencyNumber"] = this.uwAgencyNumber !== undefined ? this.uwAgencyNumber : <any>null;
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["county"] = this.county !== undefined ? this.county : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["faxAddress"] = this.faxAddress !== undefined ? this.faxAddress : <any>null;
        data["website"] = this.website !== undefined ? this.website : <any>null;
        data["executiveDirector"] = this.executiveDirector !== undefined ? this.executiveDirector : <any>null;
        data["agency501C3Number"] = this.agency501C3Number !== undefined ? this.agency501C3Number : <any>null;
        data["licenseNumber"] = this.licenseNumber !== undefined ? this.licenseNumber : <any>null;
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item.toJSON());
        }
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): Agency {
        const json = this.toJSON();
        let result = new Agency();
        result.init(json);
        return result;
    }
}

export interface IAgency extends IBaseModel {
    name?: string | null;
    uwAgencyNumber?: number;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    county?: string | null;
    phone?: string | null;
    fax?: string | null;
    emailAddress?: string | null;
    faxAddress?: string | null;
    website?: string | null;
    executiveDirector?: string | null;
    agency501C3Number?: string | null;
    licenseNumber?: string | null;
    cases?: Case[] | null;
    isActive?: boolean;
}

export class AllocatorCompletion extends BaseModel implements IAllocatorCompletion {
    allocationId?: number;
    allocation?: Allocation | null;
    isFinalized?: boolean;
    allocatorId?: number;
    allocator?: User | null;

    constructor(data?: IAllocatorCompletion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.allocationId = _data["allocationId"] !== undefined ? _data["allocationId"] : <any>null;
            this.allocation = _data["allocation"] ? Allocation.fromJS(_data["allocation"]) : <any>null;
            this.isFinalized = _data["isFinalized"] !== undefined ? _data["isFinalized"] : <any>null;
            this.allocatorId = _data["allocatorId"] !== undefined ? _data["allocatorId"] : <any>null;
            this.allocator = _data["allocator"] ? User.fromJS(_data["allocator"]) : <any>null;
        }
    }

    static fromJS(data: any): AllocatorCompletion {
        data = typeof data === 'object' ? data : {};
        let result = new AllocatorCompletion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocationId"] = this.allocationId !== undefined ? this.allocationId : <any>null;
        data["allocation"] = this.allocation ? this.allocation.toJSON() : <any>null;
        data["isFinalized"] = this.isFinalized !== undefined ? this.isFinalized : <any>null;
        data["allocatorId"] = this.allocatorId !== undefined ? this.allocatorId : <any>null;
        data["allocator"] = this.allocator ? this.allocator.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): AllocatorCompletion {
        const json = this.toJSON();
        let result = new AllocatorCompletion();
        result.init(json);
        return result;
    }
}

export interface IAllocatorCompletion extends IBaseModel {
    allocationId?: number;
    allocation?: Allocation | null;
    isFinalized?: boolean;
    allocatorId?: number;
    allocator?: User | null;
}

export class Income extends BaseModel implements IIncome {
    type?: IncomeType | null;
    description?: string | null;
    amount?: number | null;
    case?: Case | null;
    caseId?: number;

    constructor(data?: IIncome) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
        }
    }

    static fromJS(data: any): Income {
        data = typeof data === 'object' ? data : {};
        let result = new Income();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): Income {
        const json = this.toJSON();
        let result = new Income();
        result.init(json);
        return result;
    }
}

export interface IIncome extends IBaseModel {
    type?: IncomeType | null;
    description?: string | null;
    amount?: number | null;
    case?: Case | null;
    caseId?: number;
}

export enum IncomeType {
    SalaryOrWages = "SalaryOrWages",
    SS_SSI_Disability = "SS_SSI_Disability",
    Unemployment = "Unemployment",
    TANFOrFoodStamps = "TANFOrFoodStamps",
    Other = "Other",
}

export class Expense extends BaseModel implements IExpense {
    type?: ExpenseType | null;
    description?: string | null;
    amount?: number | null;
    case?: Case | null;
    caseId?: number;

    constructor(data?: IExpense) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
        }
    }

    static fromJS(data: any): Expense {
        data = typeof data === 'object' ? data : {};
        let result = new Expense();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): Expense {
        const json = this.toJSON();
        let result = new Expense();
        result.init(json);
        return result;
    }
}

export interface IExpense extends IBaseModel {
    type?: ExpenseType | null;
    description?: string | null;
    amount?: number | null;
    case?: Case | null;
    caseId?: number;
}

export enum ExpenseType {
    RentOrMortgage = "RentOrMortgage",
    Utilities = "Utilities",
    Food = "Food",
    Medical = "Medical",
    Transportation = "Transportation",
    Other = "Other",
}

export class Need extends BaseModel implements INeed {
    type?: NeedType | null;
    description?: string | null;
    quantity?: number | null;
    case?: Case | null;
    caseId?: number;

    constructor(data?: INeed) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
        }
    }

    static fromJS(data: any): Need {
        data = typeof data === 'object' ? data : {};
        let result = new Need();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): Need {
        const json = this.toJSON();
        let result = new Need();
        result.init(json);
        return result;
    }
}

export interface INeed extends IBaseModel {
    type?: NeedType | null;
    description?: string | null;
    quantity?: number | null;
    case?: Case | null;
    caseId?: number;
}

export enum NeedType {
    Clothing = "Clothing",
    CashOrGiftCertificates = "CashOrGiftCertificates",
    UtilityBills = "UtilityBills",
    Food = "Food",
    RentMortgage = "RentMortgage",
    Transportation = "Transportation",
    Other = "Other",
    TuitionEducation = "TuitionEducation",
    Medical = "Medical",
    Appliances = "Appliances",
    Furniture = "Furniture",
    HouseholdRepairs = "HouseholdRepairs",
    Toys = "Toys",
}

export class FamilyMember extends BaseModel implements IFamilyMember {
    firstName?: string | null;
    lastName?: string | null;
    age?: number | null;
    gender?: string | null;
    relationship?: RelationshipType | null;
    clothingSize?: string | null;
    clothingSizeType?: ClothingSizeType | null;
    shoeSize?: string | null;
    shoeSizeType?: ClothingSizeType | null;
    case?: Case | null;
    caseId?: number;

    constructor(data?: IFamilyMember) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.age = _data["age"] !== undefined ? _data["age"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.relationship = _data["relationship"] !== undefined ? _data["relationship"] : <any>null;
            this.clothingSize = _data["clothingSize"] !== undefined ? _data["clothingSize"] : <any>null;
            this.clothingSizeType = _data["clothingSizeType"] !== undefined ? _data["clothingSizeType"] : <any>null;
            this.shoeSize = _data["shoeSize"] !== undefined ? _data["shoeSize"] : <any>null;
            this.shoeSizeType = _data["shoeSizeType"] !== undefined ? _data["shoeSizeType"] : <any>null;
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
        }
    }

    static fromJS(data: any): FamilyMember {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["relationship"] = this.relationship !== undefined ? this.relationship : <any>null;
        data["clothingSize"] = this.clothingSize !== undefined ? this.clothingSize : <any>null;
        data["clothingSizeType"] = this.clothingSizeType !== undefined ? this.clothingSizeType : <any>null;
        data["shoeSize"] = this.shoeSize !== undefined ? this.shoeSize : <any>null;
        data["shoeSizeType"] = this.shoeSizeType !== undefined ? this.shoeSizeType : <any>null;
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): FamilyMember {
        const json = this.toJSON();
        let result = new FamilyMember();
        result.init(json);
        return result;
    }
}

export interface IFamilyMember extends IBaseModel {
    firstName?: string | null;
    lastName?: string | null;
    age?: number | null;
    gender?: string | null;
    relationship?: RelationshipType | null;
    clothingSize?: string | null;
    clothingSizeType?: ClothingSizeType | null;
    shoeSize?: string | null;
    shoeSizeType?: ClothingSizeType | null;
    case?: Case | null;
    caseId?: number;
}

export enum RelationshipType {
    Self = "Self",
    SpouseOrPartner = "SpouseOrPartner",
    Child = "Child",
    AdultChild = "AdultChild",
    FosterChild = "FosterChild",
    Parent = "Parent",
    FosterParent = "FosterParent",
    Guardian = "Guardian",
    Sibling = "Sibling",
    Grandparent = "Grandparent",
    Grandchild = "Grandchild",
    AuntUncle = "AuntUncle",
    ExtendedFamily = "ExtendedFamily",
    Other = "Other",
}

export enum ClothingSizeType {
    Womens = "Womens",
    Mens = "Mens",
    Childrens = "Childrens",
}

export class DonationDetail extends BaseModel implements IDonationDetail {
    donationId?: number;
    amount?: number;
    caseId?: number | null;
    order?: number;
    type?: DonationType;
    designationType?: DesignationCategoryType | null;
    designationSubType?: DesignationSubCategoryType | null;
    isCheckGenerated?: boolean;
    reportId?: number | null;
    paidDate?: Date | null;
    case?: Case | null;
    donation?: Donation | null;

    constructor(data?: IDonationDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.donationId = _data["donationId"] !== undefined ? _data["donationId"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.designationType = _data["designationType"] !== undefined ? _data["designationType"] : <any>null;
            this.designationSubType = _data["designationSubType"] !== undefined ? _data["designationSubType"] : <any>null;
            this.isCheckGenerated = _data["isCheckGenerated"] !== undefined ? _data["isCheckGenerated"] : <any>null;
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : <any>null;
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : <any>null;
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>null;
            this.donation = _data["donation"] ? Donation.fromJS(_data["donation"]) : <any>null;
        }
    }

    static fromJS(data: any): DonationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new DonationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donationId"] = this.donationId !== undefined ? this.donationId : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["designationType"] = this.designationType !== undefined ? this.designationType : <any>null;
        data["designationSubType"] = this.designationSubType !== undefined ? this.designationSubType : <any>null;
        data["isCheckGenerated"] = this.isCheckGenerated !== undefined ? this.isCheckGenerated : <any>null;
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>null;
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        data["donation"] = this.donation ? this.donation.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DonationDetail {
        const json = this.toJSON();
        let result = new DonationDetail();
        result.init(json);
        return result;
    }
}

export interface IDonationDetail extends IBaseModel {
    donationId?: number;
    amount?: number;
    caseId?: number | null;
    order?: number;
    type?: DonationType;
    designationType?: DesignationCategoryType | null;
    designationSubType?: DesignationSubCategoryType | null;
    isCheckGenerated?: boolean;
    reportId?: number | null;
    paidDate?: Date | null;
    case?: Case | null;
    donation?: Donation | null;
}

export enum DonationType {
    GeneralFund = "GeneralFund",
    SpecificCase = "SpecificCase",
}

export enum DesignationCategoryType {
    CashToClient = "CashToClient",
    CashToAgency = "CashToAgency",
    CashToUtility = "CashToUtility",
}

export enum DesignationSubCategoryType {
    Agency_HomeRepairs = "Agency_HomeRepairs",
    Agency_Medical = "Agency_Medical",
    Agency_Phone = "Agency_Phone",
    Agency_RentMortgage = "Agency_RentMortgage",
    Agency_TransportationCosts = "Agency_TransportationCosts",
    Agency_TuitionEducation = "Agency_TuitionEducation",
    Agency_GiftCardsFood = "Agency_GiftCardsFood",
    Agency_GiftCardsAppliances = "Agency_GiftCardsAppliances",
    Agency_GiftCardsClothing = "Agency_GiftCardsClothing",
    Agency_GiftCardsFurniture = "Agency_GiftCardsFurniture",
    Agency_GiftCardsToys = "Agency_GiftCardsToys",
    Agency_GiftCardsMisc = "Agency_GiftCardsMisc",
    Agency_GiftCards = "Agency_GiftCards",
    Agency_Other = "Agency_Other",
    Utility_Gas = "Utility_Gas",
    Utility_Electric = "Utility_Electric",
    Utility_Sewer = "Utility_Sewer",
    Utility_Water = "Utility_Water",
    Utility_Internet = "Utility_Internet",
}

export class Donation extends BaseModel implements IDonation {
    campaignId?: number;
    donorId?: number;
    donationBatchId?: number;
    amount?: number;
    quantity?: number;
    donationDate?: Date | null;
    description?: string | null;
    isThankYouGenerated?: boolean;
    isPotentialMatchingGift?: boolean;
    isDonorAdvisedFund?: boolean;
    isStockGiftReceipt?: boolean;
    matching?: string | null;
    transactionId?: string | null;
    campaign?: Campaign | null;
    donor?: Donor | null;
    donationBatch?: DonationBatch | null;
    details?: DonationDetail[] | null;

    constructor(data?: IDonation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
            this.donorId = _data["donorId"] !== undefined ? _data["donorId"] : <any>null;
            this.donationBatchId = _data["donationBatchId"] !== undefined ? _data["donationBatchId"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.donationDate = _data["donationDate"] ? new Date(_data["donationDate"].toString()) : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.isThankYouGenerated = _data["isThankYouGenerated"] !== undefined ? _data["isThankYouGenerated"] : <any>null;
            this.isPotentialMatchingGift = _data["isPotentialMatchingGift"] !== undefined ? _data["isPotentialMatchingGift"] : <any>null;
            this.isDonorAdvisedFund = _data["isDonorAdvisedFund"] !== undefined ? _data["isDonorAdvisedFund"] : <any>null;
            this.isStockGiftReceipt = _data["isStockGiftReceipt"] !== undefined ? _data["isStockGiftReceipt"] : <any>null;
            this.matching = _data["matching"] !== undefined ? _data["matching"] : <any>null;
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : <any>null;
            this.campaign = _data["campaign"] ? Campaign.fromJS(_data["campaign"]) : <any>null;
            this.donor = _data["donor"] ? Donor.fromJS(_data["donor"]) : <any>null;
            this.donationBatch = _data["donationBatch"] ? DonationBatch.fromJS(_data["donationBatch"]) : <any>null;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(DonationDetail.fromJS(item));
            }
            else {
                this.details = <any>null;
            }
        }
    }

    static fromJS(data: any): Donation {
        data = typeof data === 'object' ? data : {};
        let result = new Donation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        data["donorId"] = this.donorId !== undefined ? this.donorId : <any>null;
        data["donationBatchId"] = this.donationBatchId !== undefined ? this.donationBatchId : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["donationDate"] = this.donationDate ? this.donationDate.toISOString() : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["isThankYouGenerated"] = this.isThankYouGenerated !== undefined ? this.isThankYouGenerated : <any>null;
        data["isPotentialMatchingGift"] = this.isPotentialMatchingGift !== undefined ? this.isPotentialMatchingGift : <any>null;
        data["isDonorAdvisedFund"] = this.isDonorAdvisedFund !== undefined ? this.isDonorAdvisedFund : <any>null;
        data["isStockGiftReceipt"] = this.isStockGiftReceipt !== undefined ? this.isStockGiftReceipt : <any>null;
        data["matching"] = this.matching !== undefined ? this.matching : <any>null;
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : <any>null;
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>null;
        data["donor"] = this.donor ? this.donor.toJSON() : <any>null;
        data["donationBatch"] = this.donationBatch ? this.donationBatch.toJSON() : <any>null;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): Donation {
        const json = this.toJSON();
        let result = new Donation();
        result.init(json);
        return result;
    }
}

export interface IDonation extends IBaseModel {
    campaignId?: number;
    donorId?: number;
    donationBatchId?: number;
    amount?: number;
    quantity?: number;
    donationDate?: Date | null;
    description?: string | null;
    isThankYouGenerated?: boolean;
    isPotentialMatchingGift?: boolean;
    isDonorAdvisedFund?: boolean;
    isStockGiftReceipt?: boolean;
    matching?: string | null;
    transactionId?: string | null;
    campaign?: Campaign | null;
    donor?: Donor | null;
    donationBatch?: DonationBatch | null;
    details?: DonationDetail[] | null;
}

export class Donor extends BaseModel implements IDonor {
    type?: DonorType;
    organizationName?: string | null;
    prefix?: Prefix | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    suffix?: Suffix | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    emailAddress?: string | null;
    remarks?: string | null;
    latestThankYou?: number | null;
    contactConsent?: boolean;
    donations?: Donation[] | null;
    cases?: Case[] | null;

    constructor(data?: IDonor) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.suffix = _data["suffix"] !== undefined ? _data["suffix"] : <any>null;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.remarks = _data["remarks"] !== undefined ? _data["remarks"] : <any>null;
            this.latestThankYou = _data["latestThankYou"] !== undefined ? _data["latestThankYou"] : <any>null;
            this.contactConsent = _data["contactConsent"] !== undefined ? _data["contactConsent"] : <any>null;
            if (Array.isArray(_data["donations"])) {
                this.donations = [] as any;
                for (let item of _data["donations"])
                    this.donations!.push(Donation.fromJS(item));
            }
            else {
                this.donations = <any>null;
            }
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(Case.fromJS(item));
            }
            else {
                this.cases = <any>null;
            }
        }
    }

    static fromJS(data: any): Donor {
        data = typeof data === 'object' ? data : {};
        let result = new Donor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["prefix"] = this.prefix !== undefined ? this.prefix : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["suffix"] = this.suffix !== undefined ? this.suffix : <any>null;
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["remarks"] = this.remarks !== undefined ? this.remarks : <any>null;
        data["latestThankYou"] = this.latestThankYou !== undefined ? this.latestThankYou : <any>null;
        data["contactConsent"] = this.contactConsent !== undefined ? this.contactConsent : <any>null;
        if (Array.isArray(this.donations)) {
            data["donations"] = [];
            for (let item of this.donations)
                data["donations"].push(item.toJSON());
        }
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): Donor {
        const json = this.toJSON();
        let result = new Donor();
        result.init(json);
        return result;
    }
}

export interface IDonor extends IBaseModel {
    type?: DonorType;
    organizationName?: string | null;
    prefix?: Prefix | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    suffix?: Suffix | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    emailAddress?: string | null;
    remarks?: string | null;
    latestThankYou?: number | null;
    contactConsent?: boolean;
    donations?: Donation[] | null;
    cases?: Case[] | null;
}

export enum DonorType {
    Individual = "Individual",
    Organization = "Organization",
    Business = "Business",
    BusinessMatching = "BusinessMatching",
    School = "School",
    Club = "Club",
    Church = "Church",
    Foundation = "Foundation",
    Trust = "Trust",
}

export enum Prefix {
    Ms = "Ms",
    Miss = "Miss",
    Mrs = "Mrs",
    Mr = "Mr",
    Rev = "Rev",
    Dr = "Dr",
    Prof = "Prof",
}

export enum Suffix {
    Sr = "Sr",
    Jr = "Jr",
    I = "I",
    II = "II",
    III = "III",
}

export class DonationBatch extends BaseModel implements IDonationBatch {
    batchDate?: Date;
    batchId?: number;
    batchNumber?: string | null;
    controlAmountTotal?: number;
    enteredAmountTotal?: number;
    controlCountItems?: number;
    enteredCountItems?: number;
    status?: DonationStatusType;
    type?: DonationBatchType;
    donations?: Donation[] | null;

    constructor(data?: IDonationBatch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.batchDate = _data["batchDate"] ? new Date(_data["batchDate"].toString()) : <any>null;
            this.batchId = _data["batchId"] !== undefined ? _data["batchId"] : <any>null;
            this.batchNumber = _data["batchNumber"] !== undefined ? _data["batchNumber"] : <any>null;
            this.controlAmountTotal = _data["controlAmountTotal"] !== undefined ? _data["controlAmountTotal"] : <any>null;
            this.enteredAmountTotal = _data["enteredAmountTotal"] !== undefined ? _data["enteredAmountTotal"] : <any>null;
            this.controlCountItems = _data["controlCountItems"] !== undefined ? _data["controlCountItems"] : <any>null;
            this.enteredCountItems = _data["enteredCountItems"] !== undefined ? _data["enteredCountItems"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            if (Array.isArray(_data["donations"])) {
                this.donations = [] as any;
                for (let item of _data["donations"])
                    this.donations!.push(Donation.fromJS(item));
            }
            else {
                this.donations = <any>null;
            }
        }
    }

    static fromJS(data: any): DonationBatch {
        data = typeof data === 'object' ? data : {};
        let result = new DonationBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchDate"] = this.batchDate ? this.batchDate.toISOString() : <any>null;
        data["batchId"] = this.batchId !== undefined ? this.batchId : <any>null;
        data["batchNumber"] = this.batchNumber !== undefined ? this.batchNumber : <any>null;
        data["controlAmountTotal"] = this.controlAmountTotal !== undefined ? this.controlAmountTotal : <any>null;
        data["enteredAmountTotal"] = this.enteredAmountTotal !== undefined ? this.enteredAmountTotal : <any>null;
        data["controlCountItems"] = this.controlCountItems !== undefined ? this.controlCountItems : <any>null;
        data["enteredCountItems"] = this.enteredCountItems !== undefined ? this.enteredCountItems : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        if (Array.isArray(this.donations)) {
            data["donations"] = [];
            for (let item of this.donations)
                data["donations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): DonationBatch {
        const json = this.toJSON();
        let result = new DonationBatch();
        result.init(json);
        return result;
    }
}

export interface IDonationBatch extends IBaseModel {
    batchDate?: Date;
    batchId?: number;
    batchNumber?: string | null;
    controlAmountTotal?: number;
    enteredAmountTotal?: number;
    controlCountItems?: number;
    enteredCountItems?: number;
    status?: DonationStatusType;
    type?: DonationBatchType;
    donations?: Donation[] | null;
}

export enum DonationStatusType {
    New = "New",
    Open = "Open",
    Locked = "Locked",
    Unlocked = "Unlocked",
}

export enum DonationBatchType {
    LockBox = "LockBox",
    CreditCard = "CreditCard",
    Other = "Other",
}

export class GetAllocationsResponse implements IGetAllocationsResponse {
    allocations?: AllocationViewModel[] | null;

    constructor(data?: IGetAllocationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(AllocationViewModel.fromJS(item));
            }
            else {
                this.allocations = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAllocationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllocationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllocationsResponse {
        const json = this.toJSON();
        let result = new GetAllocationsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllocationsResponse {
    allocations?: AllocationViewModel[] | null;
}

export class AllocationViewModel implements IAllocationViewModel {
    campaignId?: number | null;
    type?: AllocationType;
    totalAmount?: number;
    amountPerAllocator?: number | null;
    caseSpecificCost?: number;
    nonAgencyCost?: number;
    postDispatchAmount?: number;
    postDispatchCasesCount?: number;
    totalDistributed?: number;
    netFundsAvailable?: number | null;
    distributedDate?: Date | null;
    deadlineDate?: Date | null;
    campaign?: CampaignViewModel | null;
    details?: AllocationDetailViewModel[] | null;

    constructor(data?: IAllocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : <any>null;
            this.amountPerAllocator = _data["amountPerAllocator"] !== undefined ? _data["amountPerAllocator"] : <any>null;
            this.caseSpecificCost = _data["caseSpecificCost"] !== undefined ? _data["caseSpecificCost"] : <any>null;
            this.nonAgencyCost = _data["nonAgencyCost"] !== undefined ? _data["nonAgencyCost"] : <any>null;
            this.postDispatchAmount = _data["postDispatchAmount"] !== undefined ? _data["postDispatchAmount"] : <any>null;
            this.postDispatchCasesCount = _data["postDispatchCasesCount"] !== undefined ? _data["postDispatchCasesCount"] : <any>null;
            this.totalDistributed = _data["totalDistributed"] !== undefined ? _data["totalDistributed"] : <any>null;
            this.netFundsAvailable = _data["netFundsAvailable"] !== undefined ? _data["netFundsAvailable"] : <any>null;
            this.distributedDate = _data["distributedDate"] ? new Date(_data["distributedDate"].toString()) : <any>null;
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : <any>null;
            this.campaign = _data["campaign"] ? CampaignViewModel.fromJS(_data["campaign"]) : <any>null;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(AllocationDetailViewModel.fromJS(item));
            }
            else {
                this.details = <any>null;
            }
        }
    }

    static fromJS(data: any): AllocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AllocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : <any>null;
        data["amountPerAllocator"] = this.amountPerAllocator !== undefined ? this.amountPerAllocator : <any>null;
        data["caseSpecificCost"] = this.caseSpecificCost !== undefined ? this.caseSpecificCost : <any>null;
        data["nonAgencyCost"] = this.nonAgencyCost !== undefined ? this.nonAgencyCost : <any>null;
        data["postDispatchAmount"] = this.postDispatchAmount !== undefined ? this.postDispatchAmount : <any>null;
        data["postDispatchCasesCount"] = this.postDispatchCasesCount !== undefined ? this.postDispatchCasesCount : <any>null;
        data["totalDistributed"] = this.totalDistributed !== undefined ? this.totalDistributed : <any>null;
        data["netFundsAvailable"] = this.netFundsAvailable !== undefined ? this.netFundsAvailable : <any>null;
        data["distributedDate"] = this.distributedDate ? this.distributedDate.toISOString() : <any>null;
        data["deadlineDate"] = this.deadlineDate ? this.deadlineDate.toISOString() : <any>null;
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>null;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }

    clone(): AllocationViewModel {
        const json = this.toJSON();
        let result = new AllocationViewModel();
        result.init(json);
        return result;
    }
}

export interface IAllocationViewModel {
    campaignId?: number | null;
    type?: AllocationType;
    totalAmount?: number;
    amountPerAllocator?: number | null;
    caseSpecificCost?: number;
    nonAgencyCost?: number;
    postDispatchAmount?: number;
    postDispatchCasesCount?: number;
    totalDistributed?: number;
    netFundsAvailable?: number | null;
    distributedDate?: Date | null;
    deadlineDate?: Date | null;
    campaign?: CampaignViewModel | null;
    details?: AllocationDetailViewModel[] | null;
}

export class CampaignViewModel implements ICampaignViewModel {
    id?: number;
    campaignYear?: number;
    isActive?: boolean;
    isFrozen?: boolean | null;
    createdDate?: Date | null;
    deactivatedDate?: Date | null;

    constructor(data?: ICampaignViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.campaignYear = _data["campaignYear"] !== undefined ? _data["campaignYear"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.isFrozen = _data["isFrozen"] !== undefined ? _data["isFrozen"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.deactivatedDate = _data["deactivatedDate"] ? new Date(_data["deactivatedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): CampaignViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["campaignYear"] = this.campaignYear !== undefined ? this.campaignYear : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isFrozen"] = this.isFrozen !== undefined ? this.isFrozen : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["deactivatedDate"] = this.deactivatedDate ? this.deactivatedDate.toISOString() : <any>null;
        return data;
    }

    clone(): CampaignViewModel {
        const json = this.toJSON();
        let result = new CampaignViewModel();
        result.init(json);
        return result;
    }
}

export interface ICampaignViewModel {
    id?: number;
    campaignYear?: number;
    isActive?: boolean;
    isFrozen?: boolean | null;
    createdDate?: Date | null;
    deactivatedDate?: Date | null;
}

export class AllocationDetailViewModel implements IAllocationDetailViewModel {
    allocationId?: number;
    caseId?: number;
    isAllocated?: boolean;
    distribution1?: number;
    distribution2?: number | null;
    case?: CaseViewModel | null;

    constructor(data?: IAllocationDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allocationId = _data["allocationId"] !== undefined ? _data["allocationId"] : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.isAllocated = _data["isAllocated"] !== undefined ? _data["isAllocated"] : <any>null;
            this.distribution1 = _data["distribution1"] !== undefined ? _data["distribution1"] : <any>null;
            this.distribution2 = _data["distribution2"] !== undefined ? _data["distribution2"] : <any>null;
            this.case = _data["case"] ? CaseViewModel.fromJS(_data["case"]) : <any>null;
        }
    }

    static fromJS(data: any): AllocationDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AllocationDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocationId"] = this.allocationId !== undefined ? this.allocationId : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["isAllocated"] = this.isAllocated !== undefined ? this.isAllocated : <any>null;
        data["distribution1"] = this.distribution1 !== undefined ? this.distribution1 : <any>null;
        data["distribution2"] = this.distribution2 !== undefined ? this.distribution2 : <any>null;
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        return data;
    }

    clone(): AllocationDetailViewModel {
        const json = this.toJSON();
        let result = new AllocationDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IAllocationDetailViewModel {
    allocationId?: number;
    caseId?: number;
    isAllocated?: boolean;
    distribution1?: number;
    distribution2?: number | null;
    case?: CaseViewModel | null;
}

export class CaseViewModel implements ICaseViewModel {
    id?: number;
    createdDate?: Date | null;
    campaignId?: number | null;
    campaignYear?: number | null;
    caseNumber?: string | null;
    client?: ClientViewModel | null;
    clientId?: number | null;
    appealLevel?: AppealLevel | null;
    status?: Status;
    neediestFlag?: boolean | null;
    caseWorkerName?: string | null;
    caseWorkerPhone?: string | null;
    story?: string | null;
    postDispatchNumber?: number | null;
    disburseTo?: string | null;
    allocator?: UserViewModel | null;
    allocatorId?: number | null;
    agency?: AgencyViewModel | null;
    agencyId?: number | null;
    coreCategory?: string | null;
    income?: IncomeViewModel[] | null;
    expenses?: ExpenseViewModel[] | null;
    needs?: NeedViewModel[] | null;
    family?: FamilyMemberViewModel[] | null;
    donor?: DonorViewModel | null;
    donorId?: number | null;
    likeCount?: number | null;
    likedByCurrentUser?: boolean | null;

    constructor(data?: ICaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
            this.campaignYear = _data["campaignYear"] !== undefined ? _data["campaignYear"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.client = _data["client"] ? ClientViewModel.fromJS(_data["client"]) : <any>null;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : <any>null;
            this.appealLevel = _data["appealLevel"] !== undefined ? _data["appealLevel"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.neediestFlag = _data["neediestFlag"] !== undefined ? _data["neediestFlag"] : <any>null;
            this.caseWorkerName = _data["caseWorkerName"] !== undefined ? _data["caseWorkerName"] : <any>null;
            this.caseWorkerPhone = _data["caseWorkerPhone"] !== undefined ? _data["caseWorkerPhone"] : <any>null;
            this.story = _data["story"] !== undefined ? _data["story"] : <any>null;
            this.postDispatchNumber = _data["postDispatchNumber"] !== undefined ? _data["postDispatchNumber"] : <any>null;
            this.disburseTo = _data["disburseTo"] !== undefined ? _data["disburseTo"] : <any>null;
            this.allocator = _data["allocator"] ? UserViewModel.fromJS(_data["allocator"]) : <any>null;
            this.allocatorId = _data["allocatorId"] !== undefined ? _data["allocatorId"] : <any>null;
            this.agency = _data["agency"] ? AgencyViewModel.fromJS(_data["agency"]) : <any>null;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : <any>null;
            this.coreCategory = _data["coreCategory"] !== undefined ? _data["coreCategory"] : <any>null;
            if (Array.isArray(_data["income"])) {
                this.income = [] as any;
                for (let item of _data["income"])
                    this.income!.push(IncomeViewModel.fromJS(item));
            }
            else {
                this.income = <any>null;
            }
            if (Array.isArray(_data["expenses"])) {
                this.expenses = [] as any;
                for (let item of _data["expenses"])
                    this.expenses!.push(ExpenseViewModel.fromJS(item));
            }
            else {
                this.expenses = <any>null;
            }
            if (Array.isArray(_data["needs"])) {
                this.needs = [] as any;
                for (let item of _data["needs"])
                    this.needs!.push(NeedViewModel.fromJS(item));
            }
            else {
                this.needs = <any>null;
            }
            if (Array.isArray(_data["family"])) {
                this.family = [] as any;
                for (let item of _data["family"])
                    this.family!.push(FamilyMemberViewModel.fromJS(item));
            }
            else {
                this.family = <any>null;
            }
            this.donor = _data["donor"] ? DonorViewModel.fromJS(_data["donor"]) : <any>null;
            this.donorId = _data["donorId"] !== undefined ? _data["donorId"] : <any>null;
            this.likeCount = _data["likeCount"] !== undefined ? _data["likeCount"] : <any>null;
            this.likedByCurrentUser = _data["likedByCurrentUser"] !== undefined ? _data["likedByCurrentUser"] : <any>null;
        }
    }

    static fromJS(data: any): CaseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        data["campaignYear"] = this.campaignYear !== undefined ? this.campaignYear : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["clientId"] = this.clientId !== undefined ? this.clientId : <any>null;
        data["appealLevel"] = this.appealLevel !== undefined ? this.appealLevel : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["neediestFlag"] = this.neediestFlag !== undefined ? this.neediestFlag : <any>null;
        data["caseWorkerName"] = this.caseWorkerName !== undefined ? this.caseWorkerName : <any>null;
        data["caseWorkerPhone"] = this.caseWorkerPhone !== undefined ? this.caseWorkerPhone : <any>null;
        data["story"] = this.story !== undefined ? this.story : <any>null;
        data["postDispatchNumber"] = this.postDispatchNumber !== undefined ? this.postDispatchNumber : <any>null;
        data["disburseTo"] = this.disburseTo !== undefined ? this.disburseTo : <any>null;
        data["allocator"] = this.allocator ? this.allocator.toJSON() : <any>null;
        data["allocatorId"] = this.allocatorId !== undefined ? this.allocatorId : <any>null;
        data["agency"] = this.agency ? this.agency.toJSON() : <any>null;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : <any>null;
        data["coreCategory"] = this.coreCategory !== undefined ? this.coreCategory : <any>null;
        if (Array.isArray(this.income)) {
            data["income"] = [];
            for (let item of this.income)
                data["income"].push(item.toJSON());
        }
        if (Array.isArray(this.expenses)) {
            data["expenses"] = [];
            for (let item of this.expenses)
                data["expenses"].push(item.toJSON());
        }
        if (Array.isArray(this.needs)) {
            data["needs"] = [];
            for (let item of this.needs)
                data["needs"].push(item.toJSON());
        }
        if (Array.isArray(this.family)) {
            data["family"] = [];
            for (let item of this.family)
                data["family"].push(item.toJSON());
        }
        data["donor"] = this.donor ? this.donor.toJSON() : <any>null;
        data["donorId"] = this.donorId !== undefined ? this.donorId : <any>null;
        data["likeCount"] = this.likeCount !== undefined ? this.likeCount : <any>null;
        data["likedByCurrentUser"] = this.likedByCurrentUser !== undefined ? this.likedByCurrentUser : <any>null;
        return data;
    }

    clone(): CaseViewModel {
        const json = this.toJSON();
        let result = new CaseViewModel();
        result.init(json);
        return result;
    }
}

export interface ICaseViewModel {
    id?: number;
    createdDate?: Date | null;
    campaignId?: number | null;
    campaignYear?: number | null;
    caseNumber?: string | null;
    client?: ClientViewModel | null;
    clientId?: number | null;
    appealLevel?: AppealLevel | null;
    status?: Status;
    neediestFlag?: boolean | null;
    caseWorkerName?: string | null;
    caseWorkerPhone?: string | null;
    story?: string | null;
    postDispatchNumber?: number | null;
    disburseTo?: string | null;
    allocator?: UserViewModel | null;
    allocatorId?: number | null;
    agency?: AgencyViewModel | null;
    agencyId?: number | null;
    coreCategory?: string | null;
    income?: IncomeViewModel[] | null;
    expenses?: ExpenseViewModel[] | null;
    needs?: NeedViewModel[] | null;
    family?: FamilyMemberViewModel[] | null;
    donor?: DonorViewModel | null;
    donorId?: number | null;
    likeCount?: number | null;
    likedByCurrentUser?: boolean | null;
}

export class ClientViewModel implements IClientViewModel {
    id?: number | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    unhashedSsn?: string | null;
    ssnHash?: string | null;
    lastFourSSN?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    gender?: string | null;
    dateOfBirth?: Date | null;
    phone?: string | null;
    email?: string | null;
    adultsInHousehold?: number | null;
    childrenInHousehold?: number | null;
    disabilities?: DisabilityViewModel[] | null;

    constructor(data?: IClientViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.unhashedSsn = _data["unhashedSsn"] !== undefined ? _data["unhashedSsn"] : <any>null;
            this.ssnHash = _data["ssnHash"] !== undefined ? _data["ssnHash"] : <any>null;
            this.lastFourSSN = _data["lastFourSSN"] !== undefined ? _data["lastFourSSN"] : <any>null;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.adultsInHousehold = _data["adultsInHousehold"] !== undefined ? _data["adultsInHousehold"] : <any>null;
            this.childrenInHousehold = _data["childrenInHousehold"] !== undefined ? _data["childrenInHousehold"] : <any>null;
            if (Array.isArray(_data["disabilities"])) {
                this.disabilities = [] as any;
                for (let item of _data["disabilities"])
                    this.disabilities!.push(DisabilityViewModel.fromJS(item));
            }
            else {
                this.disabilities = <any>null;
            }
        }
    }

    static fromJS(data: any): ClientViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["unhashedSsn"] = this.unhashedSsn !== undefined ? this.unhashedSsn : <any>null;
        data["ssnHash"] = this.ssnHash !== undefined ? this.ssnHash : <any>null;
        data["lastFourSSN"] = this.lastFourSSN !== undefined ? this.lastFourSSN : <any>null;
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["adultsInHousehold"] = this.adultsInHousehold !== undefined ? this.adultsInHousehold : <any>null;
        data["childrenInHousehold"] = this.childrenInHousehold !== undefined ? this.childrenInHousehold : <any>null;
        if (Array.isArray(this.disabilities)) {
            data["disabilities"] = [];
            for (let item of this.disabilities)
                data["disabilities"].push(item.toJSON());
        }
        return data;
    }

    clone(): ClientViewModel {
        const json = this.toJSON();
        let result = new ClientViewModel();
        result.init(json);
        return result;
    }
}

export interface IClientViewModel {
    id?: number | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    unhashedSsn?: string | null;
    ssnHash?: string | null;
    lastFourSSN?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    gender?: string | null;
    dateOfBirth?: Date | null;
    phone?: string | null;
    email?: string | null;
    adultsInHousehold?: number | null;
    childrenInHousehold?: number | null;
    disabilities?: DisabilityViewModel[] | null;
}

export class DisabilityViewModel implements IDisabilityViewModel {
    id?: number | null;
    type?: DisabilityType | null;
    description?: string | null;

    constructor(data?: IDisabilityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): DisabilityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DisabilityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }

    clone(): DisabilityViewModel {
        const json = this.toJSON();
        let result = new DisabilityViewModel();
        result.init(json);
        return result;
    }
}

export interface IDisabilityViewModel {
    id?: number | null;
    type?: DisabilityType | null;
    description?: string | null;
}

export class IncomeViewModel implements IIncomeViewModel {
    id?: number | null;
    type?: IncomeType | null;
    description?: string | null;
    amount?: number | null;

    constructor(data?: IIncomeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): IncomeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }

    clone(): IncomeViewModel {
        const json = this.toJSON();
        let result = new IncomeViewModel();
        result.init(json);
        return result;
    }
}

export interface IIncomeViewModel {
    id?: number | null;
    type?: IncomeType | null;
    description?: string | null;
    amount?: number | null;
}

export class ExpenseViewModel implements IExpenseViewModel {
    id?: number | null;
    type?: ExpenseType | null;
    description?: string | null;
    amount?: number | null;

    constructor(data?: IExpenseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): ExpenseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }

    clone(): ExpenseViewModel {
        const json = this.toJSON();
        let result = new ExpenseViewModel();
        result.init(json);
        return result;
    }
}

export interface IExpenseViewModel {
    id?: number | null;
    type?: ExpenseType | null;
    description?: string | null;
    amount?: number | null;
}

export class NeedViewModel implements INeedViewModel {
    id?: number | null;
    type?: NeedType | null;
    description?: string | null;
    quantity?: number | null;

    constructor(data?: INeedViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
        }
    }

    static fromJS(data: any): NeedViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NeedViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        return data;
    }

    clone(): NeedViewModel {
        const json = this.toJSON();
        let result = new NeedViewModel();
        result.init(json);
        return result;
    }
}

export interface INeedViewModel {
    id?: number | null;
    type?: NeedType | null;
    description?: string | null;
    quantity?: number | null;
}

export class FamilyMemberViewModel implements IFamilyMemberViewModel {
    id?: number | null;
    firstName?: string | null;
    lastName?: string | null;
    age?: number | null;
    gender?: string | null;
    relationship?: RelationshipType | null;
    clothingSize?: string | null;
    clothingSizeType?: ClothingSizeType | null;
    shoeSize?: string | null;
    shoeSizeType?: ClothingSizeType | null;

    constructor(data?: IFamilyMemberViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.age = _data["age"] !== undefined ? _data["age"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.relationship = _data["relationship"] !== undefined ? _data["relationship"] : <any>null;
            this.clothingSize = _data["clothingSize"] !== undefined ? _data["clothingSize"] : <any>null;
            this.clothingSizeType = _data["clothingSizeType"] !== undefined ? _data["clothingSizeType"] : <any>null;
            this.shoeSize = _data["shoeSize"] !== undefined ? _data["shoeSize"] : <any>null;
            this.shoeSizeType = _data["shoeSizeType"] !== undefined ? _data["shoeSizeType"] : <any>null;
        }
    }

    static fromJS(data: any): FamilyMemberViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyMemberViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["relationship"] = this.relationship !== undefined ? this.relationship : <any>null;
        data["clothingSize"] = this.clothingSize !== undefined ? this.clothingSize : <any>null;
        data["clothingSizeType"] = this.clothingSizeType !== undefined ? this.clothingSizeType : <any>null;
        data["shoeSize"] = this.shoeSize !== undefined ? this.shoeSize : <any>null;
        data["shoeSizeType"] = this.shoeSizeType !== undefined ? this.shoeSizeType : <any>null;
        return data;
    }

    clone(): FamilyMemberViewModel {
        const json = this.toJSON();
        let result = new FamilyMemberViewModel();
        result.init(json);
        return result;
    }
}

export interface IFamilyMemberViewModel {
    id?: number | null;
    firstName?: string | null;
    lastName?: string | null;
    age?: number | null;
    gender?: string | null;
    relationship?: RelationshipType | null;
    clothingSize?: string | null;
    clothingSizeType?: ClothingSizeType | null;
    shoeSize?: string | null;
    shoeSizeType?: ClothingSizeType | null;
}

export class DonorViewModel implements IDonorViewModel {
    id?: number | null;
    lastUpdatedDate?: Date | null;
    type?: DonorType;
    organizationName?: string | null;
    prefix?: Prefix | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    suffix?: Suffix | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    emailAddress?: string | null;
    remarks?: string | null;
    latestThankYou?: number | null;
    contactConsent?: boolean;
    latestAdoptionYear?: number | null;

    constructor(data?: IDonorViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? new Date(_data["lastUpdatedDate"].toString()) : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.suffix = _data["suffix"] !== undefined ? _data["suffix"] : <any>null;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.remarks = _data["remarks"] !== undefined ? _data["remarks"] : <any>null;
            this.latestThankYou = _data["latestThankYou"] !== undefined ? _data["latestThankYou"] : <any>null;
            this.contactConsent = _data["contactConsent"] !== undefined ? _data["contactConsent"] : <any>null;
            this.latestAdoptionYear = _data["latestAdoptionYear"] !== undefined ? _data["latestAdoptionYear"] : <any>null;
        }
    }

    static fromJS(data: any): DonorViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DonorViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toISOString() : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["prefix"] = this.prefix !== undefined ? this.prefix : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["suffix"] = this.suffix !== undefined ? this.suffix : <any>null;
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["remarks"] = this.remarks !== undefined ? this.remarks : <any>null;
        data["latestThankYou"] = this.latestThankYou !== undefined ? this.latestThankYou : <any>null;
        data["contactConsent"] = this.contactConsent !== undefined ? this.contactConsent : <any>null;
        data["latestAdoptionYear"] = this.latestAdoptionYear !== undefined ? this.latestAdoptionYear : <any>null;
        return data;
    }

    clone(): DonorViewModel {
        const json = this.toJSON();
        let result = new DonorViewModel();
        result.init(json);
        return result;
    }
}

export interface IDonorViewModel {
    id?: number | null;
    lastUpdatedDate?: Date | null;
    type?: DonorType;
    organizationName?: string | null;
    prefix?: Prefix | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    suffix?: Suffix | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    emailAddress?: string | null;
    remarks?: string | null;
    latestThankYou?: number | null;
    contactConsent?: boolean;
    latestAdoptionYear?: number | null;
}

export class AddAllocationResponse implements IAddAllocationResponse {
    id?: number;

    constructor(data?: IAddAllocationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): AddAllocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddAllocationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): AddAllocationResponse {
        const json = this.toJSON();
        let result = new AddAllocationResponse();
        result.init(json);
        return result;
    }
}

export interface IAddAllocationResponse {
    id?: number;
}

export class AddAllocationRequest implements IAddAllocationRequest {
    allocation?: AllocationViewModel | null;

    constructor(data?: IAddAllocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allocation = _data["allocation"] ? AllocationViewModel.fromJS(_data["allocation"]) : <any>null;
        }
    }

    static fromJS(data: any): AddAllocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddAllocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocation"] = this.allocation ? this.allocation.toJSON() : <any>null;
        return data;
    }

    clone(): AddAllocationRequest {
        const json = this.toJSON();
        let result = new AddAllocationRequest();
        result.init(json);
        return result;
    }
}

export interface IAddAllocationRequest {
    allocation?: AllocationViewModel | null;
}

export class GetDistributeAllocationPreviewResponse implements IGetDistributeAllocationPreviewResponse {
    newCasesCount?: number;
    adoptableCount?: number;
    pendingAdoptionCount?: number;
    adoptedCount?: number;
    totalCasesCount?: number;
    allocatorCount?: number;
    firstAllocationDistributed?: boolean;
    requestedAllocationDistributed?: boolean;

    constructor(data?: IGetDistributeAllocationPreviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newCasesCount = _data["newCasesCount"] !== undefined ? _data["newCasesCount"] : <any>null;
            this.adoptableCount = _data["adoptableCount"] !== undefined ? _data["adoptableCount"] : <any>null;
            this.pendingAdoptionCount = _data["pendingAdoptionCount"] !== undefined ? _data["pendingAdoptionCount"] : <any>null;
            this.adoptedCount = _data["adoptedCount"] !== undefined ? _data["adoptedCount"] : <any>null;
            this.totalCasesCount = _data["totalCasesCount"] !== undefined ? _data["totalCasesCount"] : <any>null;
            this.allocatorCount = _data["allocatorCount"] !== undefined ? _data["allocatorCount"] : <any>null;
            this.firstAllocationDistributed = _data["firstAllocationDistributed"] !== undefined ? _data["firstAllocationDistributed"] : <any>null;
            this.requestedAllocationDistributed = _data["requestedAllocationDistributed"] !== undefined ? _data["requestedAllocationDistributed"] : <any>null;
        }
    }

    static fromJS(data: any): GetDistributeAllocationPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDistributeAllocationPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newCasesCount"] = this.newCasesCount !== undefined ? this.newCasesCount : <any>null;
        data["adoptableCount"] = this.adoptableCount !== undefined ? this.adoptableCount : <any>null;
        data["pendingAdoptionCount"] = this.pendingAdoptionCount !== undefined ? this.pendingAdoptionCount : <any>null;
        data["adoptedCount"] = this.adoptedCount !== undefined ? this.adoptedCount : <any>null;
        data["totalCasesCount"] = this.totalCasesCount !== undefined ? this.totalCasesCount : <any>null;
        data["allocatorCount"] = this.allocatorCount !== undefined ? this.allocatorCount : <any>null;
        data["firstAllocationDistributed"] = this.firstAllocationDistributed !== undefined ? this.firstAllocationDistributed : <any>null;
        data["requestedAllocationDistributed"] = this.requestedAllocationDistributed !== undefined ? this.requestedAllocationDistributed : <any>null;
        return data;
    }

    clone(): GetDistributeAllocationPreviewResponse {
        const json = this.toJSON();
        let result = new GetDistributeAllocationPreviewResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDistributeAllocationPreviewResponse {
    newCasesCount?: number;
    adoptableCount?: number;
    pendingAdoptionCount?: number;
    adoptedCount?: number;
    totalCasesCount?: number;
    allocatorCount?: number;
    firstAllocationDistributed?: boolean;
    requestedAllocationDistributed?: boolean;
}

export class DistributeAllocationsResponse implements IDistributeAllocationsResponse {

    constructor(data?: IDistributeAllocationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DistributeAllocationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DistributeAllocationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): DistributeAllocationsResponse {
        const json = this.toJSON();
        let result = new DistributeAllocationsResponse();
        result.init(json);
        return result;
    }
}

export interface IDistributeAllocationsResponse {
}

export class GetAllocationDistributedStatusResponse implements IGetAllocationDistributedStatusResponse {
    isCreated?: boolean;
    isDistributed?: boolean;

    constructor(data?: IGetAllocationDistributedStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCreated = _data["isCreated"] !== undefined ? _data["isCreated"] : <any>null;
            this.isDistributed = _data["isDistributed"] !== undefined ? _data["isDistributed"] : <any>null;
        }
    }

    static fromJS(data: any): GetAllocationDistributedStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllocationDistributedStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : <any>null;
        data["isDistributed"] = this.isDistributed !== undefined ? this.isDistributed : <any>null;
        return data;
    }

    clone(): GetAllocationDistributedStatusResponse {
        const json = this.toJSON();
        let result = new GetAllocationDistributedStatusResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllocationDistributedStatusResponse {
    isCreated?: boolean;
    isDistributed?: boolean;
}

export class GetAllocatorsResponse implements IGetAllocatorsResponse {
    allocators?: UserViewModel[] | null;

    constructor(data?: IGetAllocatorsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allocators"])) {
                this.allocators = [] as any;
                for (let item of _data["allocators"])
                    this.allocators!.push(UserViewModel.fromJS(item));
            }
            else {
                this.allocators = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAllocatorsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllocatorsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allocators)) {
            data["allocators"] = [];
            for (let item of this.allocators)
                data["allocators"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllocatorsResponse {
        const json = this.toJSON();
        let result = new GetAllocatorsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllocatorsResponse {
    allocators?: UserViewModel[] | null;
}

export class GetAllocatorsOverviewResponse implements IGetAllocatorsOverviewResponse {
    allocators?: AllocatorOverviewViewModel[] | null;

    constructor(data?: IGetAllocatorsOverviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allocators"])) {
                this.allocators = [] as any;
                for (let item of _data["allocators"])
                    this.allocators!.push(AllocatorOverviewViewModel.fromJS(item));
            }
            else {
                this.allocators = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAllocatorsOverviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllocatorsOverviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allocators)) {
            data["allocators"] = [];
            for (let item of this.allocators)
                data["allocators"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllocatorsOverviewResponse {
        const json = this.toJSON();
        let result = new GetAllocatorsOverviewResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllocatorsOverviewResponse {
    allocators?: AllocatorOverviewViewModel[] | null;
}

export class AllocatorOverviewViewModel implements IAllocatorOverviewViewModel {
    id?: number;
    fullName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    totalCases?: number;
    maxAllocation?: number;
    distributedAmount?: number;
    balanceAmount?: number;

    constructor(data?: IAllocatorOverviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.totalCases = _data["totalCases"] !== undefined ? _data["totalCases"] : <any>null;
            this.maxAllocation = _data["maxAllocation"] !== undefined ? _data["maxAllocation"] : <any>null;
            this.distributedAmount = _data["distributedAmount"] !== undefined ? _data["distributedAmount"] : <any>null;
            this.balanceAmount = _data["balanceAmount"] !== undefined ? _data["balanceAmount"] : <any>null;
        }
    }

    static fromJS(data: any): AllocatorOverviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AllocatorOverviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["totalCases"] = this.totalCases !== undefined ? this.totalCases : <any>null;
        data["maxAllocation"] = this.maxAllocation !== undefined ? this.maxAllocation : <any>null;
        data["distributedAmount"] = this.distributedAmount !== undefined ? this.distributedAmount : <any>null;
        data["balanceAmount"] = this.balanceAmount !== undefined ? this.balanceAmount : <any>null;
        return data;
    }

    clone(): AllocatorOverviewViewModel {
        const json = this.toJSON();
        let result = new AllocatorOverviewViewModel();
        result.init(json);
        return result;
    }
}

export interface IAllocatorOverviewViewModel {
    id?: number;
    fullName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    totalCases?: number;
    maxAllocation?: number;
    distributedAmount?: number;
    balanceAmount?: number;
}

export class GetAllocatorWorkingSummaryResponse implements IGetAllocatorWorkingSummaryResponse {
    summary?: AllocatorWorkingSummaryViewModel | null;
    distributionThresholds?: DistributionThresholdViewModel | null;

    constructor(data?: IGetAllocatorWorkingSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? AllocatorWorkingSummaryViewModel.fromJS(_data["summary"]) : <any>null;
            this.distributionThresholds = _data["distributionThresholds"] ? DistributionThresholdViewModel.fromJS(_data["distributionThresholds"]) : <any>null;
        }
    }

    static fromJS(data: any): GetAllocatorWorkingSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllocatorWorkingSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>null;
        data["distributionThresholds"] = this.distributionThresholds ? this.distributionThresholds.toJSON() : <any>null;
        return data;
    }

    clone(): GetAllocatorWorkingSummaryResponse {
        const json = this.toJSON();
        let result = new GetAllocatorWorkingSummaryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllocatorWorkingSummaryResponse {
    summary?: AllocatorWorkingSummaryViewModel | null;
    distributionThresholds?: DistributionThresholdViewModel | null;
}

export class AllocatorWorkingSummaryViewModel implements IAllocatorWorkingSummaryViewModel {
    id?: number | null;
    fullName?: string | null;
    totalCases?: number;
    totalAllocatedCases?: number;
    totalMaxAmount?: number;
    totalDistributedAmount?: number;
    totalBalanceAmount?: number;
    allocationSummaries?: AllocationTypeSummary[] | null;

    constructor(data?: IAllocatorWorkingSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.totalCases = _data["totalCases"] !== undefined ? _data["totalCases"] : <any>null;
            this.totalAllocatedCases = _data["totalAllocatedCases"] !== undefined ? _data["totalAllocatedCases"] : <any>null;
            this.totalMaxAmount = _data["totalMaxAmount"] !== undefined ? _data["totalMaxAmount"] : <any>null;
            this.totalDistributedAmount = _data["totalDistributedAmount"] !== undefined ? _data["totalDistributedAmount"] : <any>null;
            this.totalBalanceAmount = _data["totalBalanceAmount"] !== undefined ? _data["totalBalanceAmount"] : <any>null;
            if (Array.isArray(_data["allocationSummaries"])) {
                this.allocationSummaries = [] as any;
                for (let item of _data["allocationSummaries"])
                    this.allocationSummaries!.push(AllocationTypeSummary.fromJS(item));
            }
            else {
                this.allocationSummaries = <any>null;
            }
        }
    }

    static fromJS(data: any): AllocatorWorkingSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AllocatorWorkingSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["totalCases"] = this.totalCases !== undefined ? this.totalCases : <any>null;
        data["totalAllocatedCases"] = this.totalAllocatedCases !== undefined ? this.totalAllocatedCases : <any>null;
        data["totalMaxAmount"] = this.totalMaxAmount !== undefined ? this.totalMaxAmount : <any>null;
        data["totalDistributedAmount"] = this.totalDistributedAmount !== undefined ? this.totalDistributedAmount : <any>null;
        data["totalBalanceAmount"] = this.totalBalanceAmount !== undefined ? this.totalBalanceAmount : <any>null;
        if (Array.isArray(this.allocationSummaries)) {
            data["allocationSummaries"] = [];
            for (let item of this.allocationSummaries)
                data["allocationSummaries"].push(item.toJSON());
        }
        return data;
    }

    clone(): AllocatorWorkingSummaryViewModel {
        const json = this.toJSON();
        let result = new AllocatorWorkingSummaryViewModel();
        result.init(json);
        return result;
    }
}

export interface IAllocatorWorkingSummaryViewModel {
    id?: number | null;
    fullName?: string | null;
    totalCases?: number;
    totalAllocatedCases?: number;
    totalMaxAmount?: number;
    totalDistributedAmount?: number;
    totalBalanceAmount?: number;
    allocationSummaries?: AllocationTypeSummary[] | null;
}

export class AllocationTypeSummary implements IAllocationTypeSummary {
    id?: number;
    allocationName?: string | null;
    maxAmount?: number;
    distributedAmount?: number;
    balanceAmount?: number;

    constructor(data?: IAllocationTypeSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.allocationName = _data["allocationName"] !== undefined ? _data["allocationName"] : <any>null;
            this.maxAmount = _data["maxAmount"] !== undefined ? _data["maxAmount"] : <any>null;
            this.distributedAmount = _data["distributedAmount"] !== undefined ? _data["distributedAmount"] : <any>null;
            this.balanceAmount = _data["balanceAmount"] !== undefined ? _data["balanceAmount"] : <any>null;
        }
    }

    static fromJS(data: any): AllocationTypeSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AllocationTypeSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["allocationName"] = this.allocationName !== undefined ? this.allocationName : <any>null;
        data["maxAmount"] = this.maxAmount !== undefined ? this.maxAmount : <any>null;
        data["distributedAmount"] = this.distributedAmount !== undefined ? this.distributedAmount : <any>null;
        data["balanceAmount"] = this.balanceAmount !== undefined ? this.balanceAmount : <any>null;
        return data;
    }

    clone(): AllocationTypeSummary {
        const json = this.toJSON();
        let result = new AllocationTypeSummary();
        result.init(json);
        return result;
    }
}

export interface IAllocationTypeSummary {
    id?: number;
    allocationName?: string | null;
    maxAmount?: number;
    distributedAmount?: number;
    balanceAmount?: number;
}

export class DistributionThresholdViewModel implements IDistributionThresholdViewModel {
    minimumDistribution?: number;
    maximumDistribution?: number;

    constructor(data?: IDistributionThresholdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumDistribution = _data["minimumDistribution"] !== undefined ? _data["minimumDistribution"] : <any>null;
            this.maximumDistribution = _data["maximumDistribution"] !== undefined ? _data["maximumDistribution"] : <any>null;
        }
    }

    static fromJS(data: any): DistributionThresholdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DistributionThresholdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumDistribution"] = this.minimumDistribution !== undefined ? this.minimumDistribution : <any>null;
        data["maximumDistribution"] = this.maximumDistribution !== undefined ? this.maximumDistribution : <any>null;
        return data;
    }

    clone(): DistributionThresholdViewModel {
        const json = this.toJSON();
        let result = new DistributionThresholdViewModel();
        result.init(json);
        return result;
    }
}

export interface IDistributionThresholdViewModel {
    minimumDistribution?: number;
    maximumDistribution?: number;
}

export class GetDistributionThresholdsResponse implements IGetDistributionThresholdsResponse {
    thresholds?: DistributionThresholdViewModel | null;

    constructor(data?: IGetDistributionThresholdsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.thresholds = _data["thresholds"] ? DistributionThresholdViewModel.fromJS(_data["thresholds"]) : <any>null;
        }
    }

    static fromJS(data: any): GetDistributionThresholdsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDistributionThresholdsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thresholds"] = this.thresholds ? this.thresholds.toJSON() : <any>null;
        return data;
    }

    clone(): GetDistributionThresholdsResponse {
        const json = this.toJSON();
        let result = new GetDistributionThresholdsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDistributionThresholdsResponse {
    thresholds?: DistributionThresholdViewModel | null;
}

export class UpdateDistributionThresholdsResponse implements IUpdateDistributionThresholdsResponse {
    thresholds?: DistributionThresholdViewModel | null;

    constructor(data?: IUpdateDistributionThresholdsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.thresholds = _data["thresholds"] ? DistributionThresholdViewModel.fromJS(_data["thresholds"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateDistributionThresholdsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDistributionThresholdsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thresholds"] = this.thresholds ? this.thresholds.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateDistributionThresholdsResponse {
        const json = this.toJSON();
        let result = new UpdateDistributionThresholdsResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateDistributionThresholdsResponse {
    thresholds?: DistributionThresholdViewModel | null;
}

export class GetCaseAllocationsResponse implements IGetCaseAllocationsResponse {
    caseAllocations?: CaseAllocationViewModel[] | null;
    hasFirstAllocation?: boolean;
    hasSecondAllocation?: boolean;
    hasThirdAllocation?: boolean;

    constructor(data?: IGetCaseAllocationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["caseAllocations"])) {
                this.caseAllocations = [] as any;
                for (let item of _data["caseAllocations"])
                    this.caseAllocations!.push(CaseAllocationViewModel.fromJS(item));
            }
            else {
                this.caseAllocations = <any>null;
            }
            this.hasFirstAllocation = _data["hasFirstAllocation"] !== undefined ? _data["hasFirstAllocation"] : <any>null;
            this.hasSecondAllocation = _data["hasSecondAllocation"] !== undefined ? _data["hasSecondAllocation"] : <any>null;
            this.hasThirdAllocation = _data["hasThirdAllocation"] !== undefined ? _data["hasThirdAllocation"] : <any>null;
        }
    }

    static fromJS(data: any): GetCaseAllocationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCaseAllocationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caseAllocations)) {
            data["caseAllocations"] = [];
            for (let item of this.caseAllocations)
                data["caseAllocations"].push(item.toJSON());
        }
        data["hasFirstAllocation"] = this.hasFirstAllocation !== undefined ? this.hasFirstAllocation : <any>null;
        data["hasSecondAllocation"] = this.hasSecondAllocation !== undefined ? this.hasSecondAllocation : <any>null;
        data["hasThirdAllocation"] = this.hasThirdAllocation !== undefined ? this.hasThirdAllocation : <any>null;
        return data;
    }

    clone(): GetCaseAllocationsResponse {
        const json = this.toJSON();
        let result = new GetCaseAllocationsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCaseAllocationsResponse {
    caseAllocations?: CaseAllocationViewModel[] | null;
    hasFirstAllocation?: boolean;
    hasSecondAllocation?: boolean;
    hasThirdAllocation?: boolean;
}

export class CaseAllocationViewModel implements ICaseAllocationViewModel {
    allocatorId?: number;
    allocatorName?: string | null;
    caseNumber?: string | null;
    caseId?: number;
    caseStatus?: Status;
    distribute?: boolean;
    firstDistributionAmount?: number;
    isFirstDistributionFinalized?: boolean;
    secondDistributionAmount?: number;
    isSecondDistributionFinalized?: boolean;
    thirdDistributionAmount?: number;
    isThirdDistributionFinalized?: boolean;
    donationsTotal?: number;
    totalAmount?: number;
    isDirty?: boolean;

    constructor(data?: ICaseAllocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allocatorId = _data["allocatorId"] !== undefined ? _data["allocatorId"] : <any>null;
            this.allocatorName = _data["allocatorName"] !== undefined ? _data["allocatorName"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.caseStatus = _data["caseStatus"] !== undefined ? _data["caseStatus"] : <any>null;
            this.distribute = _data["distribute"] !== undefined ? _data["distribute"] : <any>null;
            this.firstDistributionAmount = _data["firstDistributionAmount"] !== undefined ? _data["firstDistributionAmount"] : <any>null;
            this.isFirstDistributionFinalized = _data["isFirstDistributionFinalized"] !== undefined ? _data["isFirstDistributionFinalized"] : <any>null;
            this.secondDistributionAmount = _data["secondDistributionAmount"] !== undefined ? _data["secondDistributionAmount"] : <any>null;
            this.isSecondDistributionFinalized = _data["isSecondDistributionFinalized"] !== undefined ? _data["isSecondDistributionFinalized"] : <any>null;
            this.thirdDistributionAmount = _data["thirdDistributionAmount"] !== undefined ? _data["thirdDistributionAmount"] : <any>null;
            this.isThirdDistributionFinalized = _data["isThirdDistributionFinalized"] !== undefined ? _data["isThirdDistributionFinalized"] : <any>null;
            this.donationsTotal = _data["donationsTotal"] !== undefined ? _data["donationsTotal"] : <any>null;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : <any>null;
            this.isDirty = _data["isDirty"] !== undefined ? _data["isDirty"] : <any>null;
        }
    }

    static fromJS(data: any): CaseAllocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseAllocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocatorId"] = this.allocatorId !== undefined ? this.allocatorId : <any>null;
        data["allocatorName"] = this.allocatorName !== undefined ? this.allocatorName : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["caseStatus"] = this.caseStatus !== undefined ? this.caseStatus : <any>null;
        data["distribute"] = this.distribute !== undefined ? this.distribute : <any>null;
        data["firstDistributionAmount"] = this.firstDistributionAmount !== undefined ? this.firstDistributionAmount : <any>null;
        data["isFirstDistributionFinalized"] = this.isFirstDistributionFinalized !== undefined ? this.isFirstDistributionFinalized : <any>null;
        data["secondDistributionAmount"] = this.secondDistributionAmount !== undefined ? this.secondDistributionAmount : <any>null;
        data["isSecondDistributionFinalized"] = this.isSecondDistributionFinalized !== undefined ? this.isSecondDistributionFinalized : <any>null;
        data["thirdDistributionAmount"] = this.thirdDistributionAmount !== undefined ? this.thirdDistributionAmount : <any>null;
        data["isThirdDistributionFinalized"] = this.isThirdDistributionFinalized !== undefined ? this.isThirdDistributionFinalized : <any>null;
        data["donationsTotal"] = this.donationsTotal !== undefined ? this.donationsTotal : <any>null;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : <any>null;
        data["isDirty"] = this.isDirty !== undefined ? this.isDirty : <any>null;
        return data;
    }

    clone(): CaseAllocationViewModel {
        const json = this.toJSON();
        let result = new CaseAllocationViewModel();
        result.init(json);
        return result;
    }
}

export interface ICaseAllocationViewModel {
    allocatorId?: number;
    allocatorName?: string | null;
    caseNumber?: string | null;
    caseId?: number;
    caseStatus?: Status;
    distribute?: boolean;
    firstDistributionAmount?: number;
    isFirstDistributionFinalized?: boolean;
    secondDistributionAmount?: number;
    isSecondDistributionFinalized?: boolean;
    thirdDistributionAmount?: number;
    isThirdDistributionFinalized?: boolean;
    donationsTotal?: number;
    totalAmount?: number;
    isDirty?: boolean;
}

export class UpdateCaseAllocationsResponse implements IUpdateCaseAllocationsResponse {

    constructor(data?: IUpdateCaseAllocationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateCaseAllocationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseAllocationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateCaseAllocationsResponse {
        const json = this.toJSON();
        let result = new UpdateCaseAllocationsResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateCaseAllocationsResponse {
}

export class UpdateCaseAllocationsRequest implements IUpdateCaseAllocationsRequest {
    finalizeCases?: boolean | null;
    caseAllocations?: CaseAllocationViewModel[] | null;

    constructor(data?: IUpdateCaseAllocationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finalizeCases = _data["finalizeCases"] !== undefined ? _data["finalizeCases"] : <any>null;
            if (Array.isArray(_data["caseAllocations"])) {
                this.caseAllocations = [] as any;
                for (let item of _data["caseAllocations"])
                    this.caseAllocations!.push(CaseAllocationViewModel.fromJS(item));
            }
            else {
                this.caseAllocations = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateCaseAllocationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseAllocationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finalizeCases"] = this.finalizeCases !== undefined ? this.finalizeCases : <any>null;
        if (Array.isArray(this.caseAllocations)) {
            data["caseAllocations"] = [];
            for (let item of this.caseAllocations)
                data["caseAllocations"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateCaseAllocationsRequest {
        const json = this.toJSON();
        let result = new UpdateCaseAllocationsRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateCaseAllocationsRequest {
    finalizeCases?: boolean | null;
    caseAllocations?: CaseAllocationViewModel[] | null;
}

export class GetAllocatorCompletionsResponse implements IGetAllocatorCompletionsResponse {
    completions?: AllocatorCompletionsViewModel | null;

    constructor(data?: IGetAllocatorCompletionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completions = _data["completions"] ? AllocatorCompletionsViewModel.fromJS(_data["completions"]) : <any>null;
        }
    }

    static fromJS(data: any): GetAllocatorCompletionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllocatorCompletionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completions"] = this.completions ? this.completions.toJSON() : <any>null;
        return data;
    }

    clone(): GetAllocatorCompletionsResponse {
        const json = this.toJSON();
        let result = new GetAllocatorCompletionsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllocatorCompletionsResponse {
    completions?: AllocatorCompletionsViewModel | null;
}

export class AllocatorCompletionsViewModel implements IAllocatorCompletionsViewModel {
    allocatorId?: number;
    isFirstFinalized?: boolean;
    isSecondFinalized?: boolean;
    isThirdFinalized?: boolean;

    constructor(data?: IAllocatorCompletionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allocatorId = _data["allocatorId"] !== undefined ? _data["allocatorId"] : <any>null;
            this.isFirstFinalized = _data["isFirstFinalized"] !== undefined ? _data["isFirstFinalized"] : <any>null;
            this.isSecondFinalized = _data["isSecondFinalized"] !== undefined ? _data["isSecondFinalized"] : <any>null;
            this.isThirdFinalized = _data["isThirdFinalized"] !== undefined ? _data["isThirdFinalized"] : <any>null;
        }
    }

    static fromJS(data: any): AllocatorCompletionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AllocatorCompletionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocatorId"] = this.allocatorId !== undefined ? this.allocatorId : <any>null;
        data["isFirstFinalized"] = this.isFirstFinalized !== undefined ? this.isFirstFinalized : <any>null;
        data["isSecondFinalized"] = this.isSecondFinalized !== undefined ? this.isSecondFinalized : <any>null;
        data["isThirdFinalized"] = this.isThirdFinalized !== undefined ? this.isThirdFinalized : <any>null;
        return data;
    }

    clone(): AllocatorCompletionsViewModel {
        const json = this.toJSON();
        let result = new AllocatorCompletionsViewModel();
        result.init(json);
        return result;
    }
}

export interface IAllocatorCompletionsViewModel {
    allocatorId?: number;
    isFirstFinalized?: boolean;
    isSecondFinalized?: boolean;
    isThirdFinalized?: boolean;
}

export class GetCampaignResponse implements IGetCampaignResponse {
    campaign?: CampaignViewModel | null;

    constructor(data?: IGetCampaignResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaign = _data["campaign"] ? CampaignViewModel.fromJS(_data["campaign"]) : <any>null;
        }
    }

    static fromJS(data: any): GetCampaignResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>null;
        return data;
    }

    clone(): GetCampaignResponse {
        const json = this.toJSON();
        let result = new GetCampaignResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCampaignResponse {
    campaign?: CampaignViewModel | null;
}

export class GetCurrentCampaignResponse implements IGetCurrentCampaignResponse {
    campaign?: CampaignViewModel | null;

    constructor(data?: IGetCurrentCampaignResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaign = _data["campaign"] ? CampaignViewModel.fromJS(_data["campaign"]) : <any>null;
        }
    }

    static fromJS(data: any): GetCurrentCampaignResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentCampaignResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>null;
        return data;
    }

    clone(): GetCurrentCampaignResponse {
        const json = this.toJSON();
        let result = new GetCurrentCampaignResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentCampaignResponse {
    campaign?: CampaignViewModel | null;
}

export class AddCampaignResponse implements IAddCampaignResponse {
    id?: number;
    campaignYear?: number;
    success?: boolean;
    alreadyExists?: boolean;

    constructor(data?: IAddCampaignResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.campaignYear = _data["campaignYear"] !== undefined ? _data["campaignYear"] : <any>null;
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.alreadyExists = _data["alreadyExists"] !== undefined ? _data["alreadyExists"] : <any>null;
        }
    }

    static fromJS(data: any): AddCampaignResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddCampaignResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["campaignYear"] = this.campaignYear !== undefined ? this.campaignYear : <any>null;
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["alreadyExists"] = this.alreadyExists !== undefined ? this.alreadyExists : <any>null;
        return data;
    }

    clone(): AddCampaignResponse {
        const json = this.toJSON();
        let result = new AddCampaignResponse();
        result.init(json);
        return result;
    }
}

export interface IAddCampaignResponse {
    id?: number;
    campaignYear?: number;
    success?: boolean;
    alreadyExists?: boolean;
}

export class AddCampaignRequest implements IAddCampaignRequest {
    campaign?: CampaignViewModel | null;

    constructor(data?: IAddCampaignRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaign = _data["campaign"] ? CampaignViewModel.fromJS(_data["campaign"]) : <any>null;
        }
    }

    static fromJS(data: any): AddCampaignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddCampaignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>null;
        return data;
    }

    clone(): AddCampaignRequest {
        const json = this.toJSON();
        let result = new AddCampaignRequest();
        result.init(json);
        return result;
    }
}

export interface IAddCampaignRequest {
    campaign?: CampaignViewModel | null;
}

export class UpdateCampaignFrozenStateResponse implements IUpdateCampaignFrozenStateResponse {

    constructor(data?: IUpdateCampaignFrozenStateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateCampaignFrozenStateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCampaignFrozenStateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateCampaignFrozenStateResponse {
        const json = this.toJSON();
        let result = new UpdateCampaignFrozenStateResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateCampaignFrozenStateResponse {
}

export class GetCampaignFrozenStateResponse implements IGetCampaignFrozenStateResponse {
    isFrozen?: boolean;

    constructor(data?: IGetCampaignFrozenStateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFrozen = _data["isFrozen"] !== undefined ? _data["isFrozen"] : <any>null;
        }
    }

    static fromJS(data: any): GetCampaignFrozenStateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignFrozenStateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFrozen"] = this.isFrozen !== undefined ? this.isFrozen : <any>null;
        return data;
    }

    clone(): GetCampaignFrozenStateResponse {
        const json = this.toJSON();
        let result = new GetCampaignFrozenStateResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCampaignFrozenStateResponse {
    isFrozen?: boolean;
}

export class GetPreviousCampaignResponse implements IGetPreviousCampaignResponse {
    campaign?: CampaignViewModel | null;

    constructor(data?: IGetPreviousCampaignResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaign = _data["campaign"] ? CampaignViewModel.fromJS(_data["campaign"]) : <any>null;
        }
    }

    static fromJS(data: any): GetPreviousCampaignResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPreviousCampaignResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>null;
        return data;
    }

    clone(): GetPreviousCampaignResponse {
        const json = this.toJSON();
        let result = new GetPreviousCampaignResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPreviousCampaignResponse {
    campaign?: CampaignViewModel | null;
}

export class GetCaseResponse implements IGetCaseResponse {
    case?: CaseViewModel | null;
    canCompleteCase?: boolean;

    constructor(data?: IGetCaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.case = _data["case"] ? CaseViewModel.fromJS(_data["case"]) : <any>null;
            this.canCompleteCase = _data["canCompleteCase"] !== undefined ? _data["canCompleteCase"] : <any>null;
        }
    }

    static fromJS(data: any): GetCaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        data["canCompleteCase"] = this.canCompleteCase !== undefined ? this.canCompleteCase : <any>null;
        return data;
    }

    clone(): GetCaseResponse {
        const json = this.toJSON();
        let result = new GetCaseResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCaseResponse {
    case?: CaseViewModel | null;
    canCompleteCase?: boolean;
}

export class GetCasesResponse implements IGetCasesResponse {
    cases?: CaseViewModel[] | null;

    constructor(data?: IGetCasesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(CaseViewModel.fromJS(item));
            }
            else {
                this.cases = <any>null;
            }
        }
    }

    static fromJS(data: any): GetCasesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCasesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetCasesResponse {
        const json = this.toJSON();
        let result = new GetCasesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCasesResponse {
    cases?: CaseViewModel[] | null;
}

export class GetNextCaseIdResponse implements IGetNextCaseIdResponse {
    id?: number;

    constructor(data?: IGetNextCaseIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): GetNextCaseIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNextCaseIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): GetNextCaseIdResponse {
        const json = this.toJSON();
        let result = new GetNextCaseIdResponse();
        result.init(json);
        return result;
    }
}

export interface IGetNextCaseIdResponse {
    id?: number;
}

export class GetCasesCountResponse implements IGetCasesCountResponse {
    counts?: CaseCountViewModel[] | null;

    constructor(data?: IGetCasesCountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["counts"])) {
                this.counts = [] as any;
                for (let item of _data["counts"])
                    this.counts!.push(CaseCountViewModel.fromJS(item));
            }
            else {
                this.counts = <any>null;
            }
        }
    }

    static fromJS(data: any): GetCasesCountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCasesCountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.counts)) {
            data["counts"] = [];
            for (let item of this.counts)
                data["counts"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetCasesCountResponse {
        const json = this.toJSON();
        let result = new GetCasesCountResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCasesCountResponse {
    counts?: CaseCountViewModel[] | null;
}

export class CaseCountViewModel implements ICaseCountViewModel {
    count?: number;
    status?: Status;

    constructor(data?: ICaseCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): CaseCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }

    clone(): CaseCountViewModel {
        const json = this.toJSON();
        let result = new CaseCountViewModel();
        result.init(json);
        return result;
    }
}

export interface ICaseCountViewModel {
    count?: number;
    status?: Status;
}

export class GetPostDispatchCasesResponse implements IGetPostDispatchCasesResponse {
    postDispatchCasePreviews?: PostDispatchCasePreviewViewModel[] | null;

    constructor(data?: IGetPostDispatchCasesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["postDispatchCasePreviews"])) {
                this.postDispatchCasePreviews = [] as any;
                for (let item of _data["postDispatchCasePreviews"])
                    this.postDispatchCasePreviews!.push(PostDispatchCasePreviewViewModel.fromJS(item));
            }
            else {
                this.postDispatchCasePreviews = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPostDispatchCasesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPostDispatchCasesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.postDispatchCasePreviews)) {
            data["postDispatchCasePreviews"] = [];
            for (let item of this.postDispatchCasePreviews)
                data["postDispatchCasePreviews"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetPostDispatchCasesResponse {
        const json = this.toJSON();
        let result = new GetPostDispatchCasesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPostDispatchCasesResponse {
    postDispatchCasePreviews?: PostDispatchCasePreviewViewModel[] | null;
}

export class PostDispatchCasePreviewViewModel implements IPostDispatchCasePreviewViewModel {
    id?: number;
    postDispatchNumber?: number | null;
    caseNumber?: string | null;
    status?: Status;
    appealLevel?: AppealLevel | null;

    constructor(data?: IPostDispatchCasePreviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.postDispatchNumber = _data["postDispatchNumber"] !== undefined ? _data["postDispatchNumber"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.appealLevel = _data["appealLevel"] !== undefined ? _data["appealLevel"] : <any>null;
        }
    }

    static fromJS(data: any): PostDispatchCasePreviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostDispatchCasePreviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["postDispatchNumber"] = this.postDispatchNumber !== undefined ? this.postDispatchNumber : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["appealLevel"] = this.appealLevel !== undefined ? this.appealLevel : <any>null;
        return data;
    }

    clone(): PostDispatchCasePreviewViewModel {
        const json = this.toJSON();
        let result = new PostDispatchCasePreviewViewModel();
        result.init(json);
        return result;
    }
}

export interface IPostDispatchCasePreviewViewModel {
    id?: number;
    postDispatchNumber?: number | null;
    caseNumber?: string | null;
    status?: Status;
    appealLevel?: AppealLevel | null;
}

export class GenerateNewCaseDataResponse implements IGenerateNewCaseDataResponse {
    caseData?: NewCaseData | null;

    constructor(data?: IGenerateNewCaseDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseData = _data["caseData"] ? NewCaseData.fromJS(_data["caseData"]) : <any>null;
        }
    }

    static fromJS(data: any): GenerateNewCaseDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateNewCaseDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseData"] = this.caseData ? this.caseData.toJSON() : <any>null;
        return data;
    }

    clone(): GenerateNewCaseDataResponse {
        const json = this.toJSON();
        let result = new GenerateNewCaseDataResponse();
        result.init(json);
        return result;
    }
}

export interface IGenerateNewCaseDataResponse {
    caseData?: NewCaseData | null;
}

export class NewCaseData implements INewCaseData {
    caseNumber?: string | null;
    id?: number;
    campaignYear?: number;
    campaignYearShort?: string | null;
    campaignId?: number;

    constructor(data?: INewCaseData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.campaignYear = _data["campaignYear"] !== undefined ? _data["campaignYear"] : <any>null;
            this.campaignYearShort = _data["campaignYearShort"] !== undefined ? _data["campaignYearShort"] : <any>null;
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
        }
    }

    static fromJS(data: any): NewCaseData {
        data = typeof data === 'object' ? data : {};
        let result = new NewCaseData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["campaignYear"] = this.campaignYear !== undefined ? this.campaignYear : <any>null;
        data["campaignYearShort"] = this.campaignYearShort !== undefined ? this.campaignYearShort : <any>null;
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        return data;
    }

    clone(): NewCaseData {
        const json = this.toJSON();
        let result = new NewCaseData();
        result.init(json);
        return result;
    }
}

export interface INewCaseData {
    caseNumber?: string | null;
    id?: number;
    campaignYear?: number;
    campaignYearShort?: string | null;
    campaignId?: number;
}

export class SearchCasesResponse implements ISearchCasesResponse {
    resultsLength?: number;
    cases?: CaseViewModel[] | null;

    constructor(data?: ISearchCasesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultsLength = _data["resultsLength"] !== undefined ? _data["resultsLength"] : <any>null;
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(CaseViewModel.fromJS(item));
            }
            else {
                this.cases = <any>null;
            }
        }
    }

    static fromJS(data: any): SearchCasesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCasesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultsLength"] = this.resultsLength !== undefined ? this.resultsLength : <any>null;
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item.toJSON());
        }
        return data;
    }

    clone(): SearchCasesResponse {
        const json = this.toJSON();
        let result = new SearchCasesResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchCasesResponse {
    resultsLength?: number;
    cases?: CaseViewModel[] | null;
}

export class SearchCasesRequest implements ISearchCasesRequest {
    ids?: number[] | null;
    donorId?: number | null;
    status?: Status | null;
    sortOrder?: TableSortOrderType | null;
    pageIndex?: number | null;
    pageSize?: number | null;

    constructor(data?: ISearchCasesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = <any>null;
            }
            this.donorId = _data["donorId"] !== undefined ? _data["donorId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
            this.pageIndex = _data["pageIndex"] !== undefined ? _data["pageIndex"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
        }
    }

    static fromJS(data: any): SearchCasesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCasesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["donorId"] = this.donorId !== undefined ? this.donorId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["pageIndex"] = this.pageIndex !== undefined ? this.pageIndex : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        return data;
    }

    clone(): SearchCasesRequest {
        const json = this.toJSON();
        let result = new SearchCasesRequest();
        result.init(json);
        return result;
    }
}

export interface ISearchCasesRequest {
    ids?: number[] | null;
    donorId?: number | null;
    status?: Status | null;
    sortOrder?: TableSortOrderType | null;
    pageIndex?: number | null;
    pageSize?: number | null;
}

export enum TableSortOrderType {
    CreatedDateAsc = "CreatedDateAsc",
    CreatedDateDesc = "CreatedDateDesc",
    CaseNumberAsc = "CaseNumberAsc",
    CaseNumberDesc = "CaseNumberDesc",
    FirstNameAsc = "FirstNameAsc",
    FirstNameDesc = "FirstNameDesc",
    LastNameAsc = "LastNameAsc",
    LastNameDesc = "LastNameDesc",
    LevelAsc = "LevelAsc",
    LevelDesc = "LevelDesc",
    StatusAsc = "StatusAsc",
    StatusDesc = "StatusDesc",
    CampaignYearAsc = "CampaignYearAsc",
    CampaignYearDesc = "CampaignYearDesc",
}

export class QuickSearchResponse implements IQuickSearchResponse {
    cases?: CaseSearchResult[] | null;

    constructor(data?: IQuickSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(CaseSearchResult.fromJS(item));
            }
            else {
                this.cases = <any>null;
            }
        }
    }

    static fromJS(data: any): QuickSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuickSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item.toJSON());
        }
        return data;
    }

    clone(): QuickSearchResponse {
        const json = this.toJSON();
        let result = new QuickSearchResponse();
        result.init(json);
        return result;
    }
}

export interface IQuickSearchResponse {
    cases?: CaseSearchResult[] | null;
}

export class AdvancedSearchResponse implements IAdvancedSearchResponse {
    cases?: CaseSearchResult[] | null;

    constructor(data?: IAdvancedSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(CaseSearchResult.fromJS(item));
            }
            else {
                this.cases = <any>null;
            }
        }
    }

    static fromJS(data: any): AdvancedSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item.toJSON());
        }
        return data;
    }

    clone(): AdvancedSearchResponse {
        const json = this.toJSON();
        let result = new AdvancedSearchResponse();
        result.init(json);
        return result;
    }
}

export interface IAdvancedSearchResponse {
    cases?: CaseSearchResult[] | null;
}

export class AdvancedSearchRequest implements IAdvancedSearchRequest {
    limit?: number;
    keyword?: string | null;
    caseNumber?: string | null;
    caseId?: number | null;
    coreCategories?: string[] | null;
    allocatorId?: number | null;
    appealLevel?: AppealLevel | null;
    neediestFlag?: boolean | null;
    status?: Status | null;
    agencyId?: number | null;
    excludePostCases?: boolean | null;
    clientName?: string | null;
    clientSSN?: string | null;
    lastFourSSN?: string | null;
    clientAddress?: string | null;
    disabilityType?: DisabilityType | null;
    minChildren?: number | null;
    maxChildren?: number | null;
    minFamily?: number | null;
    maxFamily?: number | null;
    minFamilyAge?: number | null;
    maxFamilyAge?: number | null;
    adoptableOnly?: boolean;
    includeVoidedCases?: boolean | null;

    constructor(data?: IAdvancedSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.keyword = _data["keyword"] !== undefined ? _data["keyword"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            if (Array.isArray(_data["coreCategories"])) {
                this.coreCategories = [] as any;
                for (let item of _data["coreCategories"])
                    this.coreCategories!.push(item);
            }
            else {
                this.coreCategories = <any>null;
            }
            this.allocatorId = _data["allocatorId"] !== undefined ? _data["allocatorId"] : <any>null;
            this.appealLevel = _data["appealLevel"] !== undefined ? _data["appealLevel"] : <any>null;
            this.neediestFlag = _data["neediestFlag"] !== undefined ? _data["neediestFlag"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.agencyId = _data["agencyId"] !== undefined ? _data["agencyId"] : <any>null;
            this.excludePostCases = _data["excludePostCases"] !== undefined ? _data["excludePostCases"] : <any>null;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : <any>null;
            this.clientSSN = _data["clientSSN"] !== undefined ? _data["clientSSN"] : <any>null;
            this.lastFourSSN = _data["lastFourSSN"] !== undefined ? _data["lastFourSSN"] : <any>null;
            this.clientAddress = _data["clientAddress"] !== undefined ? _data["clientAddress"] : <any>null;
            this.disabilityType = _data["disabilityType"] !== undefined ? _data["disabilityType"] : <any>null;
            this.minChildren = _data["minChildren"] !== undefined ? _data["minChildren"] : <any>null;
            this.maxChildren = _data["maxChildren"] !== undefined ? _data["maxChildren"] : <any>null;
            this.minFamily = _data["minFamily"] !== undefined ? _data["minFamily"] : <any>null;
            this.maxFamily = _data["maxFamily"] !== undefined ? _data["maxFamily"] : <any>null;
            this.minFamilyAge = _data["minFamilyAge"] !== undefined ? _data["minFamilyAge"] : <any>null;
            this.maxFamilyAge = _data["maxFamilyAge"] !== undefined ? _data["maxFamilyAge"] : <any>null;
            this.adoptableOnly = _data["adoptableOnly"] !== undefined ? _data["adoptableOnly"] : <any>null;
            this.includeVoidedCases = _data["includeVoidedCases"] !== undefined ? _data["includeVoidedCases"] : <any>null;
        }
    }

    static fromJS(data: any): AdvancedSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["keyword"] = this.keyword !== undefined ? this.keyword : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        if (Array.isArray(this.coreCategories)) {
            data["coreCategories"] = [];
            for (let item of this.coreCategories)
                data["coreCategories"].push(item);
        }
        data["allocatorId"] = this.allocatorId !== undefined ? this.allocatorId : <any>null;
        data["appealLevel"] = this.appealLevel !== undefined ? this.appealLevel : <any>null;
        data["neediestFlag"] = this.neediestFlag !== undefined ? this.neediestFlag : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["agencyId"] = this.agencyId !== undefined ? this.agencyId : <any>null;
        data["excludePostCases"] = this.excludePostCases !== undefined ? this.excludePostCases : <any>null;
        data["clientName"] = this.clientName !== undefined ? this.clientName : <any>null;
        data["clientSSN"] = this.clientSSN !== undefined ? this.clientSSN : <any>null;
        data["lastFourSSN"] = this.lastFourSSN !== undefined ? this.lastFourSSN : <any>null;
        data["clientAddress"] = this.clientAddress !== undefined ? this.clientAddress : <any>null;
        data["disabilityType"] = this.disabilityType !== undefined ? this.disabilityType : <any>null;
        data["minChildren"] = this.minChildren !== undefined ? this.minChildren : <any>null;
        data["maxChildren"] = this.maxChildren !== undefined ? this.maxChildren : <any>null;
        data["minFamily"] = this.minFamily !== undefined ? this.minFamily : <any>null;
        data["maxFamily"] = this.maxFamily !== undefined ? this.maxFamily : <any>null;
        data["minFamilyAge"] = this.minFamilyAge !== undefined ? this.minFamilyAge : <any>null;
        data["maxFamilyAge"] = this.maxFamilyAge !== undefined ? this.maxFamilyAge : <any>null;
        data["adoptableOnly"] = this.adoptableOnly !== undefined ? this.adoptableOnly : <any>null;
        data["includeVoidedCases"] = this.includeVoidedCases !== undefined ? this.includeVoidedCases : <any>null;
        return data;
    }

    clone(): AdvancedSearchRequest {
        const json = this.toJSON();
        let result = new AdvancedSearchRequest();
        result.init(json);
        return result;
    }
}

export interface IAdvancedSearchRequest {
    limit?: number;
    keyword?: string | null;
    caseNumber?: string | null;
    caseId?: number | null;
    coreCategories?: string[] | null;
    allocatorId?: number | null;
    appealLevel?: AppealLevel | null;
    neediestFlag?: boolean | null;
    status?: Status | null;
    agencyId?: number | null;
    excludePostCases?: boolean | null;
    clientName?: string | null;
    clientSSN?: string | null;
    lastFourSSN?: string | null;
    clientAddress?: string | null;
    disabilityType?: DisabilityType | null;
    minChildren?: number | null;
    maxChildren?: number | null;
    minFamily?: number | null;
    maxFamily?: number | null;
    minFamilyAge?: number | null;
    maxFamilyAge?: number | null;
    adoptableOnly?: boolean;
    includeVoidedCases?: boolean | null;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
}

export class ApiError extends ProblemDetails implements IApiError {
    error?: string | null;
    errorKey?: any | null;

    constructor(data?: IApiError) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.error = _data["error"] !== undefined ? _data["error"] : <any>null;
            this.errorKey = _data["errorKey"] !== undefined ? _data["errorKey"] : <any>null;
        }
    }

    static fromJS(data: any): ApiError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error !== undefined ? this.error : <any>null;
        data["errorKey"] = this.errorKey !== undefined ? this.errorKey : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ApiError {
        const json = this.toJSON();
        let result = new ApiError();
        result.init(json);
        return result;
    }
}

export interface IApiError extends IProblemDetails {
    error?: string | null;
    errorKey?: any | null;
}

export class AddCaseRequest implements IAddCaseRequest {
    case?: CaseViewModel | null;
    submitCase?: boolean;

    constructor(data?: IAddCaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.case = _data["case"] ? CaseViewModel.fromJS(_data["case"]) : <any>null;
            this.submitCase = _data["submitCase"] !== undefined ? _data["submitCase"] : <any>null;
        }
    }

    static fromJS(data: any): AddCaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddCaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        data["submitCase"] = this.submitCase !== undefined ? this.submitCase : <any>null;
        return data;
    }

    clone(): AddCaseRequest {
        const json = this.toJSON();
        let result = new AddCaseRequest();
        result.init(json);
        return result;
    }
}

export interface IAddCaseRequest {
    case?: CaseViewModel | null;
    submitCase?: boolean;
}

export class UpdateCaseRequest implements IUpdateCaseRequest {
    case?: CaseViewModel | null;
    unhashedSsn?: string | null;
    hasNewlyCreatedClient?: boolean;

    constructor(data?: IUpdateCaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.case = _data["case"] ? CaseViewModel.fromJS(_data["case"]) : <any>null;
            this.unhashedSsn = _data["unhashedSsn"] !== undefined ? _data["unhashedSsn"] : <any>null;
            this.hasNewlyCreatedClient = _data["hasNewlyCreatedClient"] !== undefined ? _data["hasNewlyCreatedClient"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateCaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        data["unhashedSsn"] = this.unhashedSsn !== undefined ? this.unhashedSsn : <any>null;
        data["hasNewlyCreatedClient"] = this.hasNewlyCreatedClient !== undefined ? this.hasNewlyCreatedClient : <any>null;
        return data;
    }

    clone(): UpdateCaseRequest {
        const json = this.toJSON();
        let result = new UpdateCaseRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateCaseRequest {
    case?: CaseViewModel | null;
    unhashedSsn?: string | null;
    hasNewlyCreatedClient?: boolean;
}

export class UpdateCaseStatusRequest implements IUpdateCaseStatusRequest {
    id?: number;
    caseNumber?: string | null;
    status?: Status;

    constructor(data?: IUpdateCaseStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateCaseStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }

    clone(): UpdateCaseStatusRequest {
        const json = this.toJSON();
        let result = new UpdateCaseStatusRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateCaseStatusRequest {
    id?: number;
    caseNumber?: string | null;
    status?: Status;
}

export class BulkUpdatePostDispatchCaseRequest implements IBulkUpdatePostDispatchCaseRequest {
    postDispatchCaseUpdates?: PostDispatchCaseUpdate[] | null;

    constructor(data?: IBulkUpdatePostDispatchCaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["postDispatchCaseUpdates"])) {
                this.postDispatchCaseUpdates = [] as any;
                for (let item of _data["postDispatchCaseUpdates"])
                    this.postDispatchCaseUpdates!.push(PostDispatchCaseUpdate.fromJS(item));
            }
            else {
                this.postDispatchCaseUpdates = <any>null;
            }
        }
    }

    static fromJS(data: any): BulkUpdatePostDispatchCaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdatePostDispatchCaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.postDispatchCaseUpdates)) {
            data["postDispatchCaseUpdates"] = [];
            for (let item of this.postDispatchCaseUpdates)
                data["postDispatchCaseUpdates"].push(item.toJSON());
        }
        return data;
    }

    clone(): BulkUpdatePostDispatchCaseRequest {
        const json = this.toJSON();
        let result = new BulkUpdatePostDispatchCaseRequest();
        result.init(json);
        return result;
    }
}

export interface IBulkUpdatePostDispatchCaseRequest {
    postDispatchCaseUpdates?: PostDispatchCaseUpdate[] | null;
}

export class PostDispatchCaseUpdate implements IPostDispatchCaseUpdate {
    id?: number;
    postDispatchNumber?: number | null;
    status?: Status | null;

    constructor(data?: IPostDispatchCaseUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.postDispatchNumber = _data["postDispatchNumber"] !== undefined ? _data["postDispatchNumber"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): PostDispatchCaseUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new PostDispatchCaseUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["postDispatchNumber"] = this.postDispatchNumber !== undefined ? this.postDispatchNumber : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }

    clone(): PostDispatchCaseUpdate {
        const json = this.toJSON();
        let result = new PostDispatchCaseUpdate();
        result.init(json);
        return result;
    }
}

export interface IPostDispatchCaseUpdate {
    id?: number;
    postDispatchNumber?: number | null;
    status?: Status | null;
}

export class SearchCaseAndPrimaryContactResponse implements ISearchCaseAndPrimaryContactResponse {
    cases?: CaseAndPrimaryContactViewModel[] | null;

    constructor(data?: ISearchCaseAndPrimaryContactResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(CaseAndPrimaryContactViewModel.fromJS(item));
            }
            else {
                this.cases = <any>null;
            }
        }
    }

    static fromJS(data: any): SearchCaseAndPrimaryContactResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCaseAndPrimaryContactResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item.toJSON());
        }
        return data;
    }

    clone(): SearchCaseAndPrimaryContactResponse {
        const json = this.toJSON();
        let result = new SearchCaseAndPrimaryContactResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchCaseAndPrimaryContactResponse {
    cases?: CaseAndPrimaryContactViewModel[] | null;
}

export class CaseAndPrimaryContactViewModel implements ICaseAndPrimaryContactViewModel {
    case?: CaseViewModel | null;
    primaryContactFullName?: string | null;
    primaryContactPhone?: string | null;
    primaryContactEmail?: string | null;

    constructor(data?: ICaseAndPrimaryContactViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.case = _data["case"] ? CaseViewModel.fromJS(_data["case"]) : <any>null;
            this.primaryContactFullName = _data["primaryContactFullName"] !== undefined ? _data["primaryContactFullName"] : <any>null;
            this.primaryContactPhone = _data["primaryContactPhone"] !== undefined ? _data["primaryContactPhone"] : <any>null;
            this.primaryContactEmail = _data["primaryContactEmail"] !== undefined ? _data["primaryContactEmail"] : <any>null;
        }
    }

    static fromJS(data: any): CaseAndPrimaryContactViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseAndPrimaryContactViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        data["primaryContactFullName"] = this.primaryContactFullName !== undefined ? this.primaryContactFullName : <any>null;
        data["primaryContactPhone"] = this.primaryContactPhone !== undefined ? this.primaryContactPhone : <any>null;
        data["primaryContactEmail"] = this.primaryContactEmail !== undefined ? this.primaryContactEmail : <any>null;
        return data;
    }

    clone(): CaseAndPrimaryContactViewModel {
        const json = this.toJSON();
        let result = new CaseAndPrimaryContactViewModel();
        result.init(json);
        return result;
    }
}

export interface ICaseAndPrimaryContactViewModel {
    case?: CaseViewModel | null;
    primaryContactFullName?: string | null;
    primaryContactPhone?: string | null;
    primaryContactEmail?: string | null;
}

export class SearchCaseAndPrimaryContactRequest implements ISearchCaseAndPrimaryContactRequest {
    ids?: number[] | null;

    constructor(data?: ISearchCaseAndPrimaryContactRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = <any>null;
            }
        }
    }

    static fromJS(data: any): SearchCaseAndPrimaryContactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCaseAndPrimaryContactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }

    clone(): SearchCaseAndPrimaryContactRequest {
        const json = this.toJSON();
        let result = new SearchCaseAndPrimaryContactRequest();
        result.init(json);
        return result;
    }
}

export interface ISearchCaseAndPrimaryContactRequest {
    ids?: number[] | null;
}

export class VoteCaseResponse implements IVoteCaseResponse {
    liked?: boolean;
    count?: number;

    constructor(data?: IVoteCaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liked = _data["liked"] !== undefined ? _data["liked"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): VoteCaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VoteCaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liked"] = this.liked !== undefined ? this.liked : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data;
    }

    clone(): VoteCaseResponse {
        const json = this.toJSON();
        let result = new VoteCaseResponse();
        result.init(json);
        return result;
    }
}

export interface IVoteCaseResponse {
    liked?: boolean;
    count?: number;
}

export class GetClientResponse implements IGetClientResponse {
    client?: ClientViewModel | null;

    constructor(data?: IGetClientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client = _data["client"] ? ClientViewModel.fromJS(_data["client"]) : <any>null;
        }
    }

    static fromJS(data: any): GetClientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        return data;
    }

    clone(): GetClientResponse {
        const json = this.toJSON();
        let result = new GetClientResponse();
        result.init(json);
        return result;
    }
}

export interface IGetClientResponse {
    client?: ClientViewModel | null;
}

export class SearchClientsResponse implements ISearchClientsResponse {
    resultsLength?: number;
    clients?: ClientPreviewViewModel[] | null;

    constructor(data?: ISearchClientsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultsLength = _data["resultsLength"] !== undefined ? _data["resultsLength"] : <any>null;
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(ClientPreviewViewModel.fromJS(item));
            }
            else {
                this.clients = <any>null;
            }
        }
    }

    static fromJS(data: any): SearchClientsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchClientsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultsLength"] = this.resultsLength !== undefined ? this.resultsLength : <any>null;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        return data;
    }

    clone(): SearchClientsResponse {
        const json = this.toJSON();
        let result = new SearchClientsResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchClientsResponse {
    resultsLength?: number;
    clients?: ClientPreviewViewModel[] | null;
}

export class ClientPreviewViewModel implements IClientPreviewViewModel {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    lastFourSsn?: string | null;
    dateOfBirth?: Date;

    constructor(data?: IClientPreviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.lastFourSsn = _data["lastFourSsn"] !== undefined ? _data["lastFourSsn"] : <any>null;
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ClientPreviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPreviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["lastFourSsn"] = this.lastFourSsn !== undefined ? this.lastFourSsn : <any>null;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>null;
        return data;
    }

    clone(): ClientPreviewViewModel {
        const json = this.toJSON();
        let result = new ClientPreviewViewModel();
        result.init(json);
        return result;
    }
}

export interface IClientPreviewViewModel {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    lastFourSsn?: string | null;
    dateOfBirth?: Date;
}

export class AddClientResponse implements IAddClientResponse {
    id?: number;

    constructor(data?: IAddClientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): AddClientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddClientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): AddClientResponse {
        const json = this.toJSON();
        let result = new AddClientResponse();
        result.init(json);
        return result;
    }
}

export interface IAddClientResponse {
    id?: number;
}

export class AddClientRequest implements IAddClientRequest {
    client?: ClientViewModel | null;

    constructor(data?: IAddClientRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client = _data["client"] ? ClientViewModel.fromJS(_data["client"]) : <any>null;
        }
    }

    static fromJS(data: any): AddClientRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddClientRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        return data;
    }

    clone(): AddClientRequest {
        const json = this.toJSON();
        let result = new AddClientRequest();
        result.init(json);
        return result;
    }
}

export interface IAddClientRequest {
    client?: ClientViewModel | null;
}

export class UpdateClientResponse implements IUpdateClientResponse {
    id?: number;
    disabilities?: DisabilityViewModel[] | null;

    constructor(data?: IUpdateClientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["disabilities"])) {
                this.disabilities = [] as any;
                for (let item of _data["disabilities"])
                    this.disabilities!.push(DisabilityViewModel.fromJS(item));
            }
            else {
                this.disabilities = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateClientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.disabilities)) {
            data["disabilities"] = [];
            for (let item of this.disabilities)
                data["disabilities"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateClientResponse {
        const json = this.toJSON();
        let result = new UpdateClientResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateClientResponse {
    id?: number;
    disabilities?: DisabilityViewModel[] | null;
}

export class UpdateClientRequest implements IUpdateClientRequest {
    client?: ClientViewModel | null;

    constructor(data?: IUpdateClientRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client = _data["client"] ? ClientViewModel.fromJS(_data["client"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateClientRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateClientRequest {
        const json = this.toJSON();
        let result = new UpdateClientRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateClientRequest {
    client?: ClientViewModel | null;
}

export class CheckSSNResponse implements ICheckSSNResponse {
    alreadyExists?: boolean;

    constructor(data?: ICheckSSNResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alreadyExists = _data["alreadyExists"] !== undefined ? _data["alreadyExists"] : <any>null;
        }
    }

    static fromJS(data: any): CheckSSNResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckSSNResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alreadyExists"] = this.alreadyExists !== undefined ? this.alreadyExists : <any>null;
        return data;
    }

    clone(): CheckSSNResponse {
        const json = this.toJSON();
        let result = new CheckSSNResponse();
        result.init(json);
        return result;
    }
}

export interface ICheckSSNResponse {
    alreadyExists?: boolean;
}

export class CheckSSNRequest implements ICheckSSNRequest {
    ssn?: string | null;

    constructor(data?: ICheckSSNRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : <any>null;
        }
    }

    static fromJS(data: any): CheckSSNRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckSSNRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssn"] = this.ssn !== undefined ? this.ssn : <any>null;
        return data;
    }

    clone(): CheckSSNRequest {
        const json = this.toJSON();
        let result = new CheckSSNRequest();
        result.init(json);
        return result;
    }
}

export interface ICheckSSNRequest {
    ssn?: string | null;
}

export class CheckHasCaseResponse implements ICheckHasCaseResponse {
    hasCase?: boolean;

    constructor(data?: ICheckHasCaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasCase = _data["hasCase"] !== undefined ? _data["hasCase"] : <any>null;
        }
    }

    static fromJS(data: any): CheckHasCaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckHasCaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasCase"] = this.hasCase !== undefined ? this.hasCase : <any>null;
        return data;
    }

    clone(): CheckHasCaseResponse {
        const json = this.toJSON();
        let result = new CheckHasCaseResponse();
        result.init(json);
        return result;
    }
}

export interface ICheckHasCaseResponse {
    hasCase?: boolean;
}

export class CheckHasCaseRequest implements ICheckHasCaseRequest {
    id?: number | null;

    constructor(data?: ICheckHasCaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): CheckHasCaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckHasCaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): CheckHasCaseRequest {
        const json = this.toJSON();
        let result = new CheckHasCaseRequest();
        result.init(json);
        return result;
    }
}

export interface ICheckHasCaseRequest {
    id?: number | null;
}

export class UpsertDonationBatchResponse implements IUpsertDonationBatchResponse {
    id?: number;
    batchNumber?: string | null;

    constructor(data?: IUpsertDonationBatchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.batchNumber = _data["batchNumber"] !== undefined ? _data["batchNumber"] : <any>null;
        }
    }

    static fromJS(data: any): UpsertDonationBatchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertDonationBatchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["batchNumber"] = this.batchNumber !== undefined ? this.batchNumber : <any>null;
        return data;
    }

    clone(): UpsertDonationBatchResponse {
        const json = this.toJSON();
        let result = new UpsertDonationBatchResponse();
        result.init(json);
        return result;
    }
}

export interface IUpsertDonationBatchResponse {
    id?: number;
    batchNumber?: string | null;
}

export class AddDonationBatchRequest implements IAddDonationBatchRequest {
    donation?: DonationBatchViewModel | null;
    batchNumber?: string | null;

    constructor(data?: IAddDonationBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.donation = _data["donation"] ? DonationBatchViewModel.fromJS(_data["donation"]) : <any>null;
            this.batchNumber = _data["batchNumber"] !== undefined ? _data["batchNumber"] : <any>null;
        }
    }

    static fromJS(data: any): AddDonationBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddDonationBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donation"] = this.donation ? this.donation.toJSON() : <any>null;
        data["batchNumber"] = this.batchNumber !== undefined ? this.batchNumber : <any>null;
        return data;
    }

    clone(): AddDonationBatchRequest {
        const json = this.toJSON();
        let result = new AddDonationBatchRequest();
        result.init(json);
        return result;
    }
}

export interface IAddDonationBatchRequest {
    donation?: DonationBatchViewModel | null;
    batchNumber?: string | null;
}

export class DonationBatchViewModel implements IDonationBatchViewModel {
    id?: number;
    batchDate?: Date;
    batchNumber?: string | null;
    batchId?: number;
    controlAmountTotal?: number;
    controlCountItems?: number;
    enteredAmountTotal?: number;
    enteredCountItems?: number;
    type?: DonationBatchType;
    status?: DonationStatusType;
    donations?: DonationViewModel[] | null;

    constructor(data?: IDonationBatchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.batchDate = _data["batchDate"] ? new Date(_data["batchDate"].toString()) : <any>null;
            this.batchNumber = _data["batchNumber"] !== undefined ? _data["batchNumber"] : <any>null;
            this.batchId = _data["batchId"] !== undefined ? _data["batchId"] : <any>null;
            this.controlAmountTotal = _data["controlAmountTotal"] !== undefined ? _data["controlAmountTotal"] : <any>null;
            this.controlCountItems = _data["controlCountItems"] !== undefined ? _data["controlCountItems"] : <any>null;
            this.enteredAmountTotal = _data["enteredAmountTotal"] !== undefined ? _data["enteredAmountTotal"] : <any>null;
            this.enteredCountItems = _data["enteredCountItems"] !== undefined ? _data["enteredCountItems"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["donations"])) {
                this.donations = [] as any;
                for (let item of _data["donations"])
                    this.donations!.push(DonationViewModel.fromJS(item));
            }
            else {
                this.donations = <any>null;
            }
        }
    }

    static fromJS(data: any): DonationBatchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DonationBatchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["batchDate"] = this.batchDate ? this.batchDate.toISOString() : <any>null;
        data["batchNumber"] = this.batchNumber !== undefined ? this.batchNumber : <any>null;
        data["batchId"] = this.batchId !== undefined ? this.batchId : <any>null;
        data["controlAmountTotal"] = this.controlAmountTotal !== undefined ? this.controlAmountTotal : <any>null;
        data["controlCountItems"] = this.controlCountItems !== undefined ? this.controlCountItems : <any>null;
        data["enteredAmountTotal"] = this.enteredAmountTotal !== undefined ? this.enteredAmountTotal : <any>null;
        data["enteredCountItems"] = this.enteredCountItems !== undefined ? this.enteredCountItems : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.donations)) {
            data["donations"] = [];
            for (let item of this.donations)
                data["donations"].push(item.toJSON());
        }
        return data;
    }

    clone(): DonationBatchViewModel {
        const json = this.toJSON();
        let result = new DonationBatchViewModel();
        result.init(json);
        return result;
    }
}

export interface IDonationBatchViewModel {
    id?: number;
    batchDate?: Date;
    batchNumber?: string | null;
    batchId?: number;
    controlAmountTotal?: number;
    controlCountItems?: number;
    enteredAmountTotal?: number;
    enteredCountItems?: number;
    type?: DonationBatchType;
    status?: DonationStatusType;
    donations?: DonationViewModel[] | null;
}

export class DonationViewModel implements IDonationViewModel {
    id?: number | null;
    campaignId?: number;
    donorId?: number;
    donationBatchId?: number;
    amount?: number;
    quantity?: number;
    donationDate?: Date;
    description?: string | null;
    isThankYouGenerated?: boolean;
    isPotentialMatchingGift?: boolean;
    isDonorAdvisedFund?: boolean;
    isStockGiftReceipt?: boolean;
    matching?: string | null;
    donationBatchNumber?: string | null;
    caseNumber?: string | null;
    transactionId?: string | null;
    donor?: DonorViewModel | null;
    details?: DonationDetailViewModel[] | null;

    constructor(data?: IDonationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
            this.donorId = _data["donorId"] !== undefined ? _data["donorId"] : <any>null;
            this.donationBatchId = _data["donationBatchId"] !== undefined ? _data["donationBatchId"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.donationDate = _data["donationDate"] ? new Date(_data["donationDate"].toString()) : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.isThankYouGenerated = _data["isThankYouGenerated"] !== undefined ? _data["isThankYouGenerated"] : <any>null;
            this.isPotentialMatchingGift = _data["isPotentialMatchingGift"] !== undefined ? _data["isPotentialMatchingGift"] : <any>null;
            this.isDonorAdvisedFund = _data["isDonorAdvisedFund"] !== undefined ? _data["isDonorAdvisedFund"] : <any>null;
            this.isStockGiftReceipt = _data["isStockGiftReceipt"] !== undefined ? _data["isStockGiftReceipt"] : <any>null;
            this.matching = _data["matching"] !== undefined ? _data["matching"] : <any>null;
            this.donationBatchNumber = _data["donationBatchNumber"] !== undefined ? _data["donationBatchNumber"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : <any>null;
            this.donor = _data["donor"] ? DonorViewModel.fromJS(_data["donor"]) : <any>null;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(DonationDetailViewModel.fromJS(item));
            }
            else {
                this.details = <any>null;
            }
        }
    }

    static fromJS(data: any): DonationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DonationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        data["donorId"] = this.donorId !== undefined ? this.donorId : <any>null;
        data["donationBatchId"] = this.donationBatchId !== undefined ? this.donationBatchId : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["donationDate"] = this.donationDate ? this.donationDate.toISOString() : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["isThankYouGenerated"] = this.isThankYouGenerated !== undefined ? this.isThankYouGenerated : <any>null;
        data["isPotentialMatchingGift"] = this.isPotentialMatchingGift !== undefined ? this.isPotentialMatchingGift : <any>null;
        data["isDonorAdvisedFund"] = this.isDonorAdvisedFund !== undefined ? this.isDonorAdvisedFund : <any>null;
        data["isStockGiftReceipt"] = this.isStockGiftReceipt !== undefined ? this.isStockGiftReceipt : <any>null;
        data["matching"] = this.matching !== undefined ? this.matching : <any>null;
        data["donationBatchNumber"] = this.donationBatchNumber !== undefined ? this.donationBatchNumber : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : <any>null;
        data["donor"] = this.donor ? this.donor.toJSON() : <any>null;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }

    clone(): DonationViewModel {
        const json = this.toJSON();
        let result = new DonationViewModel();
        result.init(json);
        return result;
    }
}

export interface IDonationViewModel {
    id?: number | null;
    campaignId?: number;
    donorId?: number;
    donationBatchId?: number;
    amount?: number;
    quantity?: number;
    donationDate?: Date;
    description?: string | null;
    isThankYouGenerated?: boolean;
    isPotentialMatchingGift?: boolean;
    isDonorAdvisedFund?: boolean;
    isStockGiftReceipt?: boolean;
    matching?: string | null;
    donationBatchNumber?: string | null;
    caseNumber?: string | null;
    transactionId?: string | null;
    donor?: DonorViewModel | null;
    details?: DonationDetailViewModel[] | null;
}

export class DonationDetailViewModel implements IDonationDetailViewModel {
    id?: number;
    caseId?: number | null;
    amount?: number;
    type?: DonationType;
    designationType?: DesignationCategoryType | null;
    designationSubType?: DesignationSubCategoryType | null;
    isCheckGenerated?: boolean;
    caseNumber?: string | null;
    case?: CaseViewModel | null;
    order?: number;

    constructor(data?: IDonationDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.designationType = _data["designationType"] !== undefined ? _data["designationType"] : <any>null;
            this.designationSubType = _data["designationSubType"] !== undefined ? _data["designationSubType"] : <any>null;
            this.isCheckGenerated = _data["isCheckGenerated"] !== undefined ? _data["isCheckGenerated"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.case = _data["case"] ? CaseViewModel.fromJS(_data["case"]) : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
        }
    }

    static fromJS(data: any): DonationDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DonationDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["designationType"] = this.designationType !== undefined ? this.designationType : <any>null;
        data["designationSubType"] = this.designationSubType !== undefined ? this.designationSubType : <any>null;
        data["isCheckGenerated"] = this.isCheckGenerated !== undefined ? this.isCheckGenerated : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        return data;
    }

    clone(): DonationDetailViewModel {
        const json = this.toJSON();
        let result = new DonationDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IDonationDetailViewModel {
    id?: number;
    caseId?: number | null;
    amount?: number;
    type?: DonationType;
    designationType?: DesignationCategoryType | null;
    designationSubType?: DesignationSubCategoryType | null;
    isCheckGenerated?: boolean;
    caseNumber?: string | null;
    case?: CaseViewModel | null;
    order?: number;
}

export class GetDonationBacthesResponse implements IGetDonationBacthesResponse {
    donationBatches?: DonationBatchViewModel[] | null;

    constructor(data?: IGetDonationBacthesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["donationBatches"])) {
                this.donationBatches = [] as any;
                for (let item of _data["donationBatches"])
                    this.donationBatches!.push(DonationBatchViewModel.fromJS(item));
            }
            else {
                this.donationBatches = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDonationBacthesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationBacthesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.donationBatches)) {
            data["donationBatches"] = [];
            for (let item of this.donationBatches)
                data["donationBatches"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetDonationBacthesResponse {
        const json = this.toJSON();
        let result = new GetDonationBacthesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDonationBacthesResponse {
    donationBatches?: DonationBatchViewModel[] | null;
}

export class GetDonationBatchesRequest implements IGetDonationBatchesRequest {
    from?: Date | null;
    to?: Date | null;

    constructor(data?: IGetDonationBatchesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetDonationBatchesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationBatchesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>null;
        data["to"] = this.to ? this.to.toISOString() : <any>null;
        return data;
    }

    clone(): GetDonationBatchesRequest {
        const json = this.toJSON();
        let result = new GetDonationBatchesRequest();
        result.init(json);
        return result;
    }
}

export interface IGetDonationBatchesRequest {
    from?: Date | null;
    to?: Date | null;
}

export class GetDonationBatchResponse implements IGetDonationBatchResponse {
    donationBatch?: DonationBatchViewModel | null;

    constructor(data?: IGetDonationBatchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.donationBatch = _data["donationBatch"] ? DonationBatchViewModel.fromJS(_data["donationBatch"]) : <any>null;
        }
    }

    static fromJS(data: any): GetDonationBatchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationBatchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donationBatch"] = this.donationBatch ? this.donationBatch.toJSON() : <any>null;
        return data;
    }

    clone(): GetDonationBatchResponse {
        const json = this.toJSON();
        let result = new GetDonationBatchResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDonationBatchResponse {
    donationBatch?: DonationBatchViewModel | null;
}

export class GetDonationBatchRequest implements IGetDonationBatchRequest {
    id?: number;
    batchNumber?: string | null;

    constructor(data?: IGetDonationBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.batchNumber = _data["batchNumber"] !== undefined ? _data["batchNumber"] : <any>null;
        }
    }

    static fromJS(data: any): GetDonationBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["batchNumber"] = this.batchNumber !== undefined ? this.batchNumber : <any>null;
        return data;
    }

    clone(): GetDonationBatchRequest {
        const json = this.toJSON();
        let result = new GetDonationBatchRequest();
        result.init(json);
        return result;
    }
}

export interface IGetDonationBatchRequest {
    id?: number;
    batchNumber?: string | null;
}

export class UpdateDonationBatchResponse implements IUpdateDonationBatchResponse {
    id?: number;
    batchNumber?: string | null;

    constructor(data?: IUpdateDonationBatchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.batchNumber = _data["batchNumber"] !== undefined ? _data["batchNumber"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateDonationBatchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDonationBatchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["batchNumber"] = this.batchNumber !== undefined ? this.batchNumber : <any>null;
        return data;
    }

    clone(): UpdateDonationBatchResponse {
        const json = this.toJSON();
        let result = new UpdateDonationBatchResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateDonationBatchResponse {
    id?: number;
    batchNumber?: string | null;
}

export class UpdateDonationBatchRequest implements IUpdateDonationBatchRequest {
    batchNumber?: string | null;
    id?: number;
    controlAmountTotal?: number;
    controlCountItems?: number;
    type?: DonationBatchType;
    status?: DonationStatusType;
    batchDate?: Date;
    batchId?: number;

    constructor(data?: IUpdateDonationBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchNumber = _data["batchNumber"] !== undefined ? _data["batchNumber"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.controlAmountTotal = _data["controlAmountTotal"] !== undefined ? _data["controlAmountTotal"] : <any>null;
            this.controlCountItems = _data["controlCountItems"] !== undefined ? _data["controlCountItems"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.batchDate = _data["batchDate"] ? new Date(_data["batchDate"].toString()) : <any>null;
            this.batchId = _data["batchId"] !== undefined ? _data["batchId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateDonationBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDonationBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchNumber"] = this.batchNumber !== undefined ? this.batchNumber : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["controlAmountTotal"] = this.controlAmountTotal !== undefined ? this.controlAmountTotal : <any>null;
        data["controlCountItems"] = this.controlCountItems !== undefined ? this.controlCountItems : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["batchDate"] = this.batchDate ? this.batchDate.toISOString() : <any>null;
        data["batchId"] = this.batchId !== undefined ? this.batchId : <any>null;
        return data;
    }

    clone(): UpdateDonationBatchRequest {
        const json = this.toJSON();
        let result = new UpdateDonationBatchRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateDonationBatchRequest {
    batchNumber?: string | null;
    id?: number;
    controlAmountTotal?: number;
    controlCountItems?: number;
    type?: DonationBatchType;
    status?: DonationStatusType;
    batchDate?: Date;
    batchId?: number;
}

export class GetDonationsExportResponse implements IGetDonationsExportResponse {
    donations?: DonationViewModel[] | null;

    constructor(data?: IGetDonationsExportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["donations"])) {
                this.donations = [] as any;
                for (let item of _data["donations"])
                    this.donations!.push(DonationViewModel.fromJS(item));
            }
            else {
                this.donations = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDonationsExportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationsExportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.donations)) {
            data["donations"] = [];
            for (let item of this.donations)
                data["donations"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetDonationsExportResponse {
        const json = this.toJSON();
        let result = new GetDonationsExportResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDonationsExportResponse {
    donations?: DonationViewModel[] | null;
}

export class AddDonationsResponse implements IAddDonationsResponse {
    id?: number;

    constructor(data?: IAddDonationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): AddDonationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddDonationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): AddDonationsResponse {
        const json = this.toJSON();
        let result = new AddDonationsResponse();
        result.init(json);
        return result;
    }
}

export interface IAddDonationsResponse {
    id?: number;
}

export class AddDonationsRequest implements IAddDonationsRequest {
    donationBatchId?: number;
    donationBatchNumber?: string | null;
    donation?: DonationViewModel | null;

    constructor(data?: IAddDonationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.donationBatchId = _data["donationBatchId"] !== undefined ? _data["donationBatchId"] : <any>null;
            this.donationBatchNumber = _data["donationBatchNumber"] !== undefined ? _data["donationBatchNumber"] : <any>null;
            this.donation = _data["donation"] ? DonationViewModel.fromJS(_data["donation"]) : <any>null;
        }
    }

    static fromJS(data: any): AddDonationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddDonationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donationBatchId"] = this.donationBatchId !== undefined ? this.donationBatchId : <any>null;
        data["donationBatchNumber"] = this.donationBatchNumber !== undefined ? this.donationBatchNumber : <any>null;
        data["donation"] = this.donation ? this.donation.toJSON() : <any>null;
        return data;
    }

    clone(): AddDonationsRequest {
        const json = this.toJSON();
        let result = new AddDonationsRequest();
        result.init(json);
        return result;
    }
}

export interface IAddDonationsRequest {
    donationBatchId?: number;
    donationBatchNumber?: string | null;
    donation?: DonationViewModel | null;
}

export class GetDonationsResponse implements IGetDonationsResponse {
    donations?: DonationViewModel[] | null;

    constructor(data?: IGetDonationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["donations"])) {
                this.donations = [] as any;
                for (let item of _data["donations"])
                    this.donations!.push(DonationViewModel.fromJS(item));
            }
            else {
                this.donations = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDonationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.donations)) {
            data["donations"] = [];
            for (let item of this.donations)
                data["donations"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetDonationsResponse {
        const json = this.toJSON();
        let result = new GetDonationsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDonationsResponse {
    donations?: DonationViewModel[] | null;
}

export class GetDonationsRequest implements IGetDonationsRequest {
    donationBatchId?: number;
    batchNumber?: string | null;

    constructor(data?: IGetDonationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.donationBatchId = _data["donationBatchId"] !== undefined ? _data["donationBatchId"] : <any>null;
            this.batchNumber = _data["batchNumber"] !== undefined ? _data["batchNumber"] : <any>null;
        }
    }

    static fromJS(data: any): GetDonationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donationBatchId"] = this.donationBatchId !== undefined ? this.donationBatchId : <any>null;
        data["batchNumber"] = this.batchNumber !== undefined ? this.batchNumber : <any>null;
        return data;
    }

    clone(): GetDonationsRequest {
        const json = this.toJSON();
        let result = new GetDonationsRequest();
        result.init(json);
        return result;
    }
}

export interface IGetDonationsRequest {
    donationBatchId?: number;
    batchNumber?: string | null;
}

export class GetDonationResponse implements IGetDonationResponse {
    donation?: DonationViewModel | null;

    constructor(data?: IGetDonationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.donation = _data["donation"] ? DonationViewModel.fromJS(_data["donation"]) : <any>null;
        }
    }

    static fromJS(data: any): GetDonationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donation"] = this.donation ? this.donation.toJSON() : <any>null;
        return data;
    }

    clone(): GetDonationResponse {
        const json = this.toJSON();
        let result = new GetDonationResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDonationResponse {
    donation?: DonationViewModel | null;
}

export class GetDonationRequest implements IGetDonationRequest {
    donationId?: number;

    constructor(data?: IGetDonationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.donationId = _data["donationId"] !== undefined ? _data["donationId"] : <any>null;
        }
    }

    static fromJS(data: any): GetDonationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donationId"] = this.donationId !== undefined ? this.donationId : <any>null;
        return data;
    }

    clone(): GetDonationRequest {
        const json = this.toJSON();
        let result = new GetDonationRequest();
        result.init(json);
        return result;
    }
}

export interface IGetDonationRequest {
    donationId?: number;
}

export class GetUnthankedDonationsCountResponse implements IGetUnthankedDonationsCountResponse {
    count?: number;

    constructor(data?: IGetUnthankedDonationsCountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): GetUnthankedDonationsCountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnthankedDonationsCountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data;
    }

    clone(): GetUnthankedDonationsCountResponse {
        const json = this.toJSON();
        let result = new GetUnthankedDonationsCountResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUnthankedDonationsCountResponse {
    count?: number;
}

export class UpdateDonationResponse implements IUpdateDonationResponse {
    id?: number;

    constructor(data?: IUpdateDonationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateDonationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDonationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): UpdateDonationResponse {
        const json = this.toJSON();
        let result = new UpdateDonationResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateDonationResponse {
    id?: number;
}

export class UpdateDonationRequest implements IUpdateDonationRequest {
    donation?: DonationViewModel | null;

    constructor(data?: IUpdateDonationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.donation = _data["donation"] ? DonationViewModel.fromJS(_data["donation"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateDonationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDonationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donation"] = this.donation ? this.donation.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateDonationRequest {
        const json = this.toJSON();
        let result = new UpdateDonationRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateDonationRequest {
    donation?: DonationViewModel | null;
}

export class UpdateDraftDonationResponse implements IUpdateDraftDonationResponse {
    id?: number;

    constructor(data?: IUpdateDraftDonationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateDraftDonationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDraftDonationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): UpdateDraftDonationResponse {
        const json = this.toJSON();
        let result = new UpdateDraftDonationResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateDraftDonationResponse {
    id?: number;
}

export class UpdateDraftDonationRequest implements IUpdateDraftDonationRequest {
    donation?: DraftDonationViewModel | null;

    constructor(data?: IUpdateDraftDonationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.donation = _data["donation"] ? DraftDonationViewModel.fromJS(_data["donation"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateDraftDonationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDraftDonationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donation"] = this.donation ? this.donation.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateDraftDonationRequest {
        const json = this.toJSON();
        let result = new UpdateDraftDonationRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateDraftDonationRequest {
    donation?: DraftDonationViewModel | null;
}

export class DraftDonationViewModel implements IDraftDonationViewModel {
    id?: number;
    campaignId?: number;
    donorId?: number | null;
    donationBatchId?: number;
    amount?: number;
    quantity?: number;
    donationDate?: Date | null;
    description?: string | null;
    isThankYouGenerated?: boolean;
    isPotentialMatchingGift?: boolean;
    isDonorAdvisedFund?: boolean;
    isStockGiftReceipt?: boolean;
    isCheckGenerated?: boolean;
    matching?: string | null;
    donationBatchNumber?: string | null;
    caseNumber?: string | null;
    donorEmail?: string | null;
    donorPhone?: string | null;
    donorName?: string | null;
    donorAddress1?: string | null;
    donorAddress2?: string | null;
    donorCity?: string | null;
    donorState?: string | null;
    donorZip?: string | null;
    hasMultipleDonorMatches?: boolean;
    transactionId?: string | null;
    errors?: string[] | null;
    donor?: DonorViewModel | null;
    details?: DraftDonationDetailViewModel[] | null;

    constructor(data?: IDraftDonationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
            this.donorId = _data["donorId"] !== undefined ? _data["donorId"] : <any>null;
            this.donationBatchId = _data["donationBatchId"] !== undefined ? _data["donationBatchId"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.donationDate = _data["donationDate"] ? new Date(_data["donationDate"].toString()) : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.isThankYouGenerated = _data["isThankYouGenerated"] !== undefined ? _data["isThankYouGenerated"] : <any>null;
            this.isPotentialMatchingGift = _data["isPotentialMatchingGift"] !== undefined ? _data["isPotentialMatchingGift"] : <any>null;
            this.isDonorAdvisedFund = _data["isDonorAdvisedFund"] !== undefined ? _data["isDonorAdvisedFund"] : <any>null;
            this.isStockGiftReceipt = _data["isStockGiftReceipt"] !== undefined ? _data["isStockGiftReceipt"] : <any>null;
            this.isCheckGenerated = _data["isCheckGenerated"] !== undefined ? _data["isCheckGenerated"] : <any>null;
            this.matching = _data["matching"] !== undefined ? _data["matching"] : <any>null;
            this.donationBatchNumber = _data["donationBatchNumber"] !== undefined ? _data["donationBatchNumber"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.donorEmail = _data["donorEmail"] !== undefined ? _data["donorEmail"] : <any>null;
            this.donorPhone = _data["donorPhone"] !== undefined ? _data["donorPhone"] : <any>null;
            this.donorName = _data["donorName"] !== undefined ? _data["donorName"] : <any>null;
            this.donorAddress1 = _data["donorAddress1"] !== undefined ? _data["donorAddress1"] : <any>null;
            this.donorAddress2 = _data["donorAddress2"] !== undefined ? _data["donorAddress2"] : <any>null;
            this.donorCity = _data["donorCity"] !== undefined ? _data["donorCity"] : <any>null;
            this.donorState = _data["donorState"] !== undefined ? _data["donorState"] : <any>null;
            this.donorZip = _data["donorZip"] !== undefined ? _data["donorZip"] : <any>null;
            this.hasMultipleDonorMatches = _data["hasMultipleDonorMatches"] !== undefined ? _data["hasMultipleDonorMatches"] : <any>null;
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : <any>null;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = <any>null;
            }
            this.donor = _data["donor"] ? DonorViewModel.fromJS(_data["donor"]) : <any>null;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(DraftDonationDetailViewModel.fromJS(item));
            }
            else {
                this.details = <any>null;
            }
        }
    }

    static fromJS(data: any): DraftDonationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DraftDonationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        data["donorId"] = this.donorId !== undefined ? this.donorId : <any>null;
        data["donationBatchId"] = this.donationBatchId !== undefined ? this.donationBatchId : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["donationDate"] = this.donationDate ? this.donationDate.toISOString() : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["isThankYouGenerated"] = this.isThankYouGenerated !== undefined ? this.isThankYouGenerated : <any>null;
        data["isPotentialMatchingGift"] = this.isPotentialMatchingGift !== undefined ? this.isPotentialMatchingGift : <any>null;
        data["isDonorAdvisedFund"] = this.isDonorAdvisedFund !== undefined ? this.isDonorAdvisedFund : <any>null;
        data["isStockGiftReceipt"] = this.isStockGiftReceipt !== undefined ? this.isStockGiftReceipt : <any>null;
        data["isCheckGenerated"] = this.isCheckGenerated !== undefined ? this.isCheckGenerated : <any>null;
        data["matching"] = this.matching !== undefined ? this.matching : <any>null;
        data["donationBatchNumber"] = this.donationBatchNumber !== undefined ? this.donationBatchNumber : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["donorEmail"] = this.donorEmail !== undefined ? this.donorEmail : <any>null;
        data["donorPhone"] = this.donorPhone !== undefined ? this.donorPhone : <any>null;
        data["donorName"] = this.donorName !== undefined ? this.donorName : <any>null;
        data["donorAddress1"] = this.donorAddress1 !== undefined ? this.donorAddress1 : <any>null;
        data["donorAddress2"] = this.donorAddress2 !== undefined ? this.donorAddress2 : <any>null;
        data["donorCity"] = this.donorCity !== undefined ? this.donorCity : <any>null;
        data["donorState"] = this.donorState !== undefined ? this.donorState : <any>null;
        data["donorZip"] = this.donorZip !== undefined ? this.donorZip : <any>null;
        data["hasMultipleDonorMatches"] = this.hasMultipleDonorMatches !== undefined ? this.hasMultipleDonorMatches : <any>null;
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : <any>null;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["donor"] = this.donor ? this.donor.toJSON() : <any>null;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }

    clone(): DraftDonationViewModel {
        const json = this.toJSON();
        let result = new DraftDonationViewModel();
        result.init(json);
        return result;
    }
}

export interface IDraftDonationViewModel {
    id?: number;
    campaignId?: number;
    donorId?: number | null;
    donationBatchId?: number;
    amount?: number;
    quantity?: number;
    donationDate?: Date | null;
    description?: string | null;
    isThankYouGenerated?: boolean;
    isPotentialMatchingGift?: boolean;
    isDonorAdvisedFund?: boolean;
    isStockGiftReceipt?: boolean;
    isCheckGenerated?: boolean;
    matching?: string | null;
    donationBatchNumber?: string | null;
    caseNumber?: string | null;
    donorEmail?: string | null;
    donorPhone?: string | null;
    donorName?: string | null;
    donorAddress1?: string | null;
    donorAddress2?: string | null;
    donorCity?: string | null;
    donorState?: string | null;
    donorZip?: string | null;
    hasMultipleDonorMatches?: boolean;
    transactionId?: string | null;
    errors?: string[] | null;
    donor?: DonorViewModel | null;
    details?: DraftDonationDetailViewModel[] | null;
}

export class DraftDonationDetailViewModel implements IDraftDonationDetailViewModel {
    id?: number;
    caseId?: number | null;
    amount?: number;
    type?: DonationType | null;
    designationType?: DesignationCategoryType | null;
    designationSubType?: DesignationSubCategoryType | null;
    caseNumber?: string | null;
    case?: CaseViewModel | null;
    order?: number;

    constructor(data?: IDraftDonationDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.designationType = _data["designationType"] !== undefined ? _data["designationType"] : <any>null;
            this.designationSubType = _data["designationSubType"] !== undefined ? _data["designationSubType"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.case = _data["case"] ? CaseViewModel.fromJS(_data["case"]) : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
        }
    }

    static fromJS(data: any): DraftDonationDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DraftDonationDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["designationType"] = this.designationType !== undefined ? this.designationType : <any>null;
        data["designationSubType"] = this.designationSubType !== undefined ? this.designationSubType : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        return data;
    }

    clone(): DraftDonationDetailViewModel {
        const json = this.toJSON();
        let result = new DraftDonationDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IDraftDonationDetailViewModel {
    id?: number;
    caseId?: number | null;
    amount?: number;
    type?: DonationType | null;
    designationType?: DesignationCategoryType | null;
    designationSubType?: DesignationSubCategoryType | null;
    caseNumber?: string | null;
    case?: CaseViewModel | null;
    order?: number;
}

export class RemoveDonationResponse implements IRemoveDonationResponse {
    batchNumber?: string | null;

    constructor(data?: IRemoveDonationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchNumber = _data["batchNumber"] !== undefined ? _data["batchNumber"] : <any>null;
        }
    }

    static fromJS(data: any): RemoveDonationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveDonationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchNumber"] = this.batchNumber !== undefined ? this.batchNumber : <any>null;
        return data;
    }

    clone(): RemoveDonationResponse {
        const json = this.toJSON();
        let result = new RemoveDonationResponse();
        result.init(json);
        return result;
    }
}

export interface IRemoveDonationResponse {
    batchNumber?: string | null;
}

export class RemoveDraftDonationResponse implements IRemoveDraftDonationResponse {

    constructor(data?: IRemoveDraftDonationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RemoveDraftDonationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveDraftDonationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): RemoveDraftDonationResponse {
        const json = this.toJSON();
        let result = new RemoveDraftDonationResponse();
        result.init(json);
        return result;
    }
}

export interface IRemoveDraftDonationResponse {
}

export class DonationsImportResponse implements IDonationsImportResponse {
    donations?: DonationImportViewModel[] | null;
    isValid?: boolean;

    constructor(data?: IDonationsImportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["donations"])) {
                this.donations = [] as any;
                for (let item of _data["donations"])
                    this.donations!.push(DonationImportViewModel.fromJS(item));
            }
            else {
                this.donations = <any>null;
            }
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : <any>null;
        }
    }

    static fromJS(data: any): DonationsImportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DonationsImportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.donations)) {
            data["donations"] = [];
            for (let item of this.donations)
                data["donations"].push(item.toJSON());
        }
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        return data;
    }

    clone(): DonationsImportResponse {
        const json = this.toJSON();
        let result = new DonationsImportResponse();
        result.init(json);
        return result;
    }
}

export interface IDonationsImportResponse {
    donations?: DonationImportViewModel[] | null;
    isValid?: boolean;
}

export class DonationImportViewModel implements IDonationImportViewModel {
    index?: number;
    isValid?: boolean;
    errors?: string[] | null;
    transactionId?: string | null;
    donorEmail?: string | null;
    donorName?: string | null;
    customerAddressLine1?: string | null;
    customerAddressLine2?: string | null;
    creditCardCity?: string | null;
    creditCardState?: string | null;
    creditCardZip?: string | null;
    donorPhone?: string | null;
    created?: Date | null;
    amount?: number;
    type?: DonationType;
    typeText?: string | null;
    caseNumber?: string | null;
    designationCategory?: DesignationCategoryType | null;
    designationCategoryText?: string | null;
    designationDetail?: DesignationSubCategoryType | null;
    designationDetailText?: string | null;
    anonymous?: boolean;
    isMatching?: boolean;
    matching?: string | null;
    isDonorAdvised?: boolean;
    description?: string | null;
    donor?: DonorViewModel | null;
    case?: CaseViewModel | null;

    constructor(data?: IDonationImportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : <any>null;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = <any>null;
            }
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : <any>null;
            this.donorEmail = _data["donorEmail"] !== undefined ? _data["donorEmail"] : <any>null;
            this.donorName = _data["donorName"] !== undefined ? _data["donorName"] : <any>null;
            this.customerAddressLine1 = _data["customerAddressLine1"] !== undefined ? _data["customerAddressLine1"] : <any>null;
            this.customerAddressLine2 = _data["customerAddressLine2"] !== undefined ? _data["customerAddressLine2"] : <any>null;
            this.creditCardCity = _data["creditCardCity"] !== undefined ? _data["creditCardCity"] : <any>null;
            this.creditCardState = _data["creditCardState"] !== undefined ? _data["creditCardState"] : <any>null;
            this.creditCardZip = _data["creditCardZip"] !== undefined ? _data["creditCardZip"] : <any>null;
            this.donorPhone = _data["donorPhone"] !== undefined ? _data["donorPhone"] : <any>null;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.typeText = _data["typeText"] !== undefined ? _data["typeText"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.designationCategory = _data["designationCategory"] !== undefined ? _data["designationCategory"] : <any>null;
            this.designationCategoryText = _data["designationCategoryText"] !== undefined ? _data["designationCategoryText"] : <any>null;
            this.designationDetail = _data["designationDetail"] !== undefined ? _data["designationDetail"] : <any>null;
            this.designationDetailText = _data["designationDetailText"] !== undefined ? _data["designationDetailText"] : <any>null;
            this.anonymous = _data["anonymous"] !== undefined ? _data["anonymous"] : <any>null;
            this.isMatching = _data["isMatching"] !== undefined ? _data["isMatching"] : <any>null;
            this.matching = _data["matching"] !== undefined ? _data["matching"] : <any>null;
            this.isDonorAdvised = _data["isDonorAdvised"] !== undefined ? _data["isDonorAdvised"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.donor = _data["donor"] ? DonorViewModel.fromJS(_data["donor"]) : <any>null;
            this.case = _data["case"] ? CaseViewModel.fromJS(_data["case"]) : <any>null;
        }
    }

    static fromJS(data: any): DonationImportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DonationImportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : <any>null;
        data["donorEmail"] = this.donorEmail !== undefined ? this.donorEmail : <any>null;
        data["donorName"] = this.donorName !== undefined ? this.donorName : <any>null;
        data["customerAddressLine1"] = this.customerAddressLine1 !== undefined ? this.customerAddressLine1 : <any>null;
        data["customerAddressLine2"] = this.customerAddressLine2 !== undefined ? this.customerAddressLine2 : <any>null;
        data["creditCardCity"] = this.creditCardCity !== undefined ? this.creditCardCity : <any>null;
        data["creditCardState"] = this.creditCardState !== undefined ? this.creditCardState : <any>null;
        data["creditCardZip"] = this.creditCardZip !== undefined ? this.creditCardZip : <any>null;
        data["donorPhone"] = this.donorPhone !== undefined ? this.donorPhone : <any>null;
        data["created"] = this.created ? this.created.toISOString() : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["typeText"] = this.typeText !== undefined ? this.typeText : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["designationCategory"] = this.designationCategory !== undefined ? this.designationCategory : <any>null;
        data["designationCategoryText"] = this.designationCategoryText !== undefined ? this.designationCategoryText : <any>null;
        data["designationDetail"] = this.designationDetail !== undefined ? this.designationDetail : <any>null;
        data["designationDetailText"] = this.designationDetailText !== undefined ? this.designationDetailText : <any>null;
        data["anonymous"] = this.anonymous !== undefined ? this.anonymous : <any>null;
        data["isMatching"] = this.isMatching !== undefined ? this.isMatching : <any>null;
        data["matching"] = this.matching !== undefined ? this.matching : <any>null;
        data["isDonorAdvised"] = this.isDonorAdvised !== undefined ? this.isDonorAdvised : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["donor"] = this.donor ? this.donor.toJSON() : <any>null;
        data["case"] = this.case ? this.case.toJSON() : <any>null;
        return data;
    }

    clone(): DonationImportViewModel {
        const json = this.toJSON();
        let result = new DonationImportViewModel();
        result.init(json);
        return result;
    }
}

export interface IDonationImportViewModel {
    index?: number;
    isValid?: boolean;
    errors?: string[] | null;
    transactionId?: string | null;
    donorEmail?: string | null;
    donorName?: string | null;
    customerAddressLine1?: string | null;
    customerAddressLine2?: string | null;
    creditCardCity?: string | null;
    creditCardState?: string | null;
    creditCardZip?: string | null;
    donorPhone?: string | null;
    created?: Date | null;
    amount?: number;
    type?: DonationType;
    typeText?: string | null;
    caseNumber?: string | null;
    designationCategory?: DesignationCategoryType | null;
    designationCategoryText?: string | null;
    designationDetail?: DesignationSubCategoryType | null;
    designationDetailText?: string | null;
    anonymous?: boolean;
    isMatching?: boolean;
    matching?: string | null;
    isDonorAdvised?: boolean;
    description?: string | null;
    donor?: DonorViewModel | null;
    case?: CaseViewModel | null;
}

export class DonationsImportRequest implements IDonationsImportRequest {
    donationBatchId?: number;
    isSubmissionRequest?: boolean;
    donations?: DonationImportViewModel[] | null;

    constructor(data?: IDonationsImportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.donationBatchId = _data["donationBatchId"] !== undefined ? _data["donationBatchId"] : <any>null;
            this.isSubmissionRequest = _data["isSubmissionRequest"] !== undefined ? _data["isSubmissionRequest"] : <any>null;
            if (Array.isArray(_data["donations"])) {
                this.donations = [] as any;
                for (let item of _data["donations"])
                    this.donations!.push(DonationImportViewModel.fromJS(item));
            }
            else {
                this.donations = <any>null;
            }
        }
    }

    static fromJS(data: any): DonationsImportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DonationsImportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donationBatchId"] = this.donationBatchId !== undefined ? this.donationBatchId : <any>null;
        data["isSubmissionRequest"] = this.isSubmissionRequest !== undefined ? this.isSubmissionRequest : <any>null;
        if (Array.isArray(this.donations)) {
            data["donations"] = [];
            for (let item of this.donations)
                data["donations"].push(item.toJSON());
        }
        return data;
    }

    clone(): DonationsImportRequest {
        const json = this.toJSON();
        let result = new DonationsImportRequest();
        result.init(json);
        return result;
    }
}

export interface IDonationsImportRequest {
    donationBatchId?: number;
    isSubmissionRequest?: boolean;
    donations?: DonationImportViewModel[] | null;
}

export class GetDraftDonationsResponse implements IGetDraftDonationsResponse {
    draftDonations?: DraftDonationViewModel[] | null;

    constructor(data?: IGetDraftDonationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["draftDonations"])) {
                this.draftDonations = [] as any;
                for (let item of _data["draftDonations"])
                    this.draftDonations!.push(DraftDonationViewModel.fromJS(item));
            }
            else {
                this.draftDonations = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDraftDonationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDraftDonationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.draftDonations)) {
            data["draftDonations"] = [];
            for (let item of this.draftDonations)
                data["draftDonations"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetDraftDonationsResponse {
        const json = this.toJSON();
        let result = new GetDraftDonationsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDraftDonationsResponse {
    draftDonations?: DraftDonationViewModel[] | null;
}

export class GetDraftDonationResponse implements IGetDraftDonationResponse {
    donation?: DraftDonationViewModel | null;

    constructor(data?: IGetDraftDonationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.donation = _data["donation"] ? DraftDonationViewModel.fromJS(_data["donation"]) : <any>null;
        }
    }

    static fromJS(data: any): GetDraftDonationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDraftDonationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donation"] = this.donation ? this.donation.toJSON() : <any>null;
        return data;
    }

    clone(): GetDraftDonationResponse {
        const json = this.toJSON();
        let result = new GetDraftDonationResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDraftDonationResponse {
    donation?: DraftDonationViewModel | null;
}

export class GetDraftDonationRequest implements IGetDraftDonationRequest {
    donationId?: number;

    constructor(data?: IGetDraftDonationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.donationId = _data["donationId"] !== undefined ? _data["donationId"] : <any>null;
        }
    }

    static fromJS(data: any): GetDraftDonationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDraftDonationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donationId"] = this.donationId !== undefined ? this.donationId : <any>null;
        return data;
    }

    clone(): GetDraftDonationRequest {
        const json = this.toJSON();
        let result = new GetDraftDonationRequest();
        result.init(json);
        return result;
    }
}

export interface IGetDraftDonationRequest {
    donationId?: number;
}

export class AddDraftDonationResponse implements IAddDraftDonationResponse {
    id?: number;

    constructor(data?: IAddDraftDonationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): AddDraftDonationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddDraftDonationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): AddDraftDonationResponse {
        const json = this.toJSON();
        let result = new AddDraftDonationResponse();
        result.init(json);
        return result;
    }
}

export interface IAddDraftDonationResponse {
    id?: number;
}

export class AddDraftDonationRequest implements IAddDraftDonationRequest {
    draftDonationId?: number;
    donationBatchId?: number;
    donationBatchNumber?: string | null;
    donation?: DonationViewModel | null;

    constructor(data?: IAddDraftDonationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draftDonationId = _data["draftDonationId"] !== undefined ? _data["draftDonationId"] : <any>null;
            this.donationBatchId = _data["donationBatchId"] !== undefined ? _data["donationBatchId"] : <any>null;
            this.donationBatchNumber = _data["donationBatchNumber"] !== undefined ? _data["donationBatchNumber"] : <any>null;
            this.donation = _data["donation"] ? DonationViewModel.fromJS(_data["donation"]) : <any>null;
        }
    }

    static fromJS(data: any): AddDraftDonationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddDraftDonationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draftDonationId"] = this.draftDonationId !== undefined ? this.draftDonationId : <any>null;
        data["donationBatchId"] = this.donationBatchId !== undefined ? this.donationBatchId : <any>null;
        data["donationBatchNumber"] = this.donationBatchNumber !== undefined ? this.donationBatchNumber : <any>null;
        data["donation"] = this.donation ? this.donation.toJSON() : <any>null;
        return data;
    }

    clone(): AddDraftDonationRequest {
        const json = this.toJSON();
        let result = new AddDraftDonationRequest();
        result.init(json);
        return result;
    }
}

export interface IAddDraftDonationRequest {
    draftDonationId?: number;
    donationBatchId?: number;
    donationBatchNumber?: string | null;
    donation?: DonationViewModel | null;
}

export class GetDonationHistoryResponse implements IGetDonationHistoryResponse {
    donations?: DonationHistoryViewModel[] | null;

    constructor(data?: IGetDonationHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["donations"])) {
                this.donations = [] as any;
                for (let item of _data["donations"])
                    this.donations!.push(DonationHistoryViewModel.fromJS(item));
            }
            else {
                this.donations = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDonationHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.donations)) {
            data["donations"] = [];
            for (let item of this.donations)
                data["donations"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetDonationHistoryResponse {
        const json = this.toJSON();
        let result = new GetDonationHistoryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDonationHistoryResponse {
    donations?: DonationHistoryViewModel[] | null;
}

export class DonationHistoryViewModel implements IDonationHistoryViewModel {
    type?: DonationHistoryType;
    donationId?: number;
    caseId?: number | null;
    caseNumber?: string | null;
    amount?: number;
    designation?: string | null;
    donationDate?: Date | null;
    donorName?: string | null;
    designationSubCategory?: DesignationSubCategoryType | null;
    isPaid?: boolean | null;
    paidDate?: Date | null;

    constructor(data?: IDonationHistoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.donationId = _data["donationId"] !== undefined ? _data["donationId"] : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.designation = _data["designation"] !== undefined ? _data["designation"] : <any>null;
            this.donationDate = _data["donationDate"] ? new Date(_data["donationDate"].toString()) : <any>null;
            this.donorName = _data["donorName"] !== undefined ? _data["donorName"] : <any>null;
            this.designationSubCategory = _data["designationSubCategory"] !== undefined ? _data["designationSubCategory"] : <any>null;
            this.isPaid = _data["isPaid"] !== undefined ? _data["isPaid"] : <any>null;
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DonationHistoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DonationHistoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["donationId"] = this.donationId !== undefined ? this.donationId : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["designation"] = this.designation !== undefined ? this.designation : <any>null;
        data["donationDate"] = this.donationDate ? this.donationDate.toISOString() : <any>null;
        data["donorName"] = this.donorName !== undefined ? this.donorName : <any>null;
        data["designationSubCategory"] = this.designationSubCategory !== undefined ? this.designationSubCategory : <any>null;
        data["isPaid"] = this.isPaid !== undefined ? this.isPaid : <any>null;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>null;
        return data;
    }

    clone(): DonationHistoryViewModel {
        const json = this.toJSON();
        let result = new DonationHistoryViewModel();
        result.init(json);
        return result;
    }
}

export interface IDonationHistoryViewModel {
    type?: DonationHistoryType;
    donationId?: number;
    caseId?: number | null;
    caseNumber?: string | null;
    amount?: number;
    designation?: string | null;
    donationDate?: Date | null;
    donorName?: string | null;
    designationSubCategory?: DesignationSubCategoryType | null;
    isPaid?: boolean | null;
    paidDate?: Date | null;
}

export enum DonationHistoryType {
    Donation = "Donation",
    Allocation = "Allocation",
}

export class GetDonationHistoryRequest implements IGetDonationHistoryRequest {
    donorId?: number | null;
    caseId?: number | null;
    caseIds?: (number | null)[] | null;

    constructor(data?: IGetDonationHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.donorId = _data["donorId"] !== undefined ? _data["donorId"] : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            if (Array.isArray(_data["caseIds"])) {
                this.caseIds = [] as any;
                for (let item of _data["caseIds"])
                    this.caseIds!.push(item);
            }
            else {
                this.caseIds = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDonationHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonationHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donorId"] = this.donorId !== undefined ? this.donorId : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        if (Array.isArray(this.caseIds)) {
            data["caseIds"] = [];
            for (let item of this.caseIds)
                data["caseIds"].push(item);
        }
        return data;
    }

    clone(): GetDonationHistoryRequest {
        const json = this.toJSON();
        let result = new GetDonationHistoryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetDonationHistoryRequest {
    donorId?: number | null;
    caseId?: number | null;
    caseIds?: (number | null)[] | null;
}

export class GetUnpaidDonationsCountResponse implements IGetUnpaidDonationsCountResponse {
    count?: number;

    constructor(data?: IGetUnpaidDonationsCountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): GetUnpaidDonationsCountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnpaidDonationsCountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data;
    }

    clone(): GetUnpaidDonationsCountResponse {
        const json = this.toJSON();
        let result = new GetUnpaidDonationsCountResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUnpaidDonationsCountResponse {
    count?: number;
}

export class GetDonorResponse implements IGetDonorResponse {
    donor?: DonorViewModel | null;

    constructor(data?: IGetDonorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.donor = _data["donor"] ? DonorViewModel.fromJS(_data["donor"]) : <any>null;
        }
    }

    static fromJS(data: any): GetDonorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donor"] = this.donor ? this.donor.toJSON() : <any>null;
        return data;
    }

    clone(): GetDonorResponse {
        const json = this.toJSON();
        let result = new GetDonorResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDonorResponse {
    donor?: DonorViewModel | null;
}

export class AddDonorResponse implements IAddDonorResponse {
    id?: number;
    donor?: DonorViewModel | null;

    constructor(data?: IAddDonorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.donor = _data["donor"] ? DonorViewModel.fromJS(_data["donor"]) : <any>null;
        }
    }

    static fromJS(data: any): AddDonorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddDonorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["donor"] = this.donor ? this.donor.toJSON() : <any>null;
        return data;
    }

    clone(): AddDonorResponse {
        const json = this.toJSON();
        let result = new AddDonorResponse();
        result.init(json);
        return result;
    }
}

export interface IAddDonorResponse {
    id?: number;
    donor?: DonorViewModel | null;
}

export class AddDonorRequest implements IAddDonorRequest {
    donor?: DonorViewModel | null;

    constructor(data?: IAddDonorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.donor = _data["donor"] ? DonorViewModel.fromJS(_data["donor"]) : <any>null;
        }
    }

    static fromJS(data: any): AddDonorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddDonorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donor"] = this.donor ? this.donor.toJSON() : <any>null;
        return data;
    }

    clone(): AddDonorRequest {
        const json = this.toJSON();
        let result = new AddDonorRequest();
        result.init(json);
        return result;
    }
}

export interface IAddDonorRequest {
    donor?: DonorViewModel | null;
}

export class DonorAdvancedSearchResponse implements IDonorAdvancedSearchResponse {
    donors?: DonorSearchResult[] | null;

    constructor(data?: IDonorAdvancedSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["donors"])) {
                this.donors = [] as any;
                for (let item of _data["donors"])
                    this.donors!.push(DonorSearchResult.fromJS(item));
            }
            else {
                this.donors = <any>null;
            }
        }
    }

    static fromJS(data: any): DonorAdvancedSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DonorAdvancedSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.donors)) {
            data["donors"] = [];
            for (let item of this.donors)
                data["donors"].push(item.toJSON());
        }
        return data;
    }

    clone(): DonorAdvancedSearchResponse {
        const json = this.toJSON();
        let result = new DonorAdvancedSearchResponse();
        result.init(json);
        return result;
    }
}

export interface IDonorAdvancedSearchResponse {
    donors?: DonorSearchResult[] | null;
}

export class DonorSearchResult implements IDonorSearchResult {
    id?: number;
    donorType?: DonorType;
    fullName?: string | null;
    organizationName?: string | null;
    prefix?: Prefix | null;
    suffix?: Suffix | null;
    year?: number | null;
    createdYear?: number;
    phone?: string | null;
    emailAddress?: string | null;

    constructor(data?: IDonorSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.donorType = _data["donorType"] !== undefined ? _data["donorType"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : <any>null;
            this.suffix = _data["suffix"] !== undefined ? _data["suffix"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.createdYear = _data["createdYear"] !== undefined ? _data["createdYear"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
        }
    }

    static fromJS(data: any): DonorSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new DonorSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["donorType"] = this.donorType !== undefined ? this.donorType : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["prefix"] = this.prefix !== undefined ? this.prefix : <any>null;
        data["suffix"] = this.suffix !== undefined ? this.suffix : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["createdYear"] = this.createdYear !== undefined ? this.createdYear : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        return data;
    }

    clone(): DonorSearchResult {
        const json = this.toJSON();
        let result = new DonorSearchResult();
        result.init(json);
        return result;
    }
}

export interface IDonorSearchResult {
    id?: number;
    donorType?: DonorType;
    fullName?: string | null;
    organizationName?: string | null;
    prefix?: Prefix | null;
    suffix?: Suffix | null;
    year?: number | null;
    createdYear?: number;
    phone?: string | null;
    emailAddress?: string | null;
}

export class DonorAdvancedSearchRequest implements IDonorAdvancedSearchRequest {
    firstName?: string | null;
    lastName?: string | null;
    organizationName?: string | null;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    limit?: number;

    constructor(data?: IDonorAdvancedSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
        }
    }

    static fromJS(data: any): DonorAdvancedSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DonorAdvancedSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        return data;
    }

    clone(): DonorAdvancedSearchRequest {
        const json = this.toJSON();
        let result = new DonorAdvancedSearchRequest();
        result.init(json);
        return result;
    }
}

export interface IDonorAdvancedSearchRequest {
    firstName?: string | null;
    lastName?: string | null;
    organizationName?: string | null;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    limit?: number;
}

export class UpdateDonorResponse implements IUpdateDonorResponse {
    id?: number;

    constructor(data?: IUpdateDonorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateDonorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDonorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): UpdateDonorResponse {
        const json = this.toJSON();
        let result = new UpdateDonorResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateDonorResponse {
    id?: number;
}

export class UpdateDonorRequest implements IUpdateDonorRequest {
    donor?: DonorViewModel | null;

    constructor(data?: IUpdateDonorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.donor = _data["donor"] ? DonorViewModel.fromJS(_data["donor"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateDonorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDonorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["donor"] = this.donor ? this.donor.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateDonorRequest {
        const json = this.toJSON();
        let result = new UpdateDonorRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateDonorRequest {
    donor?: DonorViewModel | null;
}

export class GetManyResponse implements IGetManyResponse {
    donors?: DonorViewModel[] | null;

    constructor(data?: IGetManyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["donors"])) {
                this.donors = [] as any;
                for (let item of _data["donors"])
                    this.donors!.push(DonorViewModel.fromJS(item));
            }
            else {
                this.donors = <any>null;
            }
        }
    }

    static fromJS(data: any): GetManyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.donors)) {
            data["donors"] = [];
            for (let item of this.donors)
                data["donors"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetManyResponse {
        const json = this.toJSON();
        let result = new GetManyResponse();
        result.init(json);
        return result;
    }
}

export interface IGetManyResponse {
    donors?: DonorViewModel[] | null;
}

export class ExportRequest implements IExportRequest {
    records?: any[] | null;

    constructor(data?: IExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(item);
            }
            else {
                this.records = <any>null;
            }
        }
    }

    static fromJS(data: any): ExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item);
        }
        return data;
    }

    clone(): ExportRequest {
        const json = this.toJSON();
        let result = new ExportRequest();
        result.init(json);
        return result;
    }
}

export interface IExportRequest {
    records?: any[] | null;
}

export class ExportCaseDetailsRequest implements IExportCaseDetailsRequest {
    caseIds?: number[] | null;

    constructor(data?: IExportCaseDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["caseIds"])) {
                this.caseIds = [] as any;
                for (let item of _data["caseIds"])
                    this.caseIds!.push(item);
            }
            else {
                this.caseIds = <any>null;
            }
        }
    }

    static fromJS(data: any): ExportCaseDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportCaseDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caseIds)) {
            data["caseIds"] = [];
            for (let item of this.caseIds)
                data["caseIds"].push(item);
        }
        return data;
    }

    clone(): ExportCaseDetailsRequest {
        const json = this.toJSON();
        let result = new ExportCaseDetailsRequest();
        result.init(json);
        return result;
    }
}

export interface IExportCaseDetailsRequest {
    caseIds?: number[] | null;
}

export class ExportDonationBatchesRequest implements IExportDonationBatchesRequest {
    batchIds?: number[] | null;

    constructor(data?: IExportDonationBatchesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["batchIds"])) {
                this.batchIds = [] as any;
                for (let item of _data["batchIds"])
                    this.batchIds!.push(item);
            }
            else {
                this.batchIds = <any>null;
            }
        }
    }

    static fromJS(data: any): ExportDonationBatchesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportDonationBatchesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.batchIds)) {
            data["batchIds"] = [];
            for (let item of this.batchIds)
                data["batchIds"].push(item);
        }
        return data;
    }

    clone(): ExportDonationBatchesRequest {
        const json = this.toJSON();
        let result = new ExportDonationBatchesRequest();
        result.init(json);
        return result;
    }
}

export interface IExportDonationBatchesRequest {
    batchIds?: number[] | null;
}

export class ExportDonorsRequest implements IExportDonorsRequest {
    donorIds?: number[] | null;

    constructor(data?: IExportDonorsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["donorIds"])) {
                this.donorIds = [] as any;
                for (let item of _data["donorIds"])
                    this.donorIds!.push(item);
            }
            else {
                this.donorIds = <any>null;
            }
        }
    }

    static fromJS(data: any): ExportDonorsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportDonorsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.donorIds)) {
            data["donorIds"] = [];
            for (let item of this.donorIds)
                data["donorIds"].push(item);
        }
        return data;
    }

    clone(): ExportDonorsRequest {
        const json = this.toJSON();
        let result = new ExportDonorsRequest();
        result.init(json);
        return result;
    }
}

export interface IExportDonorsRequest {
    donorIds?: number[] | null;
}

export class GetReportsResponse implements IGetReportsResponse {
    reports?: ReportViewModel[] | null;

    constructor(data?: IGetReportsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(ReportViewModel.fromJS(item));
            }
            else {
                this.reports = <any>null;
            }
        }
    }

    static fromJS(data: any): GetReportsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetReportsResponse {
        const json = this.toJSON();
        let result = new GetReportsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetReportsResponse {
    reports?: ReportViewModel[] | null;
}

export class ReportViewModel implements IReportViewModel {
    id?: number;
    type?: ReportType;
    fileName?: string | null;
    description?: string | null;
    created?: Date;
    recordCount?: number;

    constructor(data?: IReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>null;
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : <any>null;
        }
    }

    static fromJS(data: any): ReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["created"] = this.created ? this.created.toISOString() : <any>null;
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : <any>null;
        return data;
    }

    clone(): ReportViewModel {
        const json = this.toJSON();
        let result = new ReportViewModel();
        result.init(json);
        return result;
    }
}

export interface IReportViewModel {
    id?: number;
    type?: ReportType;
    fileName?: string | null;
    description?: string | null;
    created?: Date;
    recordCount?: number;
}

export enum ReportType {
    ThankYou = "ThankYou",
    BulkAgencyPayment = "BulkAgencyPayment",
}

export class GenerateBulkAgencyReportRequest implements IGenerateBulkAgencyReportRequest {
    agency?: number | null;
    type?: (DesignationCategoryType | null)[] | null;

    constructor(data?: IGenerateBulkAgencyReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agency = _data["agency"] !== undefined ? _data["agency"] : <any>null;
            if (Array.isArray(_data["type"])) {
                this.type = [] as any;
                for (let item of _data["type"])
                    this.type!.push(item);
            }
            else {
                this.type = <any>null;
            }
        }
    }

    static fromJS(data: any): GenerateBulkAgencyReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateBulkAgencyReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agency"] = this.agency !== undefined ? this.agency : <any>null;
        if (Array.isArray(this.type)) {
            data["type"] = [];
            for (let item of this.type)
                data["type"].push(item);
        }
        return data;
    }

    clone(): GenerateBulkAgencyReportRequest {
        const json = this.toJSON();
        let result = new GenerateBulkAgencyReportRequest();
        result.init(json);
        return result;
    }
}

export interface IGenerateBulkAgencyReportRequest {
    agency?: number | null;
    type?: (DesignationCategoryType | null)[] | null;
}

export class DeleteBulkAgencyReportResponse implements IDeleteBulkAgencyReportResponse {
    reportId?: number;

    constructor(data?: IDeleteBulkAgencyReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteBulkAgencyReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBulkAgencyReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        return data;
    }

    clone(): DeleteBulkAgencyReportResponse {
        const json = this.toJSON();
        let result = new DeleteBulkAgencyReportResponse();
        result.init(json);
        return result;
    }
}

export interface IDeleteBulkAgencyReportResponse {
    reportId?: number;
}

export class GenerateAdoptersReportRequest implements IGenerateAdoptersReportRequest {
    minCampaignYear?: number | null;
    maxCampaignYear?: number | null;
    excludeCurrentCampaign?: boolean;

    constructor(data?: IGenerateAdoptersReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minCampaignYear = _data["minCampaignYear"] !== undefined ? _data["minCampaignYear"] : <any>null;
            this.maxCampaignYear = _data["maxCampaignYear"] !== undefined ? _data["maxCampaignYear"] : <any>null;
            this.excludeCurrentCampaign = _data["excludeCurrentCampaign"] !== undefined ? _data["excludeCurrentCampaign"] : <any>null;
        }
    }

    static fromJS(data: any): GenerateAdoptersReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateAdoptersReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minCampaignYear"] = this.minCampaignYear !== undefined ? this.minCampaignYear : <any>null;
        data["maxCampaignYear"] = this.maxCampaignYear !== undefined ? this.maxCampaignYear : <any>null;
        data["excludeCurrentCampaign"] = this.excludeCurrentCampaign !== undefined ? this.excludeCurrentCampaign : <any>null;
        return data;
    }

    clone(): GenerateAdoptersReportRequest {
        const json = this.toJSON();
        let result = new GenerateAdoptersReportRequest();
        result.init(json);
        return result;
    }
}

export interface IGenerateAdoptersReportRequest {
    minCampaignYear?: number | null;
    maxCampaignYear?: number | null;
    excludeCurrentCampaign?: boolean;
}

export class AddUserResponse implements IAddUserResponse {
    id?: number;

    constructor(data?: IAddUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): AddUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): AddUserResponse {
        const json = this.toJSON();
        let result = new AddUserResponse();
        result.init(json);
        return result;
    }
}

export interface IAddUserResponse {
    id?: number;
}

export class AddUserRequest implements IAddUserRequest {
    user?: UserViewModel | null;

    constructor(data?: IAddUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserViewModel.fromJS(_data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): AddUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data;
    }

    clone(): AddUserRequest {
        const json = this.toJSON();
        let result = new AddUserRequest();
        result.init(json);
        return result;
    }
}

export interface IAddUserRequest {
    user?: UserViewModel | null;
}

export class GetUsersResponse implements IGetUsersResponse {
    users?: UserViewModel[] | null;

    constructor(data?: IGetUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserViewModel.fromJS(item));
            }
            else {
                this.users = <any>null;
            }
        }
    }

    static fromJS(data: any): GetUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetUsersResponse {
        const json = this.toJSON();
        let result = new GetUsersResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUsersResponse {
    users?: UserViewModel[] | null;
}

export class GetUserByIdResponse implements IGetUserByIdResponse {
    user?: UserViewModel | null;

    constructor(data?: IGetUserByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserViewModel.fromJS(_data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): GetUserByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data;
    }

    clone(): GetUserByIdResponse {
        const json = this.toJSON();
        let result = new GetUserByIdResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUserByIdResponse {
    user?: UserViewModel | null;
}

export class GetUserByAzureIdResponse implements IGetUserByAzureIdResponse {
    user?: UserViewModel | null;

    constructor(data?: IGetUserByAzureIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserViewModel.fromJS(_data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): GetUserByAzureIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserByAzureIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data;
    }

    clone(): GetUserByAzureIdResponse {
        const json = this.toJSON();
        let result = new GetUserByAzureIdResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUserByAzureIdResponse {
    user?: UserViewModel | null;
}

export class GetUserAgencyResponse implements IGetUserAgencyResponse {
    agencies?: AgencyViewModel[] | null;

    constructor(data?: IGetUserAgencyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["agencies"])) {
                this.agencies = [] as any;
                for (let item of _data["agencies"])
                    this.agencies!.push(AgencyViewModel.fromJS(item));
            }
            else {
                this.agencies = <any>null;
            }
        }
    }

    static fromJS(data: any): GetUserAgencyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserAgencyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agencies)) {
            data["agencies"] = [];
            for (let item of this.agencies)
                data["agencies"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetUserAgencyResponse {
        const json = this.toJSON();
        let result = new GetUserAgencyResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUserAgencyResponse {
    agencies?: AgencyViewModel[] | null;
}

export class GetUserAgencyRequest implements IGetUserAgencyRequest {
    roles?: string[] | null;
    azureId?: string | null;

    constructor(data?: IGetUserAgencyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
            this.azureId = _data["azureId"] !== undefined ? _data["azureId"] : <any>null;
        }
    }

    static fromJS(data: any): GetUserAgencyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserAgencyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["azureId"] = this.azureId !== undefined ? this.azureId : <any>null;
        return data;
    }

    clone(): GetUserAgencyRequest {
        const json = this.toJSON();
        let result = new GetUserAgencyRequest();
        result.init(json);
        return result;
    }
}

export interface IGetUserAgencyRequest {
    roles?: string[] | null;
    azureId?: string | null;
}

export class GetAccessibleUsersResponse implements IGetAccessibleUsersResponse {
    users?: UserViewModel[] | null;

    constructor(data?: IGetAccessibleUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserViewModel.fromJS(item));
            }
            else {
                this.users = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAccessibleUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccessibleUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAccessibleUsersResponse {
        const json = this.toJSON();
        let result = new GetAccessibleUsersResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAccessibleUsersResponse {
    users?: UserViewModel[] | null;
}

export class GetAccessibleUsersRequest implements IGetAccessibleUsersRequest {
    roles?: string[] | null;
    azureId?: string | null;

    constructor(data?: IGetAccessibleUsersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
            this.azureId = _data["azureId"] !== undefined ? _data["azureId"] : <any>null;
        }
    }

    static fromJS(data: any): GetAccessibleUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccessibleUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["azureId"] = this.azureId !== undefined ? this.azureId : <any>null;
        return data;
    }

    clone(): GetAccessibleUsersRequest {
        const json = this.toJSON();
        let result = new GetAccessibleUsersRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAccessibleUsersRequest {
    roles?: string[] | null;
    azureId?: string | null;
}

export class UpdateUserResponse implements IUpdateUserResponse {
    id?: number;

    constructor(data?: IUpdateUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): UpdateUserResponse {
        const json = this.toJSON();
        let result = new UpdateUserResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserResponse {
    id?: number;
}

export class UpdateUserRequest implements IUpdateUserRequest {
    user?: UserViewModel | null;

    constructor(data?: IUpdateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserViewModel.fromJS(_data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data;
    }

    clone(): UpdateUserRequest {
        const json = this.toJSON();
        let result = new UpdateUserRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserRequest {
    user?: UserViewModel | null;
}

export class DisableUserResponse implements IDisableUserResponse {
    id?: number;

    constructor(data?: IDisableUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DisableUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DisableUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): DisableUserResponse {
        const json = this.toJSON();
        let result = new DisableUserResponse();
        result.init(json);
        return result;
    }
}

export interface IDisableUserResponse {
    id?: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}